import * as React from 'react';
import React__default from 'react';

function _extends$3m() {
  _extends$3m = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends$3m.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b = "function" === typeof Symbol && Symbol.for,
    c = b ? Symbol.for("react.element") : 60103,
    d = b ? Symbol.for("react.portal") : 60106,
    e = b ? Symbol.for("react.fragment") : 60107,
    f = b ? Symbol.for("react.strict_mode") : 60108,
    g = b ? Symbol.for("react.profiler") : 60114,
    h = b ? Symbol.for("react.provider") : 60109,
    k = b ? Symbol.for("react.context") : 60110,
    l = b ? Symbol.for("react.async_mode") : 60111,
    m = b ? Symbol.for("react.concurrent_mode") : 60111,
    n = b ? Symbol.for("react.forward_ref") : 60112,
    p = b ? Symbol.for("react.suspense") : 60113,
    q = b ? Symbol.for("react.suspense_list") : 60120,
    r = b ? Symbol.for("react.memo") : 60115,
    t = b ? Symbol.for("react.lazy") : 60116,
    v = b ? Symbol.for("react.block") : 60121,
    w = b ? Symbol.for("react.fundamental") : 60117,
    x = b ? Symbol.for("react.responder") : 60118,
    y = b ? Symbol.for("react.scope") : 60119;

function z(a) {
  if ("object" === typeof a && null !== a) {
    var u = a.$$typeof;

    switch (u) {
      case c:
        switch (a = a.type, a) {
          case l:
          case m:
          case e:
          case g:
          case f:
          case p:
            return a;

          default:
            switch (a = a && a.$$typeof, a) {
              case k:
              case n:
              case t:
              case r:
              case h:
                return a;

              default:
                return u;
            }

        }

      case d:
        return u;
    }
  }
}

function A(a) {
  return z(a) === m;
}

var AsyncMode = l;
var ConcurrentMode = m;
var ContextConsumer = k;
var ContextProvider = h;
var Element = c;
var ForwardRef = n;
var Fragment = e;
var Lazy = t;
var Memo = r;
var Portal = d;
var Profiler = g;
var StrictMode = f;
var Suspense = p;

var isAsyncMode = function (a) {
  return A(a) || z(a) === l;
};

var isConcurrentMode = A;

var isContextConsumer = function (a) {
  return z(a) === k;
};

var isContextProvider = function (a) {
  return z(a) === h;
};

var isElement = function (a) {
  return "object" === typeof a && null !== a && a.$$typeof === c;
};

var isForwardRef = function (a) {
  return z(a) === n;
};

var isFragment = function (a) {
  return z(a) === e;
};

var isLazy = function (a) {
  return z(a) === t;
};

var isMemo = function (a) {
  return z(a) === r;
};

var isPortal = function (a) {
  return z(a) === d;
};

var isProfiler = function (a) {
  return z(a) === g;
};

var isStrictMode = function (a) {
  return z(a) === f;
};

var isSuspense = function (a) {
  return z(a) === p;
};

var isValidElementType = function (a) {
  return "string" === typeof a || "function" === typeof a || a === e || a === m || a === g || a === f || a === p || a === q || "object" === typeof a && null !== a && (a.$$typeof === t || a.$$typeof === r || a.$$typeof === h || a.$$typeof === k || a.$$typeof === n || a.$$typeof === w || a.$$typeof === x || a.$$typeof === y || a.$$typeof === v);
};

var typeOf = z;

var reactIs_production_min = {
	AsyncMode: AsyncMode,
	ConcurrentMode: ConcurrentMode,
	ContextConsumer: ContextConsumer,
	ContextProvider: ContextProvider,
	Element: Element,
	ForwardRef: ForwardRef,
	Fragment: Fragment,
	Lazy: Lazy,
	Memo: Memo,
	Portal: Portal,
	Profiler: Profiler,
	StrictMode: StrictMode,
	Suspense: Suspense,
	isAsyncMode: isAsyncMode,
	isConcurrentMode: isConcurrentMode,
	isContextConsumer: isContextConsumer,
	isContextProvider: isContextProvider,
	isElement: isElement,
	isForwardRef: isForwardRef,
	isFragment: isFragment,
	isLazy: isLazy,
	isMemo: isMemo,
	isPortal: isPortal,
	isProfiler: isProfiler,
	isStrictMode: isStrictMode,
	isSuspense: isSuspense,
	isValidElementType: isValidElementType,
	typeOf: typeOf
};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var reactIs_development = createCommonjsModule(function (module, exports) {

if (process.env.NODE_ENV !== "production") {
  (function () {
    // nor polyfill, then a plain number is used for performance.

    var hasSymbol = typeof Symbol === 'function' && Symbol.for;
    var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
    var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
    var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
    var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
    var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
    var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
    var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
    // (unstable) APIs that have been removed. Can we remove the symbols?

    var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
    var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
    var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
    var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
    var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
    var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
    var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
    var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
    var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
    var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
    var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

    function isValidElementType(type) {
      return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
    }

    function typeOf(object) {
      if (typeof object === 'object' && object !== null) {
        var $$typeof = object.$$typeof;

        switch ($$typeof) {
          case REACT_ELEMENT_TYPE:
            var type = object.type;

            switch (type) {
              case REACT_ASYNC_MODE_TYPE:
              case REACT_CONCURRENT_MODE_TYPE:
              case REACT_FRAGMENT_TYPE:
              case REACT_PROFILER_TYPE:
              case REACT_STRICT_MODE_TYPE:
              case REACT_SUSPENSE_TYPE:
                return type;

              default:
                var $$typeofType = type && type.$$typeof;

                switch ($$typeofType) {
                  case REACT_CONTEXT_TYPE:
                  case REACT_FORWARD_REF_TYPE:
                  case REACT_LAZY_TYPE:
                  case REACT_MEMO_TYPE:
                  case REACT_PROVIDER_TYPE:
                    return $$typeofType;

                  default:
                    return $$typeof;
                }

            }

          case REACT_PORTAL_TYPE:
            return $$typeof;
        }
      }

      return undefined;
    } // AsyncMode is deprecated along with isAsyncMode


    var AsyncMode = REACT_ASYNC_MODE_TYPE;
    var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
    var ContextConsumer = REACT_CONTEXT_TYPE;
    var ContextProvider = REACT_PROVIDER_TYPE;
    var Element = REACT_ELEMENT_TYPE;
    var ForwardRef = REACT_FORWARD_REF_TYPE;
    var Fragment = REACT_FRAGMENT_TYPE;
    var Lazy = REACT_LAZY_TYPE;
    var Memo = REACT_MEMO_TYPE;
    var Portal = REACT_PORTAL_TYPE;
    var Profiler = REACT_PROFILER_TYPE;
    var StrictMode = REACT_STRICT_MODE_TYPE;
    var Suspense = REACT_SUSPENSE_TYPE;
    var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

    function isAsyncMode(object) {
      {
        if (!hasWarnedAboutDeprecatedIsAsyncMode) {
          hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

          console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
        }
      }
      return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
    }

    function isConcurrentMode(object) {
      return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
    }

    function isContextConsumer(object) {
      return typeOf(object) === REACT_CONTEXT_TYPE;
    }

    function isContextProvider(object) {
      return typeOf(object) === REACT_PROVIDER_TYPE;
    }

    function isElement(object) {
      return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
    }

    function isForwardRef(object) {
      return typeOf(object) === REACT_FORWARD_REF_TYPE;
    }

    function isFragment(object) {
      return typeOf(object) === REACT_FRAGMENT_TYPE;
    }

    function isLazy(object) {
      return typeOf(object) === REACT_LAZY_TYPE;
    }

    function isMemo(object) {
      return typeOf(object) === REACT_MEMO_TYPE;
    }

    function isPortal(object) {
      return typeOf(object) === REACT_PORTAL_TYPE;
    }

    function isProfiler(object) {
      return typeOf(object) === REACT_PROFILER_TYPE;
    }

    function isStrictMode(object) {
      return typeOf(object) === REACT_STRICT_MODE_TYPE;
    }

    function isSuspense(object) {
      return typeOf(object) === REACT_SUSPENSE_TYPE;
    }

    exports.AsyncMode = AsyncMode;
    exports.ConcurrentMode = ConcurrentMode;
    exports.ContextConsumer = ContextConsumer;
    exports.ContextProvider = ContextProvider;
    exports.Element = Element;
    exports.ForwardRef = ForwardRef;
    exports.Fragment = Fragment;
    exports.Lazy = Lazy;
    exports.Memo = Memo;
    exports.Portal = Portal;
    exports.Profiler = Profiler;
    exports.StrictMode = StrictMode;
    exports.Suspense = Suspense;
    exports.isAsyncMode = isAsyncMode;
    exports.isConcurrentMode = isConcurrentMode;
    exports.isContextConsumer = isContextConsumer;
    exports.isContextProvider = isContextProvider;
    exports.isElement = isElement;
    exports.isForwardRef = isForwardRef;
    exports.isFragment = isFragment;
    exports.isLazy = isLazy;
    exports.isMemo = isMemo;
    exports.isPortal = isPortal;
    exports.isProfiler = isProfiler;
    exports.isStrictMode = isStrictMode;
    exports.isSuspense = isSuspense;
    exports.isValidElementType = isValidElementType;
    exports.typeOf = typeOf;
  })();
}
});

var reactIs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
  if (val === null || val === undefined) {
    throw new TypeError('Object.assign cannot be called with null or undefined');
  }

  return Object(val);
}

function shouldUseNative() {
  try {
    if (!Object.assign) {
      return false;
    } // Detect buggy property enumeration order in older V8 versions.
    // https://bugs.chromium.org/p/v8/issues/detail?id=4118


    var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

    test1[5] = 'de';

    if (Object.getOwnPropertyNames(test1)[0] === '5') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test2 = {};

    for (var i = 0; i < 10; i++) {
      test2['_' + String.fromCharCode(i)] = i;
    }

    var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
      return test2[n];
    });

    if (order2.join('') !== '0123456789') {
      return false;
    } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


    var test3 = {};
    'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
      test3[letter] = letter;
    });

    if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
      return false;
    }

    return true;
  } catch (err) {
    // We don't expect any of the above to throw, but better to be safe.
    return false;
  }
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  var from;
  var to = toObject(target);
  var symbols;

  for (var s = 1; s < arguments.length; s++) {
    from = Object(arguments[s]);

    for (var key in from) {
      if (hasOwnProperty.call(from, key)) {
        to[key] = from[key];
      }
    }

    if (getOwnPropertySymbols) {
      symbols = getOwnPropertySymbols(from);

      for (var i = 0; i < symbols.length; i++) {
        if (propIsEnumerable.call(from, symbols[i])) {
          to[symbols[i]] = from[symbols[i]];
        }
      }
    }
  }

  return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$2 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
var ReactPropTypesSecret_1 = ReactPropTypesSecret$2;

var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);

var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;

var has$1 = has$2;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var printWarning$1 = function () {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret = ReactPropTypesSecret$1;

  var loggedTypeFailures = {};

  var has = has$1;

  printWarning$1 = function (text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {
      /**/
    }
  };
}
/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */


function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error; // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.

        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error((componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' + 'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.');
            err.name = 'Invariant Violation';
            throw err;
          }

          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }

        if (error && !(error instanceof Error)) {
          printWarning$1((componentName || 'React class') + ': type specification of ' + location + ' `' + typeSpecName + '` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a ' + typeof error + '. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).');
        }

        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;
          var stack = getStack ? getStack() : '';
          printWarning$1('Failed ' + location + ' type: ' + error.message + (stack != null ? stack : ''));
        }
      }
    }
  }
}
/**
 * Resets warning cache when testing.
 *
 * @private
 */


checkPropTypes$1.resetWarningCache = function () {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes$1;

var checkPropTypes = checkPropTypes_1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */











var printWarning = function () {};

if (process.env.NODE_ENV !== 'production') {
  printWarning = function (text) {
    var message = 'Warning: ' + text;

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function (isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */

  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);

    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }
  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */


  var ANONYMOUS = '<<anonymous>>'; // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.

  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),
    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker
  };
  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */

  /*eslint-disable no-self-compare*/

  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */


  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data : {};
    this.stack = '';
  } // Make `instanceof Error` still work for returned errors.


  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }

    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use `PropTypes.checkPropTypes()` to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;

          if (!manualPropTypeCallCache[cacheKey] && // Avoid spamming the console because they are often not actionable except for lib authors
          manualPropTypeWarningCount < 3) {
            printWarning('You are manually calling a React.PropTypes validation ' + 'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' + 'and will throw in the standalone `prop-types` package. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.');
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }

      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }

          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }

        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'), {
          expectedType: expectedType
        });
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }

      var propValue = props[propName];

      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }

      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);

        if (error instanceof Error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      if (!reactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning('Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' + 'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).');
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }

      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];

      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);

        if (type === 'symbol') {
          return String(value);
        }

        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }

      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }

      for (var key in propValue) {
        if (has$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);

          if (error instanceof Error) {
            return error;
          }
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];

      if (typeof checker !== 'function') {
        printWarning('Invalid argument supplied to oneOfType. Expected an array of check functions, but ' + 'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.');
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];

      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1);

        if (checkerResult == null) {
          return null;
        }

        if (checkerResult.data && has$1(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }

      var expectedTypesMessage = expectedTypes.length > 0 ? ', expected one of type [' + expectedTypes.join(', ') + ']' : '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }

    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError((componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' + 'it must be a function, usually from the `prop-types` package, but received `' + type + '`.');
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }

      for (var key in shapeTypes) {
        var checker = shapeTypes[key];

        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);

      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      } // We need to check all keys in case some are required but missing from props.


      var allKeys = objectAssign({}, props[propName], shapeTypes);

      for (var key in allKeys) {
        var checker = shapeTypes[key];

        if (has$1(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }

        if (!checker) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
        }

        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);

        if (error) {
          return error;
        }
      }

      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;

      case 'boolean':
        return !propValue;

      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }

        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);

        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;

          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;

              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;

      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    } // falsy value can't be a Symbol


    if (!propValue) {
      return false;
    } // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'


    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    } // Fallback for non-spec compliant Symbols which are polyfilled.


    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  } // Equivalent of `typeof` but with special handling for array and regexp.


  function getPropType(propValue) {
    var propType = typeof propValue;

    if (Array.isArray(propValue)) {
      return 'array';
    }

    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }

    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }

    return propType;
  } // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.


  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }

    var propType = getPropType(propValue);

    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }

    return propType;
  } // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"


  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);

    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;

      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;

      default:
        return type;
    }
  } // Returns class name of the object, if any.


  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }

    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



function emptyFunction() {}

function emptyFunctionWithReset() {}

emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret$1) {
      // It is still safe when called from React.
      return;
    }

    var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
    err.name = 'Invariant Violation';
    throw err;
  }
  shim.isRequired = shim;

  function getShim() {
    return shim;
  }
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.

  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,
    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,
    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };
  ReactPropTypes.PropTypes = ReactPropTypes;
  return ReactPropTypes;
};

var require$$1 = factoryWithTypeCheckers;

var require$$2 = factoryWithThrowingShims;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var propTypes = createCommonjsModule(function (module) {
if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs; // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod


  var throwOnDirectAccess = true;
  module.exports = require$$1(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = require$$2();
}
});

var PropTypes = propTypes;

function _extends$3l() { _extends$3l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3l.apply(this, arguments); }

var _ref$3l = /*#__PURE__*/React.createElement("path", {
  d: "M38.5 1C42.084 1 45 3.916 45 7.5v33c0 3.584-2.916 6.5-6.5 6.5h-24A6.508 6.508 0 018 40.5v-33C8 3.916 10.916 1 14.5 1zm0 5h-24c-.827 0-1.5.673-1.5 1.5v33c0 .939.495 1.5 1.5 1.5h24c1.034 0 1.5-.534 1.5-1.5v-33c0-.827-.673-1.5-1.5-1.5zM7 31v5H2v-5h5zm23-5v5H18v-5h12zM7 21v5H2v-5h5zm28-5v5H18v-5h17zM7 11v5H2v-5h5z",
  fillRule: "evenodd"
});

function SvgAddressBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3l({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$3l);
}

function _extends$3k() { _extends$3k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3k.apply(this, arguments); }

var _ref$3k = /*#__PURE__*/React.createElement("path", {
  d: "M24 1c12.683 0 23 10.318 23 23 0 12.683-10.317 23-23 23C11.318 47 1 36.683 1 24 1 11.318 11.318 1 24 1zm0 32a3 3 0 100 6 3 3 0 000-6zm2.5-23h-5v20h5V10z",
  fillRule: "evenodd"
});

function SvgAlertCircleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3k({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$3k);
}

function _extends$3j() { _extends$3j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3j.apply(this, arguments); }

var _ref$3j = /*#__PURE__*/React.createElement("path", {
  d: "M24 1c12.683 0 23 10.318 23 23 0 12.683-10.317 23-23 23C11.318 47 1 36.683 1 24 1 11.318 11.318 1 24 1zm0 5C14.075 6 6 14.075 6 24s8.075 18 18 18 18-8.075 18-18S33.925 6 24 6zm0 27a3 3 0 110 6 3 3 0 010-6zm2.5-23v20h-5V10h5z",
  fillRule: "evenodd"
});

function SvgAlertCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3j({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$3j);
}

function _extends$3i() { _extends$3i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3i.apply(this, arguments); }

var _ref$3i = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24 47c12.703 0 23-10.297 23-23S36.703 1 24 1 1 11.297 1 24s10.297 23 23 23zm5.672-23.758a.85.85 0 01-.355.697c-.284.179-.638.268-.922.197-.603 0-1.206-.09-1.79-.268-.094-.032-.201-.05-.298-.065l-.04-.007c-.106 0-.16.09-.16.233v.357c-.017.09.018.179.054.25a.452.452 0 00.213.144c.638.25 1.312.375 1.986.357a2.962 2.962 0 001.862-.536c.46-.34.709-.876.691-1.43 0-.376-.124-.752-.355-1.038a2.966 2.966 0 00-1.099-.697l-1.046-.376a2.796 2.796 0 01-.834-.41.632.632 0 01-.212-.52c0-.554.425-.822 1.259-.822.478 0 .957.072 1.418.197a.83.83 0 00.302.071c.124 0 .177-.09.177-.232v-.34a.413.413 0 00-.07-.25.582.582 0 00-.231-.126 5.266 5.266 0 00-1.667-.286 2.721 2.721 0 00-1.738.501 1.623 1.623 0 00-.656 1.341c0 .823.479 1.43 1.454 1.77l1.117.412c.266.071.532.196.745.375a.737.737 0 01.195.5zm-5.94-4.918a.24.24 0 00-.196.269l-.053 4.9a3.271 3.271 0 01-1.844.625.975.975 0 01-.851-.34 1.63 1.63 0 01-.266-1.037v-4.22c-.018-.125-.124-.214-.249-.197h-.798a.24.24 0 00-.195.269v4.56a2.137 2.137 0 00.48 1.484c.372.357.886.554 1.4.518.904-.036 1.756-.34 2.447-.912l.089.465a.426.426 0 00.106.197.355.355 0 00.195.053h.585a.24.24 0 00.196-.268V18.521c-.018-.125-.124-.214-.249-.197h-.798zm-7.324 6.456a.238.238 0 00.266.196H17.453a.24.24 0 00.196-.268v-4.595a2.076 2.076 0 00-.479-1.449c-.372-.34-.869-.536-1.365-.5a4.376 4.376 0 00-2.554.93c-.301-.626-.833-.93-1.631-.93a4.212 4.212 0 00-2.412.858l-.07-.411a.428.428 0 00-.107-.197.356.356 0 00-.195-.054H8.198c-.125.036-.214.143-.196.268v6.169c0 .126.124.215.248.197h.833a.24.24 0 00.196-.268V19.79a3.329 3.329 0 011.88-.572.91.91 0 01.78.304c.195.286.266.625.248.965v4.309a.238.238 0 00.266.197h.833a.24.24 0 00.196-.268V19.79a3.598 3.598 0 011.897-.59.91.91 0 01.78.304c.195.286.266.626.249.965V24.78zm19.506-3.076c0-.805.16-1.395.479-1.752.319-.358.833-.555 1.49-.573.354 0 .726.054 1.063.161.071.018.142.036.213.036.106 0 .16-.071.16-.25v-.34a.43.43 0 00-.054-.268.46.46 0 00-.195-.125 3.835 3.835 0 00-1.347-.25 2.99 2.99 0 00-2.323.893c-.55.608-.816 1.43-.816 2.54 0 1.108.266 1.949.798 2.52.532.59 1.294.877 2.305.877.497.018.993-.072 1.454-.268a.452.452 0 00.213-.143.576.576 0 00.053-.25v-.34c0-.161-.053-.25-.16-.25a.592.592 0 00-.16.026l-.034.009a4.19 4.19 0 01-1.153.179c-.55.053-1.1-.161-1.507-.555-.32-.357-.48-.93-.48-1.716v-.161zm-2.554-2.807c-.017-.125-.124-.215-.248-.197h-.833a.223.223 0 00-.178.25v6.008c.018.126.124.215.249.197h.815a.222.222 0 00.195-.25v-6.008zm-.035-1.502a.925.925 0 000-1.18.905.905 0 00-1.17 0 .925.925 0 000 1.18.905.905 0 001.17 0zm.816 11.281c1.159-.136 3.726-.435 4.168.136.429.554-.47 2.852-.901 3.956l-.038.095c-.138.327.138.463.442.218 1.905-1.604 2.402-4.949 2.015-5.438-.386-.49-3.727-.898-5.77.543-.33.218-.275.517.084.49zm-25.948-.38c4.334 4.078 9.965 6.308 15.79 6.28 4.36 0 9.44-1.44 12.973-4.133.58-.435.083-1.114-.497-.843a30.863 30.863 0 01-12.063 2.556c-5.576.028-11.014-1.495-15.844-4.35-.387-.245-.69.19-.36.49z"
});

function SvgAmazonmusic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3i({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$3i);
}

function _extends$3h() { _extends$3h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3h.apply(this, arguments); }

var _ref$3h = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.921 1c-11.414.04-20.76 9.28-20.92 20.66-.119 9.22 5.787 17.11 14.04 20.006.199.079.398-.1.378-.298a79.644 79.644 0 00-.104-.714c-.07-.476-.142-.951-.195-1.427a.786.786 0 00-.417-.575C10.18 35.817 5.627 29.293 5.706 21.739c.1-9.913 8.213-17.983 18.136-18.062 10.161-.08 18.454 8.129 18.454 18.24 0 7.476-4.534 13.9-10.997 16.735a.673.673 0 00-.418.575l-.298 2.141c-.04.218.179.377.378.298C39.134 38.81 45 31.038 45 21.918 44.96 10.378 35.515.98 23.921 1zm.057 24.09a4.881 4.881 0 004.892-4.877c0-2.677-2.187-4.878-4.892-4.878a4.881 4.881 0 00-4.892 4.878 4.881 4.881 0 004.892 4.877zm4.318 3.53c.478.476.716.991.796 1.705.159 1.388.08 2.578-.1 4.501-.159 1.824-.457 4.243-.835 6.721-.278 1.765-.497 2.717-.696 3.39-.318 1.091-1.55 2.063-3.48 2.063-1.929 0-3.142-.952-3.48-2.062-.199-.674-.417-1.626-.696-3.39-.378-2.46-.676-4.898-.835-6.722l-.002-.02c-.158-1.912-.256-3.098-.097-4.48.08-.715.338-1.21.795-1.706.895-.952 2.466-1.547 4.315-1.547 1.85 0 3.42.615 4.315 1.547zM9.94 21.759c.1-7.416 6.065-13.542 13.502-13.82 7.994-.317 14.616 6.087 14.596 13.978 0 4.799-2.446 9.061-6.144 11.58-.2.138-.458-.02-.438-.239.04-.852.06-1.606.02-2.379 0-.258.1-.495.278-.674 2.208-2.082 3.6-5.016 3.6-8.268 0-6.384-5.33-11.579-11.812-11.321-5.966.238-10.758 5.076-10.917 11.024a11.321 11.321 0 003.599 8.565.807.807 0 01.278.674c-.04.793-.04 1.547.02 2.4 0 .217-.258.356-.437.237-3.759-2.557-6.205-6.88-6.145-11.757z"
});

function SvgApplepodcast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3h({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$3h);
}

function _extends$3g() { _extends$3g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3g.apply(this, arguments); }

var _ref$3g = /*#__PURE__*/React.createElement("path", {
  d: "M24 36.5a2.516 2.516 0 01-1.785-.739L1 14.568 4.571 11 24 30.409 43.429 11 47 14.568 25.785 35.761A2.516 2.516 0 0124 36.5",
  fillRule: "evenodd"
});

function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3g({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$3g);
}

function _extends$3f() { _extends$3f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3f.apply(this, arguments); }

var _ref$3f = /*#__PURE__*/React.createElement("path", {
  d: "M24 1c12.683 0 23 10.318 23 23 0 12.683-10.317 23-23 23C11.318 47 1 36.683 1 24 1 11.318 11.318 1 24 1zm-1.762 10.726L11.732 22.207a2.492 2.492 0 000 3.529l10.505 10.491 3.537-3.529-6.237-6.227H38v-4.99H19.533l6.24-6.226-3.535-3.529z",
  fillRule: "evenodd"
});

function SvgArrowLeftCircleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3f({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$3f);
}

function _extends$3e() { _extends$3e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3e.apply(this, arguments); }

var _ref$3e = /*#__PURE__*/React.createElement("path", {
  d: "M24 1c12.683 0 23 10.318 23 23 0 12.683-10.317 23-23 23C11.318 47 1 36.683 1 24 1 11.318 11.318 1 24 1zm0 5C14.075 6 6 14.075 6 24s8.075 18 18 18 18-8.075 18-18S33.925 6 24 6zm-1.762 5.726l3.535 3.529-6.24 6.226H38v4.99H19.537l6.237 6.227-3.537 3.529-10.506-10.491a2.492 2.492 0 01.001-3.529l10.506-10.481z",
  fillRule: "evenodd"
});

function SvgArrowLeftCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3e({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$3e);
}

function _extends$3d() { _extends$3d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3d.apply(this, arguments); }

var _ref$3d = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M9.43 20.346l6.836-6.816L12.725 10l-10.9 10.868a2.804 2.804 0 000 3.973l10.9 10.868 3.54-3.53-6.852-6.833h25.083a7.5 7.5 0 017.5 7.5v4.6h5v-4.6c0-6.903-5.597-12.5-12.5-12.5H9.43z"
});

function SvgArrowLeftReply(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$3d);
}

function _extends$3c() { _extends$3c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3c.apply(this, arguments); }

var _ref$3c = /*#__PURE__*/React.createElement("path", {
  d: "M11 24c0-.646.246-1.292.739-1.785L32.932 1 36.5 4.571 17.091 24 36.5 43.429 32.932 47 11.739 25.785A2.516 2.516 0 0111 24",
  fillRule: "evenodd"
});

function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3c({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$3c);
}

function _extends$3b() { _extends$3b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3b.apply(this, arguments); }

var _ref$3b = /*#__PURE__*/React.createElement("path", {
  d: "M24 1c12.683 0 23 10.318 23 23 0 12.683-10.317 23-23 23C11.318 47 1 36.683 1 24 1 11.318 11.318 1 24 1zm2.762 10.726l-3.535 3.529 6.24 6.226H11v4.99h18.463l-6.237 6.227 3.537 3.529 10.506-10.491a2.492 2.492 0 00-.001-3.529L26.762 11.726z",
  fillRule: "evenodd"
});

function SvgArrowRightCircleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3b({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$3b);
}

function _extends$3a() { _extends$3a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3a.apply(this, arguments); }

var _ref$3a = /*#__PURE__*/React.createElement("path", {
  d: "M24 1c12.683 0 23 10.318 23 23 0 12.683-10.317 23-23 23C11.318 47 1 36.683 1 24 1 11.318 11.318 1 24 1zm0 5C14.075 6 6 14.075 6 24s8.075 18 18 18 18-8.075 18-18S33.925 6 24 6zm2.762 5.726l10.506 10.481c.977.975.977 2.555 0 3.529L26.764 36.227l-3.537-3.529 6.237-6.227H11v-4.99h18.467l-6.24-6.226 3.535-3.529z",
  fillRule: "evenodd"
});

function SvgArrowRightCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3a({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$3a);
}

function _extends$39() { _extends$39 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$39.apply(this, arguments); }

var _ref$39 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M38.566 20.346L31.73 13.53 35.27 10l10.9 10.868a2.804 2.804 0 010 3.973L35.27 35.71l-3.54-3.53 6.852-6.833H13.5a7.5 7.5 0 00-7.5 7.5v4.6H1v-4.6c0-6.903 5.596-12.5 12.5-12.5h25.066z"
});

function SvgArrowRightReply(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$39({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$39);
}

function _extends$38() { _extends$38 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$38.apply(this, arguments); }

var _ref$38 = /*#__PURE__*/React.createElement("path", {
  d: "M37 24c0-.646-.246-1.292-.739-1.785L15.068 1 11.5 4.571 30.909 24 11.5 43.429 15.068 47l21.193-21.215A2.516 2.516 0 0037 24",
  fillRule: "evenodd"
});

function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$38({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$38);
}

function _extends$37() { _extends$37 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$37.apply(this, arguments); }

var _ref$37 = /*#__PURE__*/React.createElement("path", {
  d: "M24.25 47a2.49 2.49 0 01-1.766-.732L5 28.768l3.532-3.536 13.22 13.233V1h4.996v37.465l13.22-13.233 3.532 3.536-17.484 17.5A2.49 2.49 0 0124.25 47",
  fillRule: "evenodd"
});

function SvgArrowRoundedDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$37({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$37);
}

function _extends$36() { _extends$36 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$36.apply(this, arguments); }

var _ref$36 = /*#__PURE__*/React.createElement("path", {
  d: "M1 24.25c0-.639.244-1.278.732-1.766L19.232 5l3.536 3.532-13.233 13.22H47v4.996H9.535l13.233 13.22-3.536 3.532-17.5-17.484A2.49 2.49 0 011 24.25",
  fillRule: "evenodd"
});

function SvgArrowRoundedLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$36({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$36);
}

function _extends$35() { _extends$35 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$35.apply(this, arguments); }

var _ref$35 = /*#__PURE__*/React.createElement("path", {
  d: "M7.73 40.27A2.48 2.48 0 017 38.502l.011-24.72 4.993-.002-.008 18.692L38.469 6 42 9.53 15.526 36.004l18.692-.008-.002 4.992L9.495 41a2.487 2.487 0 01-1.765-.73",
  fillRule: "evenodd"
});

function SvgArrowRoundedLeftdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$35({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$35);
}

function _extends$34() { _extends$34 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$34.apply(this, arguments); }

var _ref$34 = /*#__PURE__*/React.createElement("path", {
  d: "M6.73 6.73A2.483 2.483 0 018.495 6l24.721.011.002 4.993-18.692-.008L41 37.469 37.469 41 10.996 14.526l.008 18.692-4.993-.002L6 8.495a2.483 2.483 0 01.73-1.765",
  fillRule: "evenodd"
});

function SvgArrowRoundedLeftup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$34({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$34);
}

function _extends$33() { _extends$33 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$33.apply(this, arguments); }

var _ref$33 = /*#__PURE__*/React.createElement("path", {
  d: "M47 24a2.49 2.49 0 01-.732 1.766l-17.5 17.484-3.536-3.532 13.233-13.22H1v-4.996h37.465L25.232 8.282l3.536-3.532 17.5 17.484A2.49 2.49 0 0147 24",
  fillRule: "evenodd"
});

function SvgArrowRoundedRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$33({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$33);
}

function _extends$32() { _extends$32 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$32.apply(this, arguments); }

var _ref$32 = /*#__PURE__*/React.createElement("path", {
  d: "M41.27 41.27a2.484 2.484 0 01-1.767.73l-24.72-.011-.002-4.993 18.692.008L7 10.53 10.53 7l26.474 26.474-.008-18.692 4.992.002.011 24.72c0 .69-.278 1.315-.73 1.766",
  fillRule: "evenodd"
});

function SvgArrowRoundedRightdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$32({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$32);
}

function _extends$31() { _extends$31 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$31.apply(this, arguments); }

var _ref$31 = /*#__PURE__*/React.createElement("path", {
  d: "M41.27 6.73c.451.452.73 1.076.73 1.765l-.011 24.721-4.993.002.008-18.692L10.53 41 7 37.469l26.474-26.473-18.692.008.002-4.993L39.504 6a2.48 2.48 0 011.766.73",
  fillRule: "evenodd"
});

function SvgArrowRoundedRightup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$31({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$31);
}

function _extends$30() { _extends$30 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$30.apply(this, arguments); }

var _ref$30 = /*#__PURE__*/React.createElement("path", {
  d: "M24 1a2.49 2.49 0 011.766.732l17.484 17.5-3.532 3.536-13.22-13.233V47h-4.996V9.535L8.282 22.768 4.75 19.232l17.484-17.5A2.49 2.49 0 0124 1",
  fillRule: "evenodd"
});

function SvgArrowRoundedUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$30({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$30);
}

function _extends$2$() { _extends$2$ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2$.apply(this, arguments); }

var _ref$2$ = /*#__PURE__*/React.createElement("path", {
  d: "M22.215 30.761L10 18.568 13.571 15 24 25.409 34.429 15 38 18.568 25.785 30.761A2.516 2.516 0 0124 31.5a2.516 2.516 0 01-1.785-.739z",
  fillRule: "evenodd"
});

function SvgArrowSmallDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2$({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2$);
}

function _extends$2_() { _extends$2_ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2_.apply(this, arguments); }

var _ref$2_ = /*#__PURE__*/React.createElement("path", {
  d: "M15.739 25.785L27.932 38l3.568-3.571L21.091 24 31.5 13.571 27.932 10 15.739 22.215A2.516 2.516 0 0015 24c0 .646.246 1.292.739 1.785z",
  fillRule: "evenodd"
});

function SvgArrowSmallLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2_({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2_);
}

function _extends$2Z() { _extends$2Z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2Z.apply(this, arguments); }

var _ref$2Z = /*#__PURE__*/React.createElement("path", {
  d: "M32.261 25.785L20.068 38 16.5 34.429 26.909 24 16.5 13.571 20.068 10l12.193 12.215c.493.493.739 1.139.739 1.785 0 .646-.246 1.292-.739 1.785z",
  fillRule: "evenodd"
});

function SvgArrowSmallRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2Z({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2Z);
}

function _extends$2Y() { _extends$2Y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2Y.apply(this, arguments); }

var _ref$2Y = /*#__PURE__*/React.createElement("path", {
  d: "M22.215 17.239L10 29.432 13.571 33 24 22.591 34.429 33 38 29.432 25.785 17.239A2.516 2.516 0 0024 16.5c-.646 0-1.292.246-1.785.739z",
  fillRule: "evenodd"
});

function SvgArrowSmallUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2Y({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2Y);
}

function _extends$2X() { _extends$2X = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2X.apply(this, arguments); }

var _ref$2X = /*#__PURE__*/React.createElement("path", {
  d: "M24 11.5c-.646 0-1.292.246-1.785.739L1 33.432 4.571 37 24 17.591 43.429 37 47 33.432 25.785 12.239A2.516 2.516 0 0024 11.5",
  fillRule: "evenodd"
});

function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2X({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2X);
}

function _extends$2W() { _extends$2W = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2W.apply(this, arguments); }

var _ref$2W = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M1.014 33.117a10.438 10.438 0 013.052-7.024L21.988 8.17a14.24 14.24 0 0112.458-3.969 14.256 14.256 0 0111.707 12.032 14.288 14.288 0 01-4.034 12.123L26.535 43.94 23 40.405l15.584-15.584a9.288 9.288 0 002.62-7.878 9.256 9.256 0 00-7.597-7.812 9.24 9.24 0 00-8.084 2.575L7.601 29.628a5.439 5.439 0 00-1.59 3.66l-.008.244a5.214 5.214 0 008.898 3.865l16.872-16.872c.138-.138.252-.313.325-.505.457-1.198-.72-2.236-1.744-1.857-.187.069-.357.178-.497.319l-14.39 14.39-3.536-3.536 14.39-14.39a6.383 6.383 0 012.298-1.473c5.23-1.935 10.07 3.295 8.151 8.328a6.452 6.452 0 01-1.461 2.26L18.437 40.933a10.214 10.214 0 01-6.711 2.979c-5.973.3-10.924-4.574-10.72-10.55l.008-.245z"
});

function SvgAttachment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2W({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2W);
}

function _extends$2V() { _extends$2V = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2V.apply(this, arguments); }

var _ref$2V = /*#__PURE__*/React.createElement("path", {
  d: "M34 7.204L16.757 18.98H9v10.022h7.757L34 40.778V7.204zm5 36.158A3.624 3.624 0 0135.383 47a3.585 3.585 0 01-2.088-.672L15.243 34.013H4V13.969h11.242L33.358 1.612c1.014-.724 2.423-.821 3.613-.207a3.733 3.733 0 012.03 3.326v38.631z",
  fillRule: "evenodd"
});

function SvgAudio(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2V({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2V);
}

function _extends$2U() { _extends$2U = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2U.apply(this, arguments); }

var _ref$2U = /*#__PURE__*/React.createElement("path", {
  d: "M24.933 47L3.739 25.785a2.526 2.526 0 010-3.57L24.933 1 28.5 4.571 9.09 24 28.5 43.429 24.933 47z"
});

var _ref2$i = /*#__PURE__*/React.createElement("path", {
  d: "M41.432 47L20.24 25.785a2.524 2.524 0 010-3.57L41.433 1 45 4.571 25.59 24 45 43.429 41.431 47z"
});

function SvgBackward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2U({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2U, _ref2$i);
}

function _extends$2T() { _extends$2T = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2T.apply(this, arguments); }

var _ref$2T = /*#__PURE__*/React.createElement("path", {
  d: "M24.933 1L28.5 4.571 9.09 24 28.5 43.429 24.933 47 3.739 25.785a2.524 2.524 0 010-3.57L24.933 1zm16.5 0l3.566 3.571L25.59 24 45 43.429 41.431 47 20.24 25.785a2.524 2.524 0 010-3.57L41.433 1z",
  fillRule: "evenodd"
});

function SvgBackwards(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2T({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2T);
}

function _extends$2S() { _extends$2S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2S.apply(this, arguments); }

var _ref$2S = /*#__PURE__*/React.createElement("path", {
  d: "M31.038 39.92l1.649 4.718a15.192 15.192 0 01-5.063.862 15.14 15.14 0 01-13.488-8.25H9v-5h3.612a14.914 14.914 0 01-.112-1.75c0-.593.044-1.175.112-1.75H9v-5h5.136a15.14 15.14 0 0113.488-8.25c1.759 0 3.484.297 5.126.884l-1.669 4.71a10.253 10.253 0 00-3.457-.594 10.176 10.176 0 00-7.464 3.25H26v5h-8.356a9.843 9.843 0 00-.166 1.75c0 .598.063 1.18.166 1.75H26v5h-5.84a10.176 10.176 0 007.464 3.25c1.174 0 2.323-.195 3.414-.58zM47.5 15.704L25.842 2.52a3.526 3.526 0 00-3.683-.002L.5 15.704 3.126 20 24 7.292 44.874 20l2.626-4.296z"
});

function SvgBank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2S({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2S);
}

function _extends$2R() { _extends$2R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2R.apply(this, arguments); }

var _ref$2R = /*#__PURE__*/React.createElement("path", {
  d: "M21.949 23.5c2.84 0 5.74.361 8.618 1.074l-1.207 4.853a30.83 30.83 0 00-7.411-.928c-4.934 0-9.968 1.254-14.992 3.731 2.382 5.917 8.18 9.771 14.992 9.771 2.462 0 4.809-.499 6.977-1.482L31 45.068C28.176 46.351 25.13 47 21.949 47c-9.816 0-18.036-6.176-20.454-15.367L1 29.754l1.704-.942C9.083 25.287 15.558 23.5 21.949 23.5zM42 27v5h5v5h-5v5h-5v-5h-5v-5h5v-5h5zM22 1c4.963 0 9 4.038 9 9s-4.037 9-9 9c-4.962 0-9-4.038-9-9s4.038-9 9-9zm0 5c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4z",
  fillRule: "evenodd"
});

function SvgBecomeMember(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2R({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2R);
}

function _extends$2Q() { _extends$2Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2Q.apply(this, arguments); }

var _ref$2Q = /*#__PURE__*/React.createElement("path", {
  d: "M9.221 33l3.814-6.09 2.01-11.539.025-.18C15.621 9.694 19.31 6 24.25 6c4.94 0 8.63 3.694 9.18 9.192l2.034 11.718L39.28 33H9.221zm15.03 9a5.019 5.019 0 01-4.913-4h9.823a5.018 5.018 0 01-4.91 4zm20.716-9.354l-4.732-7.556-1.827-10.489C37.564 6.588 31.754 1 24.25 1c-7.505 0-13.315 5.588-14.158 13.601L8.264 25.09l-4.73 7.556a3.49 3.49 0 00-.094 3.551A3.512 3.512 0 006.51 38h7.765c.505 5.046 4.785 9 9.975 9 5.19 0 9.47-3.954 9.975-9h7.766a3.512 3.512 0 003.07-1.803 3.492 3.492 0 00-.094-3.551z"
});

function SvgBell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2Q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2Q);
}

function _extends$2P() { _extends$2P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2P.apply(this, arguments); }

var _ref$2P = /*#__PURE__*/React.createElement("path", {
  d: "M24 1c12.683 0 23 10.318 23 23 0 12.683-10.317 23-23 23C11.318 47 1 36.683 1 24 1 11.318 11.318 1 24 1zm14.395 12.205l-25.19 25.19A17.907 17.907 0 0024 42c9.925 0 18-8.075 18-18 0-4.046-1.342-7.785-3.605-10.795zM24 6C14.075 6 6 14.075 6 24c0 4.047 1.342 7.786 3.605 10.796l25.19-25.191A17.907 17.907 0 0024 6z"
});

function SvgBlocked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2P({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2P);
}

function _extends$2O() { _extends$2O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2O.apply(this, arguments); }

var _ref$2O = /*#__PURE__*/React.createElement("path", {
  d: "M13.517 47a3.544 3.544 0 01-1.604-.386A3.485 3.485 0 0110 43.494V1h28v42.494c0 1.324-.733 2.52-1.913 3.12a3.487 3.487 0 01-3.647-.291l-8.471-5.794-8.462 5.832a3.374 3.374 0 01-1.99.639z",
  fillRule: "evenodd"
});

function SvgBookmarkFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2O({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2O);
}

function _extends$2N() { _extends$2N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2N.apply(this, arguments); }

var _ref$2N = /*#__PURE__*/React.createElement("path", {
  d: "M23.958 34.463L33 40.65V6H15v34.64l8.958-6.177zM13.517 47a3.544 3.544 0 01-1.604-.386A3.485 3.485 0 0110 43.494V1h28v42.494c0 1.324-.733 2.52-1.913 3.12a3.487 3.487 0 01-3.647-.291l-8.471-5.794-8.462 5.832a3.374 3.374 0 01-1.99.639z",
  fillRule: "evenodd"
});

function SvgBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2N({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2N);
}

function _extends$2M() { _extends$2M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2M.apply(this, arguments); }

var _ref$2M = /*#__PURE__*/React.createElement("path", {
  d: "M13 1v4.99H6v34.65l9-6.25 9 6.25v-8.7h5v11.565a3.46 3.46 0 01-.627 1.994 3.468 3.468 0 01-2.254 1.445 3.481 3.481 0 01-2.616-.57L15 40.47l-8.501 5.902A3.501 3.501 0 011 43.505V1h12zm34 20v5H19v-5h28zm0-10v5H19v-5h28zM19.001 1L47 1.004v5L19 6l.001-5z",
  fillRule: "evenodd"
});

function SvgBookmarksList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2M({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2M);
}

function _extends$2L() { _extends$2L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2L.apply(this, arguments); }

var _ref$2L = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M1 3h46V17.625h-3.418c.031.23.048.466.048.706v22.248c0 2.837-2.3 5.137-5.138 5.137H9.508a5.137 5.137 0 01-5.138-5.137V18.33c0-.24.017-.475.048-.706H1V3zm40.975 5.025H6.025V12.6H41.975V8.025zM9.508 18.218a.112.112 0 00-.113.113v22.248c0 .062.05.112.113.112h28.984c.062 0 .113-.05.113-.112V18.33a.112.112 0 00-.113-.113H9.508zm8.872 4.809a2.513 2.513 0 100 5.025H29.62a2.513 2.513 0 000-5.025H18.38z"
});

function SvgBoxMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2L({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2L);
}

function _extends$2K() { _extends$2K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2K.apply(this, arguments); }

var _ref$2K = /*#__PURE__*/React.createElement("path", {
  d: "M7.353 15.9c-.794 0-1.468.276-2.022.83a2.712 2.712 0 00-.831 1.99v11.886c0 .794.277 1.466.83 2.019.555.553 1.229.83 2.023.83.793 0 1.463-.277 2.008-.83.545-.553.817-1.225.817-2.019V18.72c0-.775-.277-1.438-.83-1.99a2.724 2.724 0 00-1.995-.83zM30.288 5.23l1.967-3.622c.129-.24.083-.423-.139-.552-.24-.112-.425-.055-.554.165l-1.994 3.65a13.64 13.64 0 00-5.567-1.162c-1.958 0-3.814.388-5.568 1.162l-1.994-3.65c-.13-.22-.315-.276-.554-.165-.222.13-.268.313-.138.552l1.966 3.621c-1.994 1.015-3.582 2.429-4.764 4.244a10.703 10.703 0 00-1.773 5.958h25.621c0-2.157-.591-4.141-1.773-5.958-1.182-1.815-2.76-3.229-4.736-4.244zm-11.37 5.266a1.04 1.04 0 01-.762.318.992.992 0 01-.748-.318 1.058 1.058 0 01-.305-.76c0-.295.102-.548.305-.76a.996.996 0 01.748-.318c.295 0 .549.106.761.318.213.213.32.465.32.76-.001.295-.108.548-.32.76zm11.674 0a.994.994 0 01-.747.318c-.296 0-.55-.106-.762-.318a1.033 1.033 0 01-.32-.76c0-.295.107-.548.32-.76a1.04 1.04 0 01.762-.318c.295 0 .544.106.747.318.203.213.305.465.305.76s-.102.548-.305.76zm-19.306 24.34c0 .849.295 1.567.886 2.156.591.59 1.31.885 2.16.885h2.05l.029 6.275c0 .793.276 1.466.83 2.019.554.553 1.22.829 1.995.829.793 0 1.467-.276 2.021-.83.554-.552.831-1.225.831-2.018v-6.275h3.823v6.275c0 .793.277 1.466.83 2.019.554.553 1.228.829 2.022.829.794 0 1.468-.276 2.022-.83.554-.552.831-1.225.831-2.018v-6.275h2.077c.831 0 1.542-.295 2.134-.884.59-.59.886-1.308.886-2.156V16.425H11.286v18.411zM40.647 15.9c-.775 0-1.44.272-1.994.816-.554.544-.83 1.212-.83 2.004v11.886c0 .794.276 1.466.83 2.019.554.553 1.219.83 1.994.83.794 0 1.468-.277 2.022-.83.554-.553.831-1.225.831-2.019V18.72c0-.792-.277-1.46-.83-2.004-.555-.544-1.229-.816-2.023-.816z"
});

function SvgBrandAndroid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2K({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2K);
}

function _extends$2J() { _extends$2J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2J.apply(this, arguments); }

var _ref$2J = /*#__PURE__*/React.createElement("path", {
  d: "M24.348 14.31c2.783 0 7.081-5.312 14.95 0 .968.653 1.707 1.4 2.27 2.22-3.727 2.928-5.051 5.33-5.051 9.397 0 4.187 3.7 8.029 6.081 8.56C41.956 38.153 37.078 47 32.59 47c-2.784 0-5.247-1.885-7.99-1.885C21.756 45.115 20.34 47 17.1 47c-3.38 0-8.292-6.915-10.072-12.513a30.841 30.841 0 00-.337-.99l-.231-.65c-.346-.98-.677-2.004-.863-3.347-.743-5.365.507-12.339 5.395-15.45 6.915-4.4 10.573.26 13.355.26zM33.174 1c0 10.248-8.334 10.6-9.11 10.611h-.057S23.19 2.304 33.174 1z",
  fillRule: "evenodd"
});

function SvgBrandApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2J({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2J);
}

function _extends$2I() { _extends$2I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2I.apply(this, arguments); }

var _ref$2I = /*#__PURE__*/React.createElement("path", {
  d: "M2 8.23l17.982-2.442.007 17.292-17.973.102L2 8.23zm17.973 16.842l.014 17.306-17.973-2.464-.001-14.958 17.96.116zm2.18-19.603L45.995 2v20.86l-23.842.188V5.47zM46 25.234L45.994 46l-23.841-3.355-.034-17.45 23.881.04z"
});

function SvgBrandWindows(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2I({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2I);
}

function _extends$2H() { _extends$2H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2H.apply(this, arguments); }

var _ref$2H = /*#__PURE__*/React.createElement("path", {
  d: "M34.907 27.252c.57-4.852-.966-9.81-4.633-13.517a17.091 17.091 0 00-3.107-2.465c1.624-1.463 3.67-2.272 5.826-2.273h.001c2.33 0 4.54.935 6.22 2.632 2.136 2.158 2.8 4.508 2.786 15.749-2.896.007-5.203-.022-7.093-.126m-8.683 6.971C23.275 37.203 20.76 38.054 6 37.996c-.046-14.811.802-17.726 3.79-20.745 2.265-2.288 5.272-3.547 8.468-3.547h.002c3.194 0 6.2 1.26 8.462 3.547 4.57 4.618 4.35 12.072-.498 16.972m16.538-26.11C40.137 5.46 36.67 4 32.994 4h-.002c-3.674.001-7.143 1.461-9.763 4.11-.22.223-.58.582-1.067 1.069a16.892 16.892 0 00-3.902-.472h-.002c-4.539 0-8.808 1.786-12.018 5.028C1.473 18.549.874 23.475 1.018 40.5l.021 2.453 2.454.024c1.58.014 3.054.023 4.43.023 13.145 0 17.461-.824 21.851-5.262a18.34 18.34 0 003.786-5.561c1.94.147 4.271.2 7.245.2 1.136 0 2.367-.007 3.704-.02l2.454-.022.02-2.455c.11-12.858-.21-17.718-4.22-21.767"
});

function SvgBubbleLines(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2H({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2H);
}

function _extends$2G() { _extends$2G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2G.apply(this, arguments); }

var _ref$2G = /*#__PURE__*/React.createElement("path", {
  d: "M18 18.493c-.668 0-1.19.233-1.748.782-.513.504-.753 1.049-.753 1.715 0 .666.24 1.21.753 1.713L24 30.44l7.732-7.722a2.61 2.61 0 00.768-1.79c.013-.553-.108-1.021-.752-1.653-.552-.542-1.09-.783-1.748-.783-.814 0-1.8.343-2.248.782L24 23.023l-3.768-3.763c-.43-.424-1.419-.767-2.232-.767zM24 37.5L12.73 26.249c-1.454-1.427-2.232-3.252-2.232-5.26 0-2.007.778-3.832 2.248-5.275C14.243 14.244 16.01 13.5 18 13.5c2.157 0 4.361.848 5.752 2.214l.248.247.232-.232c1.406-1.381 3.61-2.23 5.768-2.23 1.988 0 3.755.746 5.252 2.215 1.541 1.512 2.297 3.308 2.246 5.338a7.618 7.618 0 01-2.246 5.213L24 37.5z"
});

var _ref2$h = /*#__PURE__*/React.createElement("path", {
  d: "M6.014 41.986c21.672.147 26.168-.704 30.752-5.284C40.142 33.332 42 28.812 42 23.98s-1.86-9.35-5.234-12.725c-7.02-7.014-18.442-7.013-25.466.001-4.567 4.562-5.417 9.052-5.286 30.731M10.18 47c-2.063 0-4.28-.014-6.672-.036l-2.455-.023-.022-2.454c-.204-23.756.429-30.47 6.734-36.766 8.973-8.962 23.568-8.962 32.537 0C44.62 12.038 46.999 17.812 47 23.98c0 6.168-2.38 11.942-6.698 16.257C34.616 45.917 28.609 47 10.18 47"
});

function SvgBubbleStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2G({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2G, _ref2$h);
}

function _extends$2F() { _extends$2F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2F.apply(this, arguments); }

var _ref$2F = /*#__PURE__*/React.createElement("path", {
  d: "M42 28.576L35.736 24 42 19.423v9.153zM6 35h23V13H6v22zm39.085-21.652a3.486 3.486 0 00-3.649.295L34 19.076V12.5c0-2.482-2.019-4.5-4.5-4.5h-24A4.505 4.505 0 001 12.5v23C1 37.981 3.019 40 5.5 40h24c2.481 0 4.5-2.019 4.5-4.5v-6.576l7.434 5.43a3.475 3.475 0 003.649.298A3.482 3.482 0 0047 31.531V16.469c0-1.325-.734-2.52-1.915-3.121z",
  fillRule: "evenodd"
});

function SvgBubbleVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2F({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2F);
}

function _extends$2E() { _extends$2E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2E.apply(this, arguments); }

var _ref$2E = /*#__PURE__*/React.createElement("path", {
  d: "M6.014 41.986c21.672.147 26.168-.704 30.752-5.284C40.142 33.332 42 28.812 42 23.98s-1.86-9.35-5.234-12.725c-7.02-7.014-18.442-7.013-25.466.001-4.567 4.562-5.417 9.052-5.286 30.731M10.18 47c-2.063 0-4.28-.014-6.672-.036l-2.455-.023-.022-2.454c-.204-23.756.43-30.47 6.734-36.766 8.973-8.962 23.568-8.962 32.537 0C44.62 12.038 47 17.812 47 23.98c0 6.168-2.38 11.942-6.698 16.257C34.616 45.917 28.61 47 10.18 47"
});

var _ref2$g = /*#__PURE__*/React.createElement("path", {
  d: "M14 22h20v-5H14zm0 11h14v-5H14z"
});

function SvgBubbles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2E({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2E, _ref2$g);
}

function _extends$2D() { _extends$2D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2D.apply(this, arguments); }

var _ref$2D = /*#__PURE__*/React.createElement("path", {
  d: "M18 1v4h12V1h5v4h5.5c3.584 0 6.5 2.916 6.5 6.5V15h-5v-3.5c0-.827-.673-1.5-1.5-1.5H35v4h-5v-4H18v4h-5v-4H7.5c-.827 0-1.5.673-1.5 1.5V19h24v5H6v16.5A1.5 1.5 0 007.5 42h33a1.5 1.5 0 001.5-1.5V31h5v9.5a6.508 6.508 0 01-6.267 6.496L40.5 47h-33A6.508 6.508 0 011 40.5v-29C1 7.916 3.916 5 7.5 5H13V1h5zm24.011 17.78l3.592 3.478-15.5 16a2.496 2.496 0 01-1.776.761h-.02a2.504 2.504 0 01-1.768-.732l-7.5-7.5 3.536-3.536 5.704 5.705L42.011 18.78z",
  fillRule: "evenodd"
});

function SvgCalendarCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2D({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2D);
}

function _extends$2C() { _extends$2C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2C.apply(this, arguments); }

var _ref$2C = /*#__PURE__*/React.createElement("path", {
  d: "M40.5 42h-33c-.827 0-1.5-.673-1.5-1.5V25h36v15.5c0 .827-.673 1.5-1.5 1.5m-33-32H13v4h5v-4h12v4h5v-4h5.5c.827 0 1.5.673 1.5 1.5V20H6v-8.5c0-.827.673-1.5 1.5-1.5m33-5H35V1h-5v4H18V1h-5v4H7.5A6.508 6.508 0 001 11.5v29C1 44.084 3.916 47 7.5 47h33c3.584 0 6.5-2.916 6.5-6.5v-29C47 7.916 44.084 5 40.5 5",
  fillRule: "evenodd"
});

function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2C({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2C);
}

function _extends$2B() { _extends$2B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2B.apply(this, arguments); }

var _ref$2B = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M24.023.995l1.752 1.722c6.729 6.615 11.016 11.045 13.595 14.67 2.704 3.802 3.628 6.855 3.63 10.625v.004a19 19 0 01-38-.034v-.002l2.5.002-2.5.002v-.002c-.002-3.791.943-6.848 3.661-10.64 2.593-3.616 6.893-8.032 13.61-14.626l1.752-1.72zm-11.298 19.26c-2.166 3.022-2.727 5.073-2.725 7.726v.004a14 14 0 0028 .03c-.002-2.651-.553-4.705-2.704-7.73-2.074-2.915-5.535-6.59-11.275-12.275-5.736 5.67-9.209 9.333-11.296 12.245z"
});

var _ref2$f = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M24.012 20.995l1.752 1.722c3.346 3.29 5.575 5.583 6.94 7.502 1.49 2.095 2.044 3.872 2.046 6.036v.004a10.749 10.749 0 01-21.5-.018c-.001-2.18.568-3.96 2.065-6.048 1.371-1.913 3.606-4.199 6.945-7.477l1.752-1.72zm-8.314 15.246l-2.448-.002v.004l2.427-.002h.073-.052zm.022 0h-2.47 2.47zm3.658-3.135c-.945 1.318-1.129 2.092-1.128 3.133v.005a5.75 5.75 0 0011.5.012c-.001-1.044-.184-1.821-1.12-3.139-.866-1.216-2.28-2.755-4.62-5.099-2.341 2.338-3.76 3.872-4.632 5.088z"
});

function SvgCalories(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2B({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2B, _ref2$f);
}

function _extends$2A() { _extends$2A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2A.apply(this, arguments); }

var _ref$2A = /*#__PURE__*/React.createElement("path", {
  d: "M32.531 2c1.554 0 2.9.999 3.35 2.486L37.249 9H40.5c3.584 0 6.5 2.916 6.5 6.5v24c0 3.584-2.916 6.5-6.5 6.5h-33A6.508 6.508 0 011 39.5v-24C1 11.916 3.916 9 7.5 9h3.251l1.369-4.515A3.48 3.48 0 0115.469 2h17.062zm-1.113 5H16.582l-2.122 7H7.5c-.827 0-1.5.673-1.5 1.5v24c0 .827.673 1.5 1.5 1.5h33c.827 0 1.5-.673 1.5-1.5v-24c0-.827-.673-1.5-1.5-1.5h-6.96l-2.122-7zM24 16.5c5.79 0 10.5 4.71 10.5 10.5S29.79 37.5 24 37.5 13.5 32.79 13.5 27 18.21 16.5 24 16.5zm0 5a5.506 5.506 0 00-5.5 5.5c0 3.033 2.467 5.5 5.5 5.5s5.5-2.467 5.5-5.5-2.467-5.5-5.5-5.5zM37.25 16a2.75 2.75 0 110 5.5 2.75 2.75 0 010-5.5z"
});

function SvgCamera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2A({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2A);
}

function _extends$2z() { _extends$2z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2z.apply(this, arguments); }

var _ref$2z = /*#__PURE__*/React.createElement("path", {
  d: "M37 33.4L33.4 37 24 27.599 14.6 37 11 33.4l9.4-9.4-9.4-9.401L14.6 11l9.4 9.4 9.4-9.4 3.6 3.599L27.6 24l9.4 9.4zM24 1C11.297 1 1 11.297 1 24c0 12.702 10.297 23 23 23 12.702 0 23-10.298 23-23C47 11.297 36.702 1 24 1z",
  fillRule: "evenodd"
});

function SvgCancelCircleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2z({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2z);
}

function _extends$2y() { _extends$2y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2y.apply(this, arguments); }

var _ref$2y = /*#__PURE__*/React.createElement("path", {
  d: "M24 1c12.683 0 23 10.318 23 23 0 12.683-10.317 23-23 23C11.318 47 1 36.683 1 24 1 11.318 11.318 1 24 1zm0 5C14.075 6 6 14.075 6 24s8.075 18 18 18 18-8.075 18-18S33.925 6 24 6zm7.4 7l3.6 3.599L27.6 24l7.4 7.4-3.6 3.6-7.4-7.401L16.6 35 13 31.4l7.4-7.4-7.4-7.401L16.6 13l7.4 7.4 7.4-7.4z",
  fillRule: "evenodd"
});

function SvgCancelCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2y({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2y);
}

function _extends$2x() { _extends$2x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2x.apply(this, arguments); }

var _ref$2x = /*#__PURE__*/React.createElement("path", {
  d: "M2.35 17.772a2.501 2.501 0 012.15-3.774h39.003a2.501 2.501 0 012.15 3.774c-.188.278-.347.475-.477.59-4.29 3.775-10.762 9.414-19.415 16.916-.35.34-.953.72-1.758.72s-1.333-.323-1.753-.72C13.553 27.734 7.066 22.08 2.788 18.317a2.478 2.478 0 01-.439-.545z",
  fillRule: "evenodd"
});

function SvgCaretDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2x({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2x);
}

function _extends$2w() { _extends$2w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2w.apply(this, arguments); }

var _ref$2w = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M13.932 38L1.739 25.785A2.516 2.516 0 011 24c0-.646.246-1.292.739-1.785L13.932 10l3.568 3.57L7.091 24 17.5 34.429l-3.568 3.57zm20.14 0l12.192-12.215a2.516 2.516 0 00.74-1.785c0-.646-.247-1.292-.74-1.785L34.071 10l-3.568 3.571L40.913 24l-10.41 10.429L34.071 38z"
});

function SvgCaretDrag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2w({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2w);
}

function _extends$2v() { _extends$2v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2v.apply(this, arguments); }

var _ref$2v = /*#__PURE__*/React.createElement("path", {
  d: "M30.226 2.346A2.501 2.501 0 0134 4.496V43.5a2.501 2.501 0 01-3.774 2.15c-.278-.188-.475-.347-.59-.477-3.775-4.29-9.414-10.762-16.916-19.415-.34-.35-.72-.953-.72-1.758s.323-1.333.72-1.753C20.265 13.55 25.919 7.063 29.682 2.785c.127-.145.308-.29.544-.439z",
  fillRule: "evenodd"
});

function SvgCaretLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2v({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2v);
}

function _extends$2u() { _extends$2u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2u.apply(this, arguments); }

var _ref$2u = /*#__PURE__*/React.createElement("path", {
  d: "M17.774 2.346A2.501 2.501 0 0014 4.496V43.5a2.501 2.501 0 003.774 2.15c.278-.188.475-.347.59-.477 3.775-4.29 9.414-10.762 16.916-19.415.34-.35.72-.953.72-1.758s-.323-1.333-.72-1.753C27.735 13.55 22.081 7.063 18.318 2.785a2.478 2.478 0 00-.544-.439z",
  fillRule: "evenodd"
});

function SvgCaretRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2u({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2u);
}

function _extends$2t() { _extends$2t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2t.apply(this, arguments); }

var _ref$2t = /*#__PURE__*/React.createElement("path", {
  d: "M34.429 30.503L38 34.071 25.785 46.264a2.516 2.516 0 01-1.785.74 2.516 2.516 0 01-1.785-.74L10 34.071l3.571-3.568L24 40.913l10.429-10.41zM24 1c.646 0 1.292.246 1.785.739L38 13.932 34.43 17.5 24 7.091 13.571 17.5l-3.57-3.568L22.214 1.739A2.516 2.516 0 0124 1z",
  fillRule: "evenodd"
});

function SvgCaretSelect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2t({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2t);
}

function _extends$2s() { _extends$2s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2s.apply(this, arguments); }

var _ref$2s = /*#__PURE__*/React.createElement("path", {
  d: "M2.348 30.225a2.501 2.501 0 002.15 3.774h39.004a2.501 2.501 0 002.15-3.774c-.188-.278-.347-.475-.477-.59-4.29-3.775-10.762-9.414-19.415-16.916-.35-.34-.953-.72-1.758-.72s-1.333.323-1.753.72C13.552 20.263 7.065 25.917 2.787 29.68c-.145.128-.29.309-.439.545z",
  fillRule: "evenodd"
});

function SvgCaretUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2s({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2s);
}

function _extends$2r() { _extends$2r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2r.apply(this, arguments); }

var _ref$2r = /*#__PURE__*/React.createElement("path", {
  d: "M34.907 27.252c.57-4.852-.966-9.81-4.633-13.517a17.091 17.091 0 00-3.107-2.465c1.624-1.463 3.67-2.272 5.826-2.273h.001c2.33 0 4.54.935 6.22 2.632 2.136 2.158 2.801 4.508 2.786 15.749-2.896.007-5.203-.022-7.093-.126m-8.683 6.971C23.275 37.203 20.76 38.054 6 37.996c-.046-14.811.802-17.726 3.79-20.745 2.265-2.288 5.272-3.547 8.468-3.547h.002c3.194 0 6.2 1.26 8.462 3.547 4.57 4.618 4.35 12.072-.498 16.972m16.538-26.11C40.137 5.46 36.67 4 32.994 4h-.002c-3.674.001-7.143 1.461-9.763 4.11-.22.223-.58.582-1.067 1.069a16.892 16.892 0 00-3.902-.472h-.002c-4.539 0-8.808 1.786-12.018 5.028C1.473 18.549.874 23.475 1.018 40.5l.021 2.453 2.454.024c1.58.014 3.054.023 4.43.023 13.145 0 17.461-.824 21.851-5.262a18.34 18.34 0 003.786-5.561c1.94.147 4.271.2 7.245.2 1.136 0 2.367-.007 3.704-.02l2.454-.022.02-2.455c.11-12.858-.21-17.718-4.22-21.767",
  fillRule: "evenodd"
});

function SvgChatBubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2r({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2r);
}

function _extends$2q() { _extends$2q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2q.apply(this, arguments); }

var _ref$2q = /*#__PURE__*/React.createElement("path", {
  d: "M21.787 33.248a2.506 2.506 0 01-1.771.752h-.02a2.51 2.51 0 01-1.764-.724l-7.482-7.411 3.527-3.494 5.69 5.637L33.668 14l3.583 3.437-15.463 15.811zM24 1C11.298 1 1 11.297 1 24c0 12.702 10.298 23 23 23 12.703 0 23-10.298 23-23C47 11.297 36.703 1 24 1z",
  fillRule: "evenodd"
});

function SvgCheckmarkCircleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2q({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2q);
}

function _extends$2p() { _extends$2p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2p.apply(this, arguments); }

var _ref$2p = /*#__PURE__*/React.createElement("path", {
  d: "M24 1c12.683 0 23 10.318 23 23 0 12.683-10.317 23-23 23C11.318 47 1 36.683 1 24 1 11.318 11.318 1 24 1zm0 5C14.075 6 6 14.075 6 24s8.075 18 18 18 18-8.075 18-18S33.925 6 24 6zm9.704 8.011l3.592 3.478-15.501 16a2.496 2.496 0 01-1.775.761H20a2.504 2.504 0 01-1.768-.732l-7.5-7.5 3.536-3.536 5.704 5.705 13.732-14.176z",
  fillRule: "evenodd"
});

function SvgCheckmarkCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2p({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2p);
}

function _extends$2o() { _extends$2o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2o.apply(this, arguments); }

var _ref$2o = /*#__PURE__*/React.createElement("path", {
  d: "M16.268 40a2.49 2.49 0 01-1.768-.74L3 27.627l3.536-3.576 9.704 9.816L41.412 8l3.592 3.518L18.063 39.23a2.482 2.482 0 01-1.775.77h-.02z",
  fillRule: "evenodd"
});

function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2o({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2o);
}

function _extends$2n() { _extends$2n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2n.apply(this, arguments); }

var _ref$2n = /*#__PURE__*/React.createElement("path", {
  d: "M10.5 42c-.827 0-1.5-.673-1.5-1.5V13c0-1.362.499-2 2-2h1v5h24v-5h1c1.485 0 2 .563 2 2v27.5c0 .827-.673 1.5-1.5 1.5h-27zm0-36A6.508 6.508 0 004 12.5v28c0 3.584 2.916 6.5 6.5 6.5h27c3.584 0 6.5-2.916 6.5-6.5v-28C44 8.916 41.084 6 37.5 6H31V1H17v5h14v5H17V6h-6.5z",
  fillRule: "evenodd"
});

function SvgClipboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2n({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2n);
}

function _extends$2m() { _extends$2m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2m.apply(this, arguments); }

var _ref$2m = /*#__PURE__*/React.createElement("path", {
  d: "M24 1c12.683 0 23 10.318 23 23 0 12.683-10.317 23-23 23C11.318 47 1 36.683 1 24 1 11.318 11.318 1 24 1zm0 5C14.075 6 6 14.075 6 24s8.075 18 18 18 18-8.075 18-18S33.925 6 24 6zm2 5v11.562l6.492 3.82-2.539 4.31L21 25.42V11h5z",
  fillRule: "evenodd"
});

function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2m({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2m);
}

function _extends$2l() { _extends$2l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2l.apply(this, arguments); }

var _ref$2l = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M33.4 11L24 20.401 14.6 11 11 14.6l9.4 9.401L11 33.4l3.6 3.6 9.4-9.4 9.4 9.4 3.6-3.6-9.401-9.399L37 14.6z"
});

function SvgCloseSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2l({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2l);
}

function _extends$2k() { _extends$2k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2k.apply(this, arguments); }

var _ref$2k = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M43.429 1L24.001 20.428 4.572 1 1 4.571 20.429 24 1 43.429 4.572 47l19.429-19.428L43.429 47 47 43.429 27.572 24 47 4.571z"
});

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2k({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2k);
}

function _extends$2j() { _extends$2j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2j.apply(this, arguments); }

var _ref$2j = /*#__PURE__*/React.createElement("path", {
  d: "M17.068 21l11.193 11.215c.493.493.739 1.139.739 1.785 0 .646-.246 1.292-.739 1.785L17.068 47 13.5 43.429l6.914-6.929H1v-5h19.414L13.5 24.571 17.068 21zM30.932 1L34.5 4.571 27.585 11.5H47v5H27.586l6.914 6.929L30.932 27 19.739 15.785A2.516 2.516 0 0119 14c0-.646.246-1.292.739-1.785L30.932 1z",
  fillRule: "evenodd"
});

function SvgCompare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2j({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2j);
}

function _extends$2i() { _extends$2i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2i.apply(this, arguments); }

var _ref$2i = /*#__PURE__*/React.createElement("path", {
  d: "M39.5 14c2.481 0 4.5 2.019 4.5 4.5v24c0 2.481-2.019 4.5-4.5 4.5h-17a4.505 4.505 0 01-4.5-4.5v-24c0-2.481 2.019-4.5 4.5-4.5h17zm-.5 5H23v23h16V19zM26.5 1C28.43 1 30 2.57 30 4.5V9h-5V6H9v25h4v5H7.5C5.57 36 4 34.43 4 32.5v-28C4 2.57 5.57 1 7.5 1h19z",
  fillRule: "evenodd"
});

function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2i({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2i);
}

function _extends$2h() { _extends$2h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2h.apply(this, arguments); }

var _ref$2h = /*#__PURE__*/React.createElement("path", {
  d: "M37 32.5v-6c0-.827.673-1.5 1.5-1.5h3.496v7.5c0 .827-.673 1.5-1.5 1.5H38.5c-.827 0-1.5-.673-1.5-1.5m-26.004-6v6c0 .827-.673 1.5-1.5 1.5H7.5c-.827 0-1.5-.673-1.5-1.5V32h.001v-7h3.495c.827 0 1.5.673 1.5 1.5m35.98 6.404c.003-.136.024-.265.024-.404h-.004V20h-.015C46.678 9.306 36.697 1 24.002 1 11.302 1 1.319 9.306 1.016 20H1v12.5C1 36.084 3.916 39 7.5 39h1.996c3.584 0 6.5-2.916 6.5-6.5v-6c0-3.584-2.916-6.5-6.5-6.5H6.033c.331-7.763 8.253-14 17.969-14 9.713 0 17.632 6.237 17.963 14H38.5a6.508 6.508 0 00-6.5 6.5v6c0 3.476 2.744 6.314 6.179 6.483-2.116 1.381-5.376 2.499-10.364 2.877C27.322 40.21 25.811 39 24 39a4 4 0 000 8c14.027 0 22.524-5.153 22.958-13.81.011-.093.012-.19.018-.286",
  fillRule: "evenodd"
});

function SvgCustomerCentre(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2h({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2h);
}

function _extends$2g() { _extends$2g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2g.apply(this, arguments); }

var _ref$2g = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M47 7h-8.976v5.69H47V7zm-24.683 9.103h-8.975v5.69h8.975v-5.69zm-8.975 9.104h8.975v5.69h-8.975v-5.69zM9.976 34.31H1V40h8.976v-5.69zm12.341 0h-8.975V40h8.975v-5.69zm3.366 0h8.975V40h-8.975v-5.69zm8.975-9.103h-8.975v5.69h8.975v-5.69zm3.366 9.103H47V40h-8.976v-5.69zM47 25.207h-8.976v5.69H47v-5.69zm-8.976-9.104H47v5.69h-8.976v-5.69z"
});

var _ref2$e = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M47 7h-8.976v5.69H47V7zm-24.683 9.103h-8.975v5.69h8.975v-5.69zm-8.975 9.104h8.975v5.69h-8.975v-5.69zM9.976 34.31H1V40h8.976v-5.69zm12.341 0h-8.975V40h8.975v-5.69zm3.366 0h8.975V40h-8.975v-5.69zm8.975-9.103h-8.975v5.69h8.975v-5.69zm3.366 9.103H47V40h-8.976v-5.69zM47 25.207h-8.976v5.69H47v-5.69zm-8.976-9.104H47v5.69h-8.976v-5.69z"
});

var _ref3$3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M47 7h-8.976v5.69H47V7zm-24.683 9.103h-8.975v5.69h8.975v-5.69zm-8.975 9.104h8.975v5.69h-8.975v-5.69zM9.976 34.31H1V40h8.976v-5.69zm12.341 0h-8.975V40h8.975v-5.69zm3.366 0h8.975V40h-8.975v-5.69zm8.975-9.103h-8.975v5.69h8.975v-5.69zm3.366 9.103H47V40h-8.976v-5.69zM47 25.207h-8.976v5.69H47v-5.69zm-8.976-9.104H47v5.69h-8.976v-5.69z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M47 7h-8.976v5.69H47V7zm-24.683 9.103h-8.975v5.69h8.975v-5.69zm-8.975 9.104h8.975v5.69h-8.975v-5.69zM9.976 34.31H1V40h8.976v-5.69zm12.341 0h-8.975V40h8.975v-5.69zm3.366 0h8.975V40h-8.975v-5.69zm8.975-9.103h-8.975v5.69h8.975v-5.69zm3.366 9.103H47V40h-8.976v-5.69zM47 25.207h-8.976v5.69H47v-5.69zm-8.976-9.104H47v5.69h-8.976v-5.69z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M47 7h-8.976v5.69H47V7zm-24.683 9.103h-8.975v5.69h8.975v-5.69zm-8.975 9.104h8.975v5.69h-8.975v-5.69zM9.976 34.31H1V40h8.976v-5.69zm12.341 0h-8.975V40h8.975v-5.69zm3.366 0h8.975V40h-8.975v-5.69zm8.975-9.103h-8.975v5.69h8.975v-5.69zm3.366 9.103H47V40h-8.976v-5.69zM47 25.207h-8.976v5.69H47v-5.69zm-8.976-9.104H47v5.69h-8.976v-5.69z"
});

function SvgDeezer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2g({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2g, _ref2$e, _ref3$3, _ref4, _ref5);
}

function _extends$2f() { _extends$2f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2f.apply(this, arguments); }

var _ref$2f = /*#__PURE__*/React.createElement("path", {
  d: "M29.5 1C33.084 1 36 3.916 36 7.5l-.001 1.499L45 9v5h-4v26.5c0 3.584-2.916 6.5-6.5 6.5h-21A6.508 6.508 0 017 40.5V14H3V9l8.999-.001L12 7.5C12 3.916 14.916 1 18.5 1h11zM36 14H12v26.5c0 .827.673 1.5 1.5 1.5h21c.813 0 1.5-.687 1.5-1.5V14zm-14 6v16h-5V20h5zm9 0v16h-5V20h5zM29.5 6h-11c-.827 0-1.5.673-1.5 1.5l-.001 1.499h14L31 7.5c0-.827-.673-1.5-1.5-1.5z",
  fillRule: "evenodd"
});

function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2f({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2f);
}

function _extends$2e() { _extends$2e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2e.apply(this, arguments); }

var _ref$2e = /*#__PURE__*/React.createElement("path", {
  d: "M8 42V11h8v13h13v18H8zm13-31l8 8h-8v-8zM34 1l11 11v26.5c0 2.156-1.765 3.5-3.5 3.5H34v1.503c0 2.15-1.74 3.411-3.336 3.493L30.5 47h-24C4.226 46.967 3 45.094 3 43.503V9.5C3 7.066 5 6 6.5 6h9.674l.046-1.448C16.22 2.5 17.461 1 20.004 1H34zm0 16v20h6V14l-8-8h-9l11 11z",
  fillRule: "evenodd"
});

function SvgDocuments(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2e({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2e);
}

function _extends$2d() { _extends$2d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2d.apply(this, arguments); }

var _ref$2d = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M6.906 22.843l9.307-9.307L12.677 10 1.824 20.853a2.813 2.813 0 000 3.979l10.853 10.853 3.536-3.536-9.307-9.306zm13.752-2.544l6.764-6.763L23.886 10 13.033 20.853a2.813 2.813 0 000 3.979l10.853 10.853 3.536-3.536-6.85-6.85h13.824a7.5 7.5 0 017.5 7.5v4.6h5v-4.6c0-6.903-5.596-12.5-12.5-12.5H20.658z"
});

function SvgDoubleArrowLeftForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$2d);
}

function _extends$2c() { _extends$2c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2c.apply(this, arguments); }

var _ref$2c = /*#__PURE__*/React.createElement("path", {
  d: "M24 1c12.683 0 23 10.318 23 23 0 12.683-10.317 23-23 23C11.318 47 1 36.683 1 24 1 11.318 11.318 1 24 1zm2.752 4h-5.005v15.622l-5.276-4.923L13 19.301l9.514 9c.484.466 1.11.699 1.736.699a2.5 2.5 0 001.736-.699l9.514-9-3.473-3.602-5.275 4.923V5zM13.5 38A6.508 6.508 0 017 31.5V28h5v3.5c0 .827.673 1.5 1.5 1.5h21c.827 0 1.5-.673 1.5-1.5V28h5v3.5c0 3.584-2.916 6.5-6.5 6.5h-21z",
  fillRule: "evenodd"
});

function SvgDownloadCircleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2c({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2c);
}

function _extends$2b() { _extends$2b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2b.apply(this, arguments); }

var _ref$2b = /*#__PURE__*/React.createElement("path", {
  d: "M26.502 19v19.622l5.275-4.923 3.473 3.602-9.514 9A2.5 2.5 0 0124 47a2.496 2.496 0 01-1.736-.699l-9.514-9 3.471-3.602 5.276 4.923V19h5.005zM15.717 1l8 5H40.5c3.584 0 6.5 2.916 6.5 6.5v16c0 3.584-2.916 6.5-6.5 6.5h-2.496v-5H40.5c.827 0 1.5-.673 1.5-1.5v-16c0-.827-.673-1.5-1.5-1.5H22.283l-8-5H7.5C6.673 6 6 6.673 6 7.5v21c0 .827.673 1.5 1.5 1.5H10v5H7.5A6.508 6.508 0 011 28.5v-21C1 3.916 3.916 1 7.5 1h8.217z",
  fillRule: "evenodd"
});

function SvgDownloadFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2b({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2b);
}

function _extends$2a() { _extends$2a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2a.apply(this, arguments); }

var _ref$2a = /*#__PURE__*/React.createElement("path", {
  d: "M6 30v10.5c0 .827.673 1.5 1.5 1.5h33c.827 0 1.5-.673 1.5-1.5V30h5v10.5c0 3.584-2.916 6.5-6.5 6.5h-33A6.508 6.508 0 011 40.5V30h5zM26.502 1v27.622l9.275-8.923 3.473 3.602-13.514 13A2.5 2.5 0 0124 37a2.496 2.496 0 01-1.736-.699l-13.514-13 3.471-3.602 9.276 8.923V1h5.005z",
  fillRule: "evenodd"
});

function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2a({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2a);
}

function _extends$29() { _extends$29 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$29.apply(this, arguments); }

var _ref$29 = /*#__PURE__*/React.createElement("path", {
  d: "M3.487 14.005c8.469-.056 14.683.271 20.513 4.58 5.829-4.308 12-4.633 20.514-4.58l2.486.013V42.04l-2.514-.014c-9.684-.054-13.87.57-18.253 4.175a3.5 3.5 0 01-2.232.8 3.514 3.514 0 01-2.236-.8c-4.381-3.605-8.59-4.225-18.251-4.175L1 42.04V14.018zM42 19.01c-7.656.084-11.629.875-15.5 3.957v17.041c4.512-2.463 9.382-2.933 15.5-2.98zm-36 0v18.018c6.119.047 10.988.516 15.5 2.98v-17.04c-3.872-3.082-7.845-3.874-15.5-3.958zM24 1a5.5 5.5 0 110 11 5.5 5.5 0 010-11z",
  fillRule: "evenodd"
});

function SvgEasyLanguage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$29({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$29);
}

function _extends$28() { _extends$28 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$28.apply(this, arguments); }

var _ref$28 = /*#__PURE__*/React.createElement("path", {
  xmlns: "http://www.w3.org/2000/svg",
  d: "M35.006 2l.189.007a2.55 2.55 0 011.45.6l.16.146 4.221 4.212 4.221 4.212.124.135c.827.97.83 2.392.059 3.29l-.116.124-3.438 3.438C33.688 26.35 25.26 34.768 17.08 42.946L14.025 46H2V33.977l17.394-17.395 3.499-3.498L33.285 2.69A2.49 2.49 0 0135.006 2zM9.278 33.771l-2.276 2.278V41h4.951l2.277-2.277-4.952-4.951zM35.001 8.046L12.815 30.235l4.951 4.95 22.188-22.188L35 8.047z"
});

function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$28({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$28);
}

function _extends$27() { _extends$27 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$27.apply(this, arguments); }

var _ref$27 = /*#__PURE__*/React.createElement("path", {
  d: "M6 29v11.5c0 .827.673 1.5 1.5 1.5H19v5H7.5A6.508 6.508 0 011 40.5V29h5zm41 0v11.5c0 3.584-2.916 6.5-6.5 6.5H29v-5h11.5c.827 0 1.5-.673 1.5-1.5V29h5zM19 1v5H7.5C6.673 6 6 6.673 6 7.5V19H1V7.5C1 3.916 3.916 1 7.5 1H19zm21.5 0C44.084 1 47 3.916 47 7.5V19h-5V7.5c0-.827-.673-1.5-1.5-1.5H29V1z",
  fillRule: "evenodd"
});

function SvgEnlarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$27({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$27);
}

function _extends$26() { _extends$26 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$26.apply(this, arguments); }

var _ref$26 = /*#__PURE__*/React.createElement("path", {
  d: "M4 21.498h12.018L14 11V4.5C14 2.709 15.436 1 17.5 1h23C42.597 1 44 2.7 44 4.5v39c0 2.075-1.715 3.5-3.5 3.5h-23c-1.997 0-3.5-1.666-3.5-3.432v-2.017V37h5l-2.02-10.497H4v-5.005zm10-10.501l2.019 10.501h9.603l-4.923-5.275L24.3 12.75l9 9.514A2.5 2.5 0 0134 24c0 .626-.233 1.252-.7 1.736l-9 9.514-3.601-3.471 4.923-5.276h-8.64L19 37v5h20V6H19v5l-5-.003z",
  fillRule: "evenodd"
});

function SvgEnterLogin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$26({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$26);
}

function _extends$25() { _extends$25 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$25.apply(this, arguments); }

var _ref$25 = /*#__PURE__*/React.createElement("path", {
  d: "M16 31v13h-5v-4H1v-5h10v-4h5zm31 4v5H21v-5h26zM37 17v4h10v5H37v4h-5V17h5zm-10 4v5H1v-5h26zM16 3v13.001h-5V12H1V7h10V3h5zm31 4.001v5H21V7h26z",
  fillRule: "evenodd"
});

function SvgEqualizer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$25({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$25);
}

function _extends$24() { _extends$24 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$24.apply(this, arguments); }

var _ref$24 = /*#__PURE__*/React.createElement("path", {
  d: "M1 4.5C1 2.424 2.715 1 4.5 1h23C29.497 1 31 2.666 31 4.432V11h-5l2.019 10.498h10.603l-4.923-5.275L37.3 12.75l9 9.514A2.5 2.5 0 0147 24c0 .626-.233 1.252-.7 1.736l-9 9.514-3.601-3.471 4.923-5.276H28.98L31 37l-.001.003-2.02-10.5H17v-5.005h11.019L25.999 11V6H6v36h20v-5l5 .003L31 43.5c0 1.791-1.436 3.5-3.5 3.5h-23C2.402 47 1 45.3 1 43.5v-39z",
  fillRule: "evenodd"
});

function SvgExit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$24({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$24);
}

function _extends$23() { _extends$23 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$23.apply(this, arguments); }

var _ref$23 = /*#__PURE__*/React.createElement("path", {
  d: "M28.768 4.75l17.5 17.484A2.49 2.49 0 0147 24a2.49 2.49 0 01-.732 1.766l-17.5 17.484-3.536-3.532 13.233-13.22H24v-4.996h14.465L25.232 8.282l3.536-3.532zM6 21.502v4.996H1v-4.996h5zm13 0v4.996h-8v-4.996h8z",
  fillRule: "evenodd"
});

function SvgExpandArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$23({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$23);
}

function _extends$22() { _extends$22 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$22.apply(this, arguments); }

var _ref$22 = /*#__PURE__*/React.createElement("path", {
  d: "M39.203 5.762l3.535 3.535-4.608 4.609c4.9 3.676 7.447 8.152 7.713 8.636l.014.025.643 1.183-.643 1.183c-.301.554-7.543 13.567-22.107 13.567-3.217 0-6.077-.635-8.584-1.63l-6.369 6.368-3.535-3.535 33.94-33.941zm-4.63 11.7l-.408.41c.026.302.042.606.042.913 0 6.16-4.691 11.172-10.457 11.172a9.839 9.839 0 01-1.548-.122l-3.105 3.104c1.434.377 2.985.596 4.653.596 9.38 0 15.052-6.933 16.988-9.785-1.02-1.501-3.078-4.13-6.164-6.287zM23.75 9c2.604 0 4.974.416 7.113 1.103l-4.12 4.118a17.854 17.854 0 00-2.993-.255c-1.367 0-2.645.16-3.854.421-1.037 1.161-1.623 2.72-1.623 4.398 0 1.148.277 2.224.758 3.148l-3.606 3.606a11.616 11.616 0 01-2.132-6.754c0-.561.053-1.112.128-1.657-3.361 2.212-5.586 5.043-6.659 6.623a25.245 25.245 0 005.016 5.434l-3.525 3.526C4.08 29.236 1.9 25.402 1.656 24.958l-.013-.025L1 23.75l.643-1.183C1.944 22.013 9.186 9 23.75 9z"
});

function SvgEyeClosed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$22({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$22);
}

function _extends$21() { _extends$21 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$21.apply(this, arguments); }

var _ref$21 = /*#__PURE__*/React.createElement("path", {
  d: "M23.75 33.535c-9.383 0-15.055-6.937-16.988-9.784 1.073-1.58 3.298-4.411 6.659-6.623a12.127 12.127 0 00-.128 1.657c0 6.16 4.691 11.172 10.457 11.172 5.766 0 10.457-5.012 10.457-11.172 0-.561-.052-1.113-.128-1.658 3.362 2.213 5.586 5.043 6.659 6.623-1.936 2.852-7.608 9.785-16.988 9.785zm3.854-19.148c1.037 1.16 1.623 2.72 1.623 4.398 0 3.422-2.457 6.207-5.477 6.207-3.02 0-5.477-2.785-5.477-6.207 0-1.678.586-3.237 1.623-4.398a18.153 18.153 0 013.854-.421c1.367 0 2.645.16 3.854.421zm18.253 8.18C45.556 22.013 38.314 9 23.75 9S1.944 22.013 1.643 22.567L1 23.75l.643 1.183C1.944 25.487 9.186 38.5 23.75 38.5s21.806-13.013 22.107-13.567l.643-1.183-.643-1.183z"
});

function SvgEyeOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$21({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$21);
}

function _extends$20() { _extends$20 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$20.apply(this, arguments); }

var _ref$20 = /*#__PURE__*/React.createElement("path", {
  d: "M42 1v12h5v26h-9v8H19v-8H7.5A6.508 6.508 0 011 32.5v-13C1 15.916 3.916 13 7.5 13H14V1h28zm-9 29h-9v12h9V30zm9-12H7.5c-.827 0-1.5.673-1.5 1.5v13c0 .827.673 1.5 1.5 1.5H19v-9h19v9h4V18zm-27 3v10h-5V21h5zM37 6H19v7h18V6z",
  fillRule: "evenodd"
});

function SvgFax(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$20({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$20);
}

function _extends$1$() { _extends$1$ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1$.apply(this, arguments); }

var _ref$1$ = /*#__PURE__*/React.createElement("path", {
  d: "M34.5 42h-21c-.827 0-1.5-.673-1.5-1.5V32h11v-5H12V7.5c0-.827.673-1.5 1.5-1.5H23v13h13v21.5c0 .827-.673 1.5-1.5 1.5zM28 7.535L34.465 14H28V7.535zM28.535 1H13.5A6.508 6.508 0 007 7.5v33c0 3.584 2.916 6.5 6.5 6.5h21c3.584 0 6.5-2.916 6.5-6.5V13.464L28.535 1z",
  fillRule: "evenodd"
});

function SvgFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1$({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1$);
}

function _extends$1_() { _extends$1_ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1_.apply(this, arguments); }

var _ref$1_ = /*#__PURE__*/React.createElement("path", {
  d: "M16.5 24c3.538 0 6.541 2.311 7.595 5.5H47v5H24.095C23.041 37.689 20.038 40 16.5 40c-3.538 0-6.542-2.311-7.594-5.5H1v-5h7.906C9.958 26.311 12.962 24 16.5 24zm0 5c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3zm14-21c3.537 0 6.541 2.311 7.595 5.5H47v5h-8.905C37.041 21.689 34.037 24 30.5 24s-6.541-2.311-7.595-5.5H1v-5h21.905C23.959 10.311 26.963 8 30.5 8zm0 5c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3z",
  fillRule: "evenodd"
});

function SvgFilter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1_({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1_);
}

function _extends$1Z() { _extends$1Z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1Z.apply(this, arguments); }

var _ref$1Z = /*#__PURE__*/React.createElement("path", {
  d: "M28.017 15c5.525 0 11.325 6.028 13.676 8.284a.972.972 0 010 1.416c-2.35 2.26-8.15 8.3-13.675 8.3-6.905 0-11.744-4.773-14.712-6.875l-5.343 3.98c-2.556-3.842-2.678-7.902 0-12.21l5.342 3.98C16.273 19.773 21.112 15 28.017 15zm0-5c-6.479 0-11.419 3.14-14.74 5.619l-2.328-1.734-4.363-3.25-2.87 4.621C.091 21.088.121 27.346 3.8 32.875l2.921 4.39 4.23-3.15 2.327-1.734C16.599 34.86 21.539 38 28.018 38c7.176 0 13.561-6.213 16.63-9.2l.51-.494a5.973 5.973 0 00-.003-8.63l-.505-.489C41.581 16.205 35.195 10 28.017 10z"
});

function SvgFish(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1Z({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1Z);
}

function _extends$1Y() { _extends$1Y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1Y.apply(this, arguments); }

var _ref$1Y = /*#__PURE__*/React.createElement("path", {
  d: "M9.106 25.705a17.286 17.286 0 019.19 1.087 16.52 16.52 0 013.723 2.302 19.108 19.108 0 004.132 2.574 17.72 17.72 0 007.19 1.435 27.46 27.46 0 008.197-1.356L43 31.29V6.595l-2.67.835c-4.912 1.535-9.117 1.577-12.495.08a15.302 15.302 0 01-3.316-2.103 20.444 20.444 0 00-4.581-2.8C16.007.91 11.539.553 6.663 1.557L4 2.5V47h5.132l-.026-21.295zM18.296 7.5a16.52 16.52 0 013.723 2.302 19.103 19.103 0 004.132 2.574c3.409 1.486 7.4 1.815 11.849.959v14.004c-3.95.893-7.367.712-10.211-.533a15.297 15.297 0 01-3.316-2.101 20.455 20.455 0 00-4.582-2.8 20.224 20.224 0 00-8.083-1.614c-.91 0-1.904.052-2.808.152V6.403A17.678 17.678 0 0118.295 7.5z"
});

function SvgFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1Y({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1Y);
}

function _extends$1X() { _extends$1X = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1X.apply(this, arguments); }

var _ref$1X = /*#__PURE__*/React.createElement("path", {
  d: "M7.5 12c-.827 0-1.5.673-1.5 1.5v21c0 .827.673 1.5 1.5 1.5h33c.827 0 1.5-.673 1.5-1.5v-16c0-.827-.673-1.5-1.5-1.5H22.283l-8-5H7.5zm33 29h-33A6.508 6.508 0 011 34.5v-21C1 9.916 3.916 7 7.5 7h8.217l8 5H40.5c3.584 0 6.5 2.916 6.5 6.5v16c0 3.584-2.916 6.5-6.5 6.5z",
  fillRule: "evenodd"
});

function SvgFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1X({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1X);
}

function _extends$1W() { _extends$1W = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1W.apply(this, arguments); }

var _ref$1W = /*#__PURE__*/React.createElement("path", {
  d: "M24.695 14l6.638 6.644-10.691 10.69H14v-6.642L24.695 14zM21 .667A4.338 4.338 0 0125.333 5v6.333H22V5c0-.551-.449-1-1-1H5c-.551 0-1 .449-1 1v22c0 .551.449 1 1 1h5.667v3.333H5A4.338 4.338 0 01.667 27V5A4.338 4.338 0 015 .667h16zm3.693 18.078l-7.338 7.336v1.898h1.898l7.336-7.336-1.896-1.898z",
  fillRule: "evenodd"
});

function SvgForm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1W({
    width: 48,
    height: 48,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1W);
}

function _extends$1V() { _extends$1V = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1V.apply(this, arguments); }

var _ref$1V = /*#__PURE__*/React.createElement("path", {
  d: "M31.5 1C35.084 1 38 3.916 38 7.5V17h-5V7.5c0-.827-.673-1.5-1.5-1.5h-24C6.673 6 6 6.673 6 7.5v33c0 .827.673 1.5 1.5 1.5H16v5H7.5A6.508 6.508 0 011 40.5v-33C1 3.916 3.916 1 7.5 1h24zm5.542 20L47 30.966 30.963 47H21v-9.962L37.042 21zm-.003 7.117L26.033 39.12v2.848h2.847l11.004-11.005-2.845-2.847z",
  fillRule: "evenodd"
});

function SvgForms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1V({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1V);
}

function _extends$1U() { _extends$1U = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1U.apply(this, arguments); }

var _ref$1U = /*#__PURE__*/React.createElement("path", {
  d: "M23.067 1L44.26 22.215a2.524 2.524 0 010 3.57L23.067 47 19.5 43.429 38.91 24 19.5 4.571 23.067 1zm-16.5 0l21.194 21.215a2.526 2.526 0 010 3.57L6.568 47 3 43.429 22.409 24 2.999 4.571 6.569 1z",
  fillRule: "evenodd"
});

function SvgForward(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1U({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1U);
}

function _extends$1T() { _extends$1T = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1T.apply(this, arguments); }

var _ref$1T = /*#__PURE__*/React.createElement("path", {
  d: "M12 .5l.292.004c6.118.152 11.05 5.082 11.204 11.2L23.5 12l-.004.292c-.152 6.118-5.082 11.05-11.2 11.204L12 23.5l-.292-.004C5.492 23.341.5 18.253.5 12 .5 5.649 5.649.5 12 .5zM13.853 16h-3.7a26.06 26.06 0 001.54 4.994.619.619 0 00.042.002L12 21l.265-.004.048-.002a26.067 26.067 0 001.54-4.993zm-6.226 0l-3.69.001a9.032 9.032 0 004.855 4.41 27.294 27.294 0 01-1.165-4.41zm12.437.001h-3.685a27.288 27.288 0 01-1.164 4.408A9.032 9.032 0 0020.064 16zm-12.73-6H3.223a9.03 9.03 0 00-.098 3.5H7.32a23.526 23.526 0 01.013-3.5zm6.85 0H9.822a20.662 20.662 0 00-.015 3.5h4.392c.094-1.175.089-2.34-.015-3.5zm6.593 0h-4.105c.091 1.16.096 2.327.013 3.5h4.19a9.04 9.04 0 00.121-1.236L21 12l-.004-.265A9.012 9.012 0 0020.777 10zM8.741 3.607l-.012.005A9.032 9.032 0 004.204 7.5h3.463A24.614 24.614 0 018.74 3.608zM12 3l-.265.004-.058.002A23.008 23.008 0 0010.202 7.5h3.602a23.01 23.01 0 00-1.474-4.494A8.454 8.454 0 0012 3zm3.266.61l.12.337c.411 1.177.729 2.361.953 3.553h3.457a9.032 9.032 0 00-4.53-3.89z",
  fillRule: "evenodd"
});

function SvgGlobe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1T({
    width: 48,
    height: 48,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1T);
}

function _extends$1S() { _extends$1S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1S.apply(this, arguments); }

var _ref$1S = /*#__PURE__*/React.createElement("path", {
  d: "M24 9.558a2.683 2.683 0 01-2.692-2.674v-3.21A2.683 2.683 0 0124 1a2.683 2.683 0 012.692 2.674v3.21A2.683 2.683 0 0124 9.558zM24 47a2.683 2.683 0 01-2.692-2.674v-3.21A2.683 2.683 0 0124 38.442a2.683 2.683 0 012.692 2.674v3.21A2.683 2.683 0 0124 47zm0-11.767a2.683 2.683 0 01-2.692-2.675V15.442A2.683 2.683 0 0124 12.767a2.683 2.683 0 012.692 2.675v17.116A2.683 2.683 0 0124 35.233zm9.692-25.675A2.683 2.683 0 0031 12.233v3.209a2.683 2.683 0 002.692 2.674 2.683 2.683 0 002.693-2.674v-3.21a2.683 2.683 0 00-2.693-2.674zm0 11.768A2.683 2.683 0 0031 24v10.698a2.683 2.683 0 002.692 2.674 2.683 2.683 0 002.693-2.674V24a2.683 2.683 0 00-2.693-2.674zm8.616-2.14a2.683 2.683 0 00-2.693 2.674v3.21a2.683 2.683 0 002.693 2.674A2.683 2.683 0 0045 25.07v-3.21a2.683 2.683 0 00-2.692-2.674zm-28 18.186a2.683 2.683 0 01-2.693-2.674v-3.21a2.683 2.683 0 012.693-2.674A2.683 2.683 0 0117 31.488v3.21a2.683 2.683 0 01-2.692 2.674zm0-11.767a2.683 2.683 0 01-2.693-2.675V12.233a2.683 2.683 0 012.693-2.675A2.683 2.683 0 0117 12.233V22.93a2.683 2.683 0 01-2.692 2.675zm-8.616-6.419a2.683 2.683 0 012.693 2.674v3.21a2.683 2.683 0 01-2.693 2.674A2.683 2.683 0 013 25.07v-3.21a2.683 2.683 0 012.692-2.674z"
});

function SvgGooglepodcast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1S({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1S);
}

function _extends$1R() { _extends$1R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1R.apply(this, arguments); }

var _ref$1R = /*#__PURE__*/React.createElement("path", {
  d: "M42.5 26c2.481 0 4.5 2.019 4.5 4.5v12c0 2.481-2.019 4.5-4.5 4.5h-12a4.505 4.505 0 01-4.5-4.5v-12c0-2.481 2.019-4.5 4.5-4.5h12zm-25 0c2.481 0 4.5 2.019 4.5 4.5v12c0 2.481-2.019 4.5-4.5 4.5h-12A4.505 4.505 0 011 42.5v-12C1 28.019 3.019 26 5.5 26h12zM42 31H31v11h11V31zm-25 0H6v11h11V31zM42.5 1C44.981 1 47 3.019 47 5.5v12c0 2.481-2.019 4.5-4.5 4.5h-12a4.505 4.505 0 01-4.5-4.5v-12C26 3.019 28.019 1 30.5 1h12zm-25 0C19.981 1 22 3.019 22 5.5v12c0 2.481-2.019 4.5-4.5 4.5h-12A4.505 4.505 0 011 17.5v-12C1 3.019 3.019 1 5.5 1h12zM42 6H31v11h11V6zM17 6H6v11h11V6z",
  fillRule: "evenodd"
});

function SvgGrid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1R({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1R);
}

function _extends$1Q() { _extends$1Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1Q.apply(this, arguments); }

var _ref$1Q = /*#__PURE__*/React.createElement("path", {
  d: "M42 39.5c0 .827-.673 1.5-1.5 1.5h-3a1.52 1.52 0 01-1.5-1.5v-7c0-.813.687-1.5 1.5-1.5H42v8.5zm-30-7v7c0 .813-.687 1.5-1.5 1.5h-3c-.827 0-1.5-.673-1.5-1.5V31h4.5c.813 0 1.5.687 1.5 1.5zM24.003 2C11.104 2 1 10.627 1 21.641V39.5C1 43.084 3.916 46 7.5 46h3c3.584 0 6.5-2.916 6.5-6.5v-7c0-3.584-2.916-6.5-6.5-6.5H6v-4.359C6 13.568 14.076 7 24.003 7 33.927 7 42 13.568 42 21.641V26h-4.5a6.508 6.508 0 00-6.5 6.5v7c0 3.584 2.916 6.5 6.5 6.5h3c3.584 0 6.5-2.916 6.5-6.5V21.641C47 10.627 36.898 2 24.003 2z",
  fillRule: "evenodd"
});

function SvgHeadphones(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1Q({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1Q);
}

function _extends$1P() { _extends$1P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1P.apply(this, arguments); }

var _ref$1P = /*#__PURE__*/React.createElement("path", {
  d: "M40.302 7.721C44.62 12.038 46.999 17.812 47 23.98c0 6.168-2.38 11.942-6.698 16.257C34.616 45.917 28.609 47 10.18 47c-2.063 0-4.28-.014-6.672-.036l-2.455-.023-.022-2.454c-.017-1.9-.028-3.692-.031-5.382v-1.86c.034-17.986 1.153-23.92 6.764-29.524 8.973-8.962 23.568-8.962 32.537 0zM11.3 11.255C7.052 15.498 6.02 19.678 6 37.68v1.181c.002 1 .006 2.041.013 3.125 1.3.01 2.538.014 3.719.015h1.16c17.512-.028 21.655-1.085 25.873-5.299C40.142 33.332 42 28.812 42 23.98c0-4.832-1.86-9.35-5.234-12.725-7.02-7.014-18.442-7.013-25.466.001zM30 13.5c1.987 0 3.754.745 5.251 2.214 1.541 1.512 2.297 3.308 2.246 5.338a7.618 7.618 0 01-2.246 5.213L24 37.5 12.731 26.249c-1.454-1.427-2.232-3.252-2.232-5.26 0-2.007.778-3.832 2.248-5.275C14.243 14.244 16.01 13.5 18 13.5c2.157 0 4.361.848 5.752 2.214l.248.247.232-.232c1.406-1.381 3.61-2.23 5.768-2.23zm0 4.993c-.815 0-1.802.343-2.249.782L24 23.023l-3.768-3.763c-.43-.424-1.419-.767-2.232-.767-.667 0-1.189.233-1.747.782-.513.504-.753 1.049-.753 1.715 0 .666.24 1.21.753 1.713L24 30.44l7.732-7.722a2.608 2.608 0 00.768-1.79c.013-.553-.108-1.021-.752-1.653-.552-.542-1.09-.783-1.748-.783z",
  fillRule: "evenodd"
});

function SvgHeartBubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1P({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1P);
}

function _extends$1O() { _extends$1O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1O.apply(this, arguments); }

var _ref$1O = /*#__PURE__*/React.createElement("path", {
  d: "M4.302 23.807C2.173 21.624 1 18.71 1 15.6c0-3.111 1.173-6.026 3.302-8.21A11.128 11.128 0 0112.324 4c3.041 0 5.892 1.206 8.028 3.396l3.641 3.733 3.648-3.74A11.124 11.124 0 0135.662 4c3.04 0 5.89 1.204 8.023 3.389 4.417 4.528 4.417 11.897 0 16.423L23.993 44 4.302 23.807z",
  fillRule: "evenodd"
});

function SvgHeartFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1O({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1O);
}

function _extends$1N() { _extends$1N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1N.apply(this, arguments); }

var _ref$1N = /*#__PURE__*/React.createElement("path", {
  xmlns: "http://www.w3.org/2000/svg",
  d: "M35.662 4l.35.005a11.128 11.128 0 017.674 3.385l.225.237c4.19 4.543 4.116 11.738-.225 16.186L23.994 44.001 4.303 23.807l-.242-.255C2.085 21.4 1 18.59 1 15.599l.005-.358c.087-2.975 1.25-5.751 3.298-7.851l.25-.248A11.111 11.111 0 0112.323 4l.35.005a11.126 11.126 0 017.678 3.392l3.642 3.733 3.647-3.74A11.12 11.12 0 0135.662 4zm0 5a6.163 6.163 0 00-4.442 1.88l-7.228 7.41-7.22-7.402A6.165 6.165 0 0012.324 9c-1.682 0-3.26.668-4.443 1.88-1.212 1.244-1.88 2.92-1.88 4.719 0 1.797.667 3.472 1.881 4.716L23.994 36.84l16.112-16.52c2.54-2.601 2.54-6.836 0-9.44A6.166 6.166 0 0035.662 9z"
});

function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1N({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1N);
}

function _extends$1M() { _extends$1M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1M.apply(this, arguments); }

var _ref$1M = /*#__PURE__*/React.createElement("path", {
  d: "M35 16.054v21.45c0 .804-.562 1.5-1.5 1.5h-19c-.78 0-1.5-.661-1.5-1.5V16.009l11-6.87 11 6.916zm-30-.953L1 17.61l2.637 4.24L8 19.135v18.37c0 3.584 2.916 6.5 6.5 6.5h19c3.584 0 6.5-2.916 6.5-6.5v-18.37l4.366 2.728 2.632-4.228L26.114 4.606a4 4 0 00-4.23-.003L5 15.101z",
  fillRule: "evenodd"
});

function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1M({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1M);
}

function _extends$1L() { _extends$1L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1L.apply(this, arguments); }

var _ref$1L = /*#__PURE__*/React.createElement("path", {
  d: "M40.5 1C44.084 1 47 3.916 47 7.5v33c0 3.584-2.916 6.5-6.5 6.5h-33A6.508 6.508 0 011 40.5v-33C1 3.916 3.916 1 7.5 1zM14.877 24.464L6 33.368V40.5c0 .827.673 1.5 1.5 1.5h33c.827 0 1.5-.673 1.5-1.5v-3.167l-8.744-8.765-7.149 7.171-11.23-11.275zM40.5 6h-33C6.673 6 6 6.673 6 7.5v18.786l8.878-8.906 11.231 11.275 7.145-7.167L42 30.255V7.5c0-.827-.673-1.5-1.5-1.5zm-13 4a4.5 4.5 0 110 9 4.5 4.5 0 010-9z",
  fillRule: "evenodd"
});

function SvgImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1L({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1L);
}

function _extends$1K() { _extends$1K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1K.apply(this, arguments); }

var _ref$1K = /*#__PURE__*/React.createElement("path", {
  d: "M41.002 1C44.365 1 47 3.635 47 6.999v24.996C47 35.704 43.887 38 41.002 38H38v3l-.004.225A6 6 0 0132 47.001H7l-.225-.004A6 6 0 011 41V16l.004-.225A6 6 0 017 10h3V6.999C10 3.635 12.636 1 16 1h25.002zM11.966 29.834L6 35.82V41a1 1 0 001 1h25a1 1 0 001-1v-3.332l-3.991-3.917-7.077 5.118-9.966-9.035zM41.002 6H16c-.617 0-1 .383-1 .999V10h17l.225.004A6 6 0 0138 16v17h3.002c.198 0 .998-.179.998-1.005V6.999c0-.616-.383-.999-.998-.999zM32 15H7a1 1 0 00-1 1v12.736l5.79-5.81 10.497 9.515 7.212-5.216L33 30.662V16a1 1 0 00-1-1zm-8.5 4l.192.005a3.502 3.502 0 013.309 3.495l-.005.192A3.501 3.501 0 0123.5 26l-.192-.005A3.5 3.5 0 0123.5 19z",
  fillRule: "evenodd"
});

function SvgImages(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1K({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1K);
}

function _extends$1J() { _extends$1J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1J.apply(this, arguments); }

var _ref$1J = /*#__PURE__*/React.createElement("path", {
  d: "M24 1c12.683 0 23 10.318 23 23 0 12.683-10.317 23-23 23C11.318 47 1 36.683 1 24 1 11.318 11.318 1 24 1zm2.5 17h-5v20h5V18zM24 9a3 3 0 100 6 3 3 0 000-6z",
  fillRule: "evenodd"
});

function SvgInfoCircleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1J({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1J);
}

function _extends$1I() { _extends$1I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1I.apply(this, arguments); }

var _ref$1I = /*#__PURE__*/React.createElement("path", {
  d: "M24 1c12.683 0 23 10.318 23 23 0 12.683-10.317 23-23 23C11.318 47 1 36.683 1 24 1 11.318 11.318 1 24 1zm0 5C14.075 6 6 14.075 6 24s8.075 18 18 18 18-8.075 18-18S33.925 6 24 6zm2.5 12v20h-5V18h5zM24 9a3 3 0 110 6 3 3 0 010-6z",
  fillRule: "evenodd"
});

function SvgInfoCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1I({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1I);
}

function _extends$1H() { _extends$1H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1H.apply(this, arguments); }

var _ref$1H = /*#__PURE__*/React.createElement("path", {
  d: "M32 3c7.732 0 14 6.267 14 13.998 0 7.731-6.268 13.998-14 13.998-2.878 0-5.554-.868-7.778-2.357l-.056.056-.025.024-.358.359-.064.065-.304.305-.088.087-.187.189-.1.1-.216.216-.355.356-.26.26-.422.424-.304.305-.159.16-.33.33-.716.718-.384.386L6.91 46l-3.527-3.535 3.962-3.971L1 32.132l3.527-3.535 6.344 6.361 2.955-2.962-4.733-4.739 3.536-3.538 4.726 4.74.437-.436 1.58-1.581.605-.606.41-.41.187-.187.063-.062A13.933 13.933 0 0118 16.998C18 9.268 24.268 3 32 3zm0 5a9 9 0 100 18 9 9 0 000-18z",
  fillRule: "evenodd"
});

function SvgKeyword(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1H({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1H);
}

function _extends$1G() { _extends$1G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1G.apply(this, arguments); }

var _ref$1G = /*#__PURE__*/React.createElement("path", {
  d: "M24 1l.38.003c12.403.201 22.418 10.218 22.617 22.62L47 24l-.003.38c-.201 12.402-10.218 22.418-22.62 22.617L24 47l-.38-.003C11.093 46.794 1 36.575 1 24 1 11.297 11.298 1 24 1zm3.705 31h-7.398c.647 3.289 1.673 6.615 3.08 9.99l.282.007L24 42l.33-.003.297-.008c1.405-3.374 2.431-6.7 3.078-9.988zm-12.452 0H7.871a18.063 18.063 0 009.712 8.822 54.684 54.684 0 01-2.33-8.821zm24.876 0h-7.37a54.575 54.575 0 01-2.33 8.818A18.063 18.063 0 0040.13 32zM14.668 20H6.446a18.121 18.121 0 00-.197 7.002h8.392A47.053 47.053 0 0114.668 20zm13.7 0h-8.723a41.324 41.324 0 00-.031 7.001h8.784c.188-2.349.177-4.681-.03-7zm13.186 0h-8.21c.183 2.322.191 4.656.026 7.002h8.38c.147-.87.23-1.76.247-2.668L42 24l-.003-.33a18.037 18.037 0 00-.443-3.67zM17.481 7.217l-.12.047A18.066 18.066 0 008.408 15h6.925a49.227 49.227 0 012.148-7.783zM24 6l-.33.003-.316.008c-1.322 2.986-2.305 5.98-2.95 8.99h7.204c-.645-3.01-1.628-6.003-2.95-8.989C24.44 6.004 24.22 6 24 6zm6.533 1.222l.06.165A49.181 49.181 0 0132.678 15h6.914a18.065 18.065 0 00-9.06-7.779z",
  fillRule: "evenodd"
});

function SvgLanguage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1G({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1G);
}

function _extends$1F() { _extends$1F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1F.apply(this, arguments); }

var _ref$1F = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M29.979 8.03l-9.218 9.218-3.536-3.535 9.219-9.218C31.1-.162 38.649-.165 43.31 4.487c4.667 4.658 4.67 12.22.007 16.882l-9.205 9.205-3.536-3.535 9.206-9.206a6.932 6.932 0 00-9.803-9.803zM17.833 39.782l9.208-9.208 3.536 3.536-9.208 9.208c-4.657 4.656-12.205 4.66-16.866.008-4.667-4.659-4.671-12.22-.008-16.882l9.195-9.196 3.536 3.536-9.196 9.195a6.932 6.932 0 109.803 9.803zm-1.427-5.045l18.332-18.332-3.535-3.535L12.87 31.202l3.535 3.535z"
});

function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1F({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1F);
}

function _extends$1E() { _extends$1E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1E.apply(this, arguments); }

var _ref$1E = /*#__PURE__*/React.createElement("path", {
  d: "M7 33.5a3 3 0 110 6 3 3 0 010-6zm37 .499v5H15v-5h29zM7 20.5a3 3 0 110 6 3 3 0 010-6zm37 .499v5H15v-5h29zM7 7.5a3 3 0 110 6 3 3 0 010-6zM44 8v4.999H15V8h29z",
  fillRule: "evenodd"
});

function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1E({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1E);
}

function _extends$1D() { _extends$1D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1D.apply(this, arguments); }

var _ref$1D = /*#__PURE__*/React.createElement("path", {
  d: "M6 24H1C1 11.317 11.317 1 24 1v5C14.075 6 6 14.075 6 24",
  fillRule: "evenodd"
});

function SvgLoad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1D({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1D);
}

function _extends$1C() { _extends$1C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1C.apply(this, arguments); }

var _ref$1C = /*#__PURE__*/React.createElement("path", {
  d: "M24.007 1c4.916.001 9.775 1.997 13.333 5.475 3.648 3.567 5.659 8.372 5.66 13.527-.005 3.257-.651 5.696-2.23 8.427-2.645 4.578-7.9 9.874-15.034 16.856L23.983 47l-1.749-1.719C8.485 31.766 4.996 27.516 5 19.989c0-3.308.887-6.59 2.562-9.489C11 4.551 17.142 1 23.993 1h.014zm-.003 5h-.01c-5.045 0-9.569 2.617-12.103 7.002A13.993 13.993 0 0010 19.99c-.003 5.076 2.143 8.267 13.992 20.001 5.953-5.856 10.325-10.387 12.449-14.064C37.574 23.968 37.997 22.361 38 20c-.001-3.796-1.477-7.331-4.156-9.95-2.631-2.573-6.218-4.049-9.84-4.05zM24 11c4.963 0 9 4.038 9 9 0 4.963-4.037 9-9 9-4.962 0-9-4.037-9-9 0-4.962 4.038-9 9-9zm0 5c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4z",
  fillRule: "evenodd"
});

function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1C({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1C);
}

function _extends$1B() { _extends$1B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1B.apply(this, arguments); }

var _ref$1B = /*#__PURE__*/React.createElement("path", {
  d: "M36 11.954v7h5v23.5c0 2.481-2.019 4.5-4.5 4.5h-25a4.505 4.505 0 01-4.5-4.5v-23.5h5.015v-.124-.501l-.013-5.75v-.293L12 12.171v-.217C12-2.65 36-2.65 36 11.954zm0 12H12v18h24v-18zm-12 5.5a3 3 0 110 6 3 3 0 010-6zm7-17c0-8.662-14-8.662-14 0v.342l.001.14v.534l.001.21v.705l.001.254v.526l.001.269v.541l.001.269v.526l.001.254v.48l.001.224v.585l.001.16v.481H31z",
  fillRule: "evenodd"
});

function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1B({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1B);
}

function _extends$1A() { _extends$1A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1A.apply(this, arguments); }

var _ref$1A = /*#__PURE__*/React.createElement("path", {
  d: "M43.292 28.792l1.708.943-.496 1.882C42.08 40.817 33.84 47 24 47c-9.84 0-18.08-6.182-20.505-15.383L3 29.735l1.708-.943c12.791-7.056 25.795-7.056 38.584 0zM24 28.48c-4.946 0-9.993 1.255-15.029 3.734 2.388 5.924 8.2 9.782 15.029 9.782 6.829 0 12.64-3.858 15.028-9.782C33.992 29.734 28.945 28.48 24 28.48zM24 1c4.963 0 9 4.038 9 9s-4.037 9-9 9c-4.962 0-9-4.038-9-9s4.038-9 9-9zm0 5c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4z",
  fillRule: "evenodd"
});

function SvgLogin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1A({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1A);
}

function _extends$1z() { _extends$1z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1z.apply(this, arguments); }

var _ref$1z = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M37.84 16.197L23.73 6.973 9.618 16.198l14.11 10.011L37.84 16.197zM8 21.18v18.824a2 2 0 002 2h27.46a2 2 0 002-2V21.178L25.174 31.313 23.73 32.34l-1.447-1.027L8 21.18zm36.459-2.841a7 7 0 00-3.17-5.859L23.73 1 6.17 12.48A7 7 0 003 18.337v23.664a5 5 0 005 5h31.46a5 5 0 004.999-5V18.338z"
});

function SvgMailOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1z({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1z);
}

function _extends$1y() { _extends$1y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1y.apply(this, arguments); }

var _ref$1y = /*#__PURE__*/React.createElement("path", {
  d: "M40.5 37h-33c-.827 0-1.5-.673-1.5-1.5V16.24l17.999 12.292L42 16.241V35.5c0 .827-.673 1.5-1.5 1.5zm0-26c.092 0 .181.011.268.027L23.999 22.478 7.233 11.027c.087-.016.176-.027.267-.027h33zm0-5h-33A6.508 6.508 0 001 12.5v23C1 39.084 3.916 42 7.5 42h33c3.584 0 6.5-2.916 6.5-6.5v-23C47 8.916 44.084 6 40.5 6z",
  fillRule: "evenodd"
});

function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1y({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1y);
}

function _extends$1x() { _extends$1x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1x.apply(this, arguments); }

var _ref$1x = /*#__PURE__*/React.createElement("path", {
  d: "M42 26h-3v9H9v-9H6v14.5c0 .827.673 1.5 1.5 1.5h33c.827 0 1.5-.673 1.5-1.5V26zM14 6h20v24H14V6zM7.5 47A6.508 6.508 0 011 40.5V21h8V5a4 4 0 014-4h22a4 4 0 014 4v16h8v19.5c0 3.584-2.916 6.5-6.5 6.5h-33zM17 11h13v5H17v-5zm0 9h10v5H17v-5z",
  fillRule: "evenodd"
});

function SvgMailbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1x({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1x);
}

function _extends$1w() { _extends$1w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1w.apply(this, arguments); }

var _ref$1w = /*#__PURE__*/React.createElement("path", {
  d: "M42 33l-9 4.582V15l9-5.069V33zM6 15l9-4.582v22.613L6 38V15zm14-4.441L28 15v22.441L20 33V10.559zm25.34-6.033a3.471 3.471 0 00-3.405-.152l-11.392 6.183-11.401-6.139a3.5 3.5 0 00-3.225-.048L2.935 10.861A3.48 3.48 0 001 13.992v26.484a3.48 3.48 0 001.617 2.949 3.492 3.492 0 003.357.224l11.443-6.227 11.439 6.159a3.495 3.495 0 003.226.05l12.981-6.49A3.48 3.48 0 0047 34.009V7.504c0-1.222-.62-2.335-1.66-2.978z",
  fillRule: "evenodd"
});

function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1w({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1w);
}

function _extends$1v() { _extends$1v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1v.apply(this, arguments); }

var _ref$1v = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M33.095 15.013l-2.11 1.407-.052.032-8.032 5.451a4.576 4.576 0 00-1.401 1.68c-.3.65-.448 1.359-.43 2.074l-5 .118a9.681 9.681 0 01.906-4.322l.007-.016.008-.015a9.577 9.577 0 013.005-3.588l.03-.023 8.186-5.555.07-.044 2.15-1.433.052-.03a6.29 6.29 0 018.504 1.955l.01.014.01.015a5.999 5.999 0 01.581 5.22l-.03.087-5.006 11.322-.017.036c-.217.452-.47.885-.755 1.297l-4.11-2.848c.13-.186.244-.38.343-.584l4.885-11.05a1 1 0 00-.108-.792 1.29 1.29 0 00-1.696-.408z"
});

var _ref2$d = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M44.106 7.63l-6.151 7.154-3.792-3.26 6.152-7.154 3.791 3.26zM9.691 12.89a15 15 0 0113.08.224l.073.037 3.53 2.084-2.542 4.305-3.386-1.999A10 10 0 1016 36.5h22a4 4 0 003.82-5.187 3.998 3.998 0 00-1.319-1.932l-7.145-4.218 2.542-4.305 7.4 4.368.111.084A8.998 8.998 0 0138 41.5H16a15.001 15.001 0 01-6.309-28.61z"
});

function SvgMeat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1v({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1v, _ref2$d);
}

function _extends$1u() { _extends$1u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1u.apply(this, arguments); }

var _ref$1u = /*#__PURE__*/React.createElement("path", {
  d: "M37 20a4 4 0 110 8 4 4 0 010-8zm-13 0a4 4 0 110 8 4 4 0 010-8zm-13 0a4 4 0 110 8 4 4 0 010-8z"
});

function SvgMenuDotsHorizontal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1u({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1u);
}

function _extends$1t() { _extends$1t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1t.apply(this, arguments); }

var _ref$1t = /*#__PURE__*/React.createElement("path", {
  d: "M24 33a4 4 0 110 8 4 4 0 010-8zm0-13a4 4 0 110 8 4 4 0 010-8zm0-13a4 4 0 110 8 4 4 0 010-8z"
});

function SvgMenuDotsVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1t({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1t);
}

function _extends$1s() { _extends$1s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1s.apply(this, arguments); }

var _ref$1s = /*#__PURE__*/React.createElement("path", {
  d: "M33.048 15c6.093 0 11.05 4.957 11.05 11.049 0 2.456-.816 4.72-2.178 6.557l5.08 5.86-3.795 3.29-5.106-5.892a10.952 10.952 0 01-5.05 1.234C26.955 37.098 22 32.141 22 26.049S26.956 15 33.048 15zm0 5.023a6.033 6.033 0 00-6.026 6.026 6.033 6.033 0 006.026 6.026 6.033 6.033 0 006.027-6.026 6.033 6.033 0 00-6.027-6.026zM16 26v5H1v-5h15zm3-10v5H1v-5h18zM1.001 6L28 6.004v5L1 11l.001-5z",
  fillRule: "evenodd"
});

function SvgMenuMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1s({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1s);
}

function _extends$1r() { _extends$1r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1r.apply(this, arguments); }

var _ref$1r = /*#__PURE__*/React.createElement("path", {
  d: "M47 33.999v5H1v-5h46zm0-13v5H12v-5h35zM47 8v4.999H1V8h46z",
  fillRule: "evenodd"
});

function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1r({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1r);
}

function _extends$1q() { _extends$1q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1q.apply(this, arguments); }

var _ref$1q = /*#__PURE__*/React.createElement("path", {
  d: "M10.5 19c0 7.125 6.309 13.375 13.5 13.375S37.5 26.125 37.5 19h5c0 9.118-7.105 16.92-16 18.178V42H33v5H15v-5h6.5v-4.822c-8.894-1.258-16-9.06-16-18.178zM24 1c4.963 0 9 4.038 9 9v9c0 4.963-4.037 9-9 9-4.962 0-9-4.037-9-9v-9c0-4.962 4.038-9 9-9zm0 5c-2.206 0-4 1.794-4 4v9c0 2.206 1.794 4 4 4s4-1.794 4-4v-9c0-2.206-1.794-4-4-4z",
  fillRule: "evenodd"
});

function SvgMic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1q({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1q);
}

function _extends$1p() { _extends$1p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1p.apply(this, arguments); }

var _ref$1p = /*#__PURE__*/React.createElement("path", {
  d: "M42.5 19h-5c0 7.125-6.309 13.375-13.5 13.375S10.5 26.125 10.5 19h-5c0 9.118 7.106 16.92 16 18.178V42H15v5h18v-5h-6.5v-4.822c8.895-1.258 16-9.06 16-18.178"
});

var _ref2$c = /*#__PURE__*/React.createElement("path", {
  d: "M20 10c0-2.206 1.794-4 4-4s4 1.794 4 4v9c0 2.206-1.794 4-4 4s-4-1.794-4-4v-9zm4 18c4.963 0 9-4.037 9-9v-9c0-4.962-4.037-9-9-9-4.962 0-9 4.038-9 9v9c0 4.963 4.038 9 9 9z"
});

function SvgMicrophone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1p({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1p, _ref2$c);
}

function _extends$1o() { _extends$1o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1o.apply(this, arguments); }

var _ref$1o = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M1 26h46v-5H1z"
});

function SvgMinus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1o({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1o);
}

function _extends$1n() { _extends$1n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1n.apply(this, arguments); }

var _ref$1n = /*#__PURE__*/React.createElement("path", {
  d: "M32.5 2A6.5 6.5 0 0139 8.5v31a6.5 6.5 0 01-6.5 6.5h-16a6.5 6.5 0 01-6.5-6.5v-31A6.5 6.5 0 0116.5 2h16zm0 5h-16A1.5 1.5 0 0015 8.5v31a1.5 1.5 0 001.5 1.5h16a1.5 1.5 0 001.5-1.5v-31A1.5 1.5 0 0032.5 7zm-8 24a3 3 0 110 6 3 3 0 010-6z"
});

function SvgMobilePhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1n({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1n);
}

function _extends$1m() { _extends$1m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1m.apply(this, arguments); }

var _ref$1m = /*#__PURE__*/React.createElement("path", {
  d: "M20 42h22V20H20v22zm22.5 5h-23a4.505 4.505 0 01-4.5-4.5v-23c0-2.481 2.018-4.5 4.5-4.5h23c2.48 0 4.5 2.019 4.5 4.5v23c0 2.481-2.02 4.5-4.5 4.5z"
});

var _ref2$b = /*#__PURE__*/React.createElement("path", {
  d: "M11 33H5.5A4.505 4.505 0 011 28.5v-23C1 3.019 3.018 1 5.5 1h23C30.981 1 33 3.019 33 5.5V11h-5V6H6v22h5v5z"
});

function SvgMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1m({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1m, _ref2$b);
}

function _extends$1l() { _extends$1l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1l.apply(this, arguments); }

var _ref$1l = /*#__PURE__*/React.createElement("path", {
  d: "M42.5 2C44.981 2 47 4.019 47 6.5V35H35v12H1V18.5C1 16.019 3.019 14 5.5 14H12V6.5C12 4.019 14.019 2 16.5 2h26zM12 19H6v23h24v-7H12V19zm5 11h25V7H17v23zm15-19v5h5v5h-5v5h-5v-5h-5v-5h5v-5h5z",
  fillRule: "evenodd"
});

function SvgNewTab(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1l({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1l);
}

function _extends$1k() { _extends$1k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1k.apply(this, arguments); }

var _ref$1k = /*#__PURE__*/React.createElement("path", {
  d: "M28.5 1C32.084 1 35 3.916 35 7.5v4.314l12 6.721V47H1V7.5C1 3.916 3.916 1 7.5 1h21zm0 5h-21C6.687 6 6 6.687 6 7.5V42h24V7.5c0-.827-.673-1.5-1.5-1.5zM35 17.545V42h7V21.465l-7-3.92zM16 30v5h-5v-5h5zm9 0v5h-5v-5h5zm-9-9v5h-5v-5h5zm9 0v5h-5v-5h5zm-9-9v5h-5v-5h5zm9 0v5h-5v-5h5z",
  fillRule: "evenodd"
});

function SvgOffice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1k({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1k);
}

function _extends$1j() { _extends$1j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1j.apply(this, arguments); }

var _ref$1j = /*#__PURE__*/React.createElement("path", {
  d: "M40.5 1C44.084 1 47 3.916 47 7.5v33c0 3.584-2.916 6.5-6.5 6.5h-33A6.508 6.508 0 011 40.5v-33C1 3.916 3.916 1 7.5 1zm0 5h-33C6.673 6 6 6.673 6 7.5v33c0 .628.788 1.5 1.5 1.5h33c.789 0 1.5-.647 1.5-1.5v-33c0-.827-.673-1.5-1.5-1.5zm-15.494 6c10.839 0 10.477 16 0 16h-4.003v8H16V12h9.006zM25 17h-4v6h3.998c3.944 0 3.944-6 .002-6z",
  fillRule: "evenodd"
});

function SvgParking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1j({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1j);
}

function _extends$1i() { _extends$1i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1i.apply(this, arguments); }

var _ref$1i = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.49 8.893c-1.558.32-3.217 1.37-4.213 2.365-.995.997-2.043 2.657-2.364 4.217-.154.747-.118 1.353.05 1.828.156.44.484.939 1.239 1.42l.007.004 11.477 7.371c1.675 1.03 2.782 1.553 3.62 1.683.573.089 1.07.02 1.785-.696.715-.716.785-1.213.696-1.788-.13-.84-.654-1.948-1.683-3.624l-7.37-11.49c-.482-.756-.98-1.084-1.42-1.24-.473-.168-1.078-.204-1.823-.05zm7.458-1.4c-1.028-1.613-2.386-2.703-3.96-3.262-1.542-.547-3.11-.523-4.506-.235-2.725.561-5.223 2.209-6.741 3.728-1.518 1.52-3.165 4.018-3.726 6.743-.287 1.397-.31 2.965.236 4.507.558 1.575 1.646 2.933 3.259 3.962l.004.003 11.51 7.393.022.013c1.672 1.028 3.553 2.076 5.495 2.377 2.211.343 4.288-.303 6.086-2.102 1.798-1.8 2.443-3.876 2.1-6.087-.3-1.942-1.347-3.825-2.375-5.498l-.013-.02-7.388-11.518-.003-.004z"
});

var _ref2$a = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.824 19.46c1.414-.142 2.84.209 4.176 1.06l-2.686 4.217c-.468-.298-.783-.323-.993-.302-.25.024-.582.142-.99.447-.868.65-1.621 1.812-1.957 2.735-.336.925-.503 2.288-.255 3.33.115.487.293.786.467.963.148.15.408.334.963.407l.008.001 10.283 1.388c1.484.17 2.306.158 2.799.014.19-.055.27-.115.319-.16.052-.05.17-.184.294-.526.12-.33.112-.498.104-.563-.007-.061-.032-.163-.152-.337-.306-.447-.958-.996-2.226-1.832l2.755-4.173c1.237.817 2.67 1.832 3.592 3.173 1.077 1.566 1.362 3.417.626 5.44-.724 1.992-2.09 3.248-3.916 3.78-1.564.455-3.309.32-4.791.149l-.024-.003-10.324-1.394h-.004c-1.564-.207-2.878-.849-3.87-1.858-.968-.984-1.499-2.18-1.768-3.313-.523-2.2-.168-4.574.42-6.194.59-1.622 1.85-3.675 3.664-5.032.934-.698 2.11-1.28 3.486-1.418zM37.281 6.894V6.9l1.394 10.33.002.024c.17 1.483.306 3.228-.149 4.792-.53 1.825-1.785 3.193-3.777 3.918-2.023.736-3.875.45-5.44-.627-1.341-.922-2.356-2.356-3.172-3.595l4.174-2.752c.837 1.269 1.386 1.921 1.831 2.228.174.12.275.144.336.151.064.008.232.016.561-.104.341-.124.475-.242.524-.294.046-.048.106-.129.162-.32.143-.493.156-1.317-.014-2.802L32.324 7.55c-.073-.555-.257-.816-.407-.964-.177-.174-.476-.352-.962-.468-1.04-.247-2.401-.08-3.325.256-.922.335-2.084 1.09-2.733 1.958-.304.408-.423.741-.448.992-.02.212.005.528.303.996l-4.218 2.684c-.851-1.337-1.2-2.762-1.06-4.176.137-1.376.719-2.552 1.416-3.487 1.356-1.816 3.409-3.075 5.03-3.666 1.62-.589 3.993-.944 6.192-.42 1.133.269 2.33.8 3.313 1.768 1.009.993 1.65 2.307 1.856 3.871z"
});

var _ref3$2 = /*#__PURE__*/React.createElement("path", {
  d: "M37.791 11.076a5.64 5.64 0 01.374-.036c2.028-.129 3.742.863 3.828 2.215a1.7 1.7 0 01.003.105c0 1.309-1.545 2.45-3.52 2.577l-.062.003-.623-4.864zm-26.72 26.71l4.862.623-.004.062c-.125 1.976-1.267 3.522-2.575 3.522a1.62 1.62 0 01-.105-.003c-1.351-.086-2.342-1.8-2.214-3.83.008-.127.02-.251.037-.374zm-4.96-.653c-.031.233-.054.47-.07.71a9.788 9.788 0 001.214 5.467 7.064 7.064 0 005.677 3.677c.141.009.282.013.422.013 4.018 0 7.272-3.53 7.57-8.212l.006-.115-1.712-2.718-3.452-.987-4.509-.035H7.453l-1.343 2.2zM34.94 7.455v3.807l.035 4.511.986 3.454 2.717 1.713.115-.007C43.472 20.636 47 17.38 47 13.36c0-.14-.004-.281-.013-.422a7.068 7.068 0 00-3.675-5.68 9.773 9.773 0 00-5.464-1.215c-.24.015-.476.038-.71.069L34.94 7.455z"
});

function SvgPastries(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1i({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1i, _ref2$a, _ref3$2);
}

function _extends$1h() { _extends$1h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1h.apply(this, arguments); }

var _ref$1h = /*#__PURE__*/React.createElement("path", {
  d: "M27 33h5V15h-5v18zm-11 0h5V15h-5v18zm8-32C11.297 1 1 11.297 1 24c0 12.702 10.297 23 23 23 12.702 0 23-10.298 23-23C47 11.297 36.702 1 24 1z",
  fillRule: "evenodd"
});

function SvgPauseCircleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1h({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1h);
}

function _extends$1g() { _extends$1g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1g.apply(this, arguments); }

var _ref$1g = /*#__PURE__*/React.createElement("path", {
  d: "M24 1c12.683 0 23 10.318 23 23 0 12.683-10.317 23-23 23C11.318 47 1 36.683 1 24 1 11.318 11.318 1 24 1zm0 5C14.075 6 6 14.075 6 24s8.075 18 18 18 18-8.075 18-18S33.925 6 24 6zm-3 9v18h-5V15h5zm11 0v18h-5V15h5z",
  fillRule: "evenodd"
});

function SvgPauseCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1g({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1g);
}

function _extends$1f() { _extends$1f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1f.apply(this, arguments); }

var _ref$1f = /*#__PURE__*/React.createElement("path", {
  d: "M20 5v38h-6V5h6zm14 0v38h-6V5h6z",
  fillRule: "evenodd"
});

function SvgPause(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1f({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1f);
}

function _extends$1e() { _extends$1e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1e.apply(this, arguments); }

var _ref$1e = /*#__PURE__*/React.createElement("path", {
  d: "M7.75 9.212a4.152 4.152 0 015.865 0l7.295 7.296a4.152 4.152 0 010 5.865l-2.322 2.322c1.229 2.01 2.686 3.463 4.719 4.71l2.318-2.317a4.114 4.114 0 012.932-1.215c1.107 0 2.15.432 2.933 1.215l7.295 7.296A4.122 4.122 0 0140 37.317c0 1.108-.432 2.15-1.216 2.933l-4.334 4.334C33.241 45.794 31.225 47 27.99 47c-1.264 0-2.716-.184-4.378-.626-3.565-.946-6.757-2.716-8.081-3.612A38.336 38.336 0 015.238 32.466c-.897-1.323-2.666-4.516-3.612-8.08-1.569-5.91.106-9.157 1.788-10.838zm2.933 4.14L6.95 17.083c-2.586 2.585.646 9.945 2.429 12.58a33.298 33.298 0 008.956 8.955c2.633 1.783 9.99 5.015 12.58 2.43l3.731-3.733-6.089-6.089-4.321 4.321-1.613-.81c-4.402-2.21-7.205-5.014-9.368-9.374l-.798-1.609 4.315-4.315-6.089-6.089zM35.731 1l3.537 3.529-5.73 5.724H47v4.992H33.533l5.734 5.723-3.535 3.532-10-9.981a2.497 2.497 0 010-3.53l10-9.989z",
  fillRule: "evenodd"
});

function SvgPhoneCallback(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1e({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1e);
}

function _extends$1d() { _extends$1d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1d.apply(this, arguments); }

var _ref$1d = /*#__PURE__*/React.createElement("path", {
  d: "M12.146 6.213L7.28 11.08c-3.267 3.267.318 12.063 2.868 15.83A40.743 40.743 0 0021.09 37.852c3.765 2.55 12.56 6.135 15.828 2.868l4.867-4.867-8.075-8.075-5.313 5.314-1.613-.809c-5.204-2.613-8.515-5.925-11.072-11.077l-.799-1.61 5.308-5.308-8.074-8.075zM33.067 47c-5.803 0-12.222-3.272-14.782-5.005a45.73 45.73 0 01-12.28-12.28c-2.56-3.78-8.468-15.967-2.263-22.172l5.23-5.23a4.493 4.493 0 016.347 0l8.802 8.801a4.494 4.494 0 010 6.348l-3.087 3.085c1.64 2.798 3.591 4.747 6.421 6.413l3.082-3.082a4.49 4.49 0 016.346 0l8.801 8.801A4.456 4.456 0 0147 35.853c0 1.2-.467 2.327-1.317 3.175l-5.228 5.228c-2 2.002-4.625 2.744-7.388 2.744z",
  fillRule: "evenodd"
});

function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1d({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1d);
}

function _extends$1c() { _extends$1c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1c.apply(this, arguments); }

var _ref$1c = /*#__PURE__*/React.createElement("path", {
  d: "M11.457 2l9.616 4.806A25.055 25.055 0 0126 6.315c11.58 0 21 7.847 21 17.493 0 3.939-1.59 7.743-4.5 10.82V46h-14v-4.627a24.06 24.06 0 01-4.5.044V46H10V35.132a17.516 17.516 0 01-2.674-3.327H4.5c-1.93 0-3.5-1.57-3.5-3.499V19.31a3.504 3.504 0 013.5-3.499h2.826a17.528 17.528 0 012.841-3.489L11.457 2zm4.085 7.63l-.648 5.183-.729.629c-1.357 1.17-2.406 2.503-3.117 3.963l-.684 1.404H6v5.998h4.364l.684 1.405c.705 1.447 1.745 2.772 3.09 3.937l.862.748v8.105h4v-5.723l2.997.609c2.899.588 5.663.541 8.448-.092l3.055-.695v5.901h4V32.51l.788-.74C40.682 29.522 42 26.695 42 23.808c0-6.89-7.178-12.495-16-12.495-1.567 0-3.139.186-4.671.554l-.887.212-4.9-2.449zM33 16.816v5H20.5v-5H33z"
});

function SvgPiggybank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1c({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1c);
}

function _extends$1b() { _extends$1b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1b.apply(this, arguments); }

var _ref$1b = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M35.19 8.321l2.626 2.626 2.626 2.625-1.794 1.794-8.081 8.08-.726.727-.006 1.026-.048 7.56-6.892-6.891-6.892-6.892 7.561-.048 1.026-.006.726-.726 8.081-8.081 1.794-1.794zm9.336 2.264l-3.174-3.174-3.174-3.174a4.224 4.224 0 00-5.974 0l-.425.425-1.917 1.917-7.356 7.356-8.391.053c-3.75.024-5.612 4.559-2.96 7.21l6.437 6.439-.903.903L3.732 41.497a2.5 2.5 0 003.536 3.535l12.957-12.957.903-.903 6.436 6.436c2.652 2.652 7.187.79 7.21-2.96l.054-8.391 7.356-7.356 1.917-1.917.425-.425a4.224 4.224 0 000-5.974z"
});

function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1b({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$1b);
}

function _extends$1a() { _extends$1a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1a.apply(this, arguments); }

var _ref$1a = /*#__PURE__*/React.createElement("path", {
  d: "M24 1c12.702 0 23 10.297 23 23 0 12.702-10.298 23-23 23C11.297 47 1 36.702 1 24 1 11.297 11.297 1 24 1zm-4.224 11.351a2.496 2.496 0 00-2.513-.024A2.502 2.502 0 0016 14.5v19a2.499 2.499 0 003.776 2.149l16-9.5a2.5 2.5 0 000-4.299zM21 18.892L29.604 24 21 29.108V18.892z",
  fillRule: "evenodd"
});

function SvgPlayCircleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1a({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1a);
}

function _extends$19() { _extends$19 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$19.apply(this, arguments); }

var _ref$19 = /*#__PURE__*/React.createElement("path", {
  d: "M24 1c12.683 0 23 10.318 23 23 0 12.683-10.317 23-23 23C11.318 47 1 36.683 1 24 1 11.318 11.318 1 24 1zm0 5C14.075 6 6 14.075 6 24s8.075 18 18 18 18-8.075 18-18S33.925 6 24 6zm-4.224 6.35l16 9.5a2.5 2.5 0 010 4.3l-16 9.5A2.5 2.5 0 0116 33.5v-19a2.5 2.5 0 013.776-2.15zM21 18.894v10.216l8.604-5.11L21 18.894z",
  fillRule: "evenodd"
});

function SvgPlayCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$19({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$19);
}

function _extends$18() { _extends$18 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$18.apply(this, arguments); }

var _ref$18 = /*#__PURE__*/React.createElement("path", {
  d: "M38.774 21.849l-27-16A2.501 2.501 0 008 7.999V40a2.501 2.501 0 003.774 2.15l27-16a2.498 2.498 0 000-4.301",
  fillRule: "evenodd"
});

function SvgPlayFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$18({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$18);
}

function _extends$17() { _extends$17 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$17.apply(this, arguments); }

var _ref$17 = /*#__PURE__*/React.createElement("path", {
  d: "M13 12.888v23.225L32.596 24.5 13 12.888zM10.5 43A2.497 2.497 0 018 40.5v-32a2.501 2.501 0 013.774-2.151l27 16a2.501 2.501 0 010 4.302l-27 16A2.492 2.492 0 0110.5 43z",
  fillRule: "evenodd"
});

function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$17({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$17);
}

function _extends$16() { _extends$16 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$16.apply(this, arguments); }

var _ref$16 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M21.5 1v20.5H1v5h20.5V47h4.999V26.5H47v-5H26.499V1z"
});

function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$16({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$16);
}

function _extends$15() { _extends$15 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$15.apply(this, arguments); }

var _ref$15 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M47 24c0 12.703-10.297 23-23 23S1 36.703 1 24 11.297 1 24 1s23 10.297 23 23zm-40.889.213c0-9.998 8.104-18.102 18.102-18.102 9.998 0 18.102 8.104 18.102 18.102h-4.526c0-7.498-6.079-13.576-13.576-13.576-7.497 0-13.577 6.078-13.577 13.576s6.079 13.576 13.577 13.576v4.526c-9.998 0-18.102-8.104-18.102-18.102zm18.102 10.861c-5.998 0-10.861-4.863-10.861-10.861s4.863-10.861 10.86-10.861c5.999 0 10.862 4.863 10.862 10.861h-3.95a6.91 6.91 0 10-6.911 6.912v3.95z"
});

function SvgPocketcasts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$15({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$15);
}

function _extends$14() { _extends$14 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$14.apply(this, arguments); }

var _ref$14 = /*#__PURE__*/React.createElement("path", {
  d: "M26.803 28.085V47h-5.605V28.085a5.87 5.87 0 01-3.092-5.17c0-3.243 2.64-5.874 5.894-5.874 3.255 0 5.894 2.63 5.894 5.875a5.87 5.87 0 01-3.091 5.17zM15.72 6.166a2.193 2.193 0 001-2.94 2.206 2.206 0 00-2.95-.999C9.317 4.417 5.852 8.041 3.663 12.308a24.083 24.083 0 00-2.65 10.197c-.112 3.568.594 7.173 2.235 10.49 2.022 4.087 5.45 7.723 10.497 10.296a2.203 2.203 0 002.96-.955 2.188 2.188 0 00-.958-2.949c-4.132-2.106-6.92-5.047-8.548-8.334-1.312-2.653-1.877-5.544-1.787-8.41a19.69 19.69 0 012.167-8.34c1.772-3.451 4.563-6.378 8.142-8.137zm18.51-3.939a2.207 2.207 0 00-2.95.998 2.193 2.193 0 001 2.941c3.58 1.76 6.37 4.685 8.142 8.138a19.686 19.686 0 012.167 8.339c.09 2.866-.475 5.757-1.787 8.41-1.627 3.287-4.416 6.228-8.548 8.334a2.189 2.189 0 00-.957 2.95 2.203 2.203 0 002.959.954c5.046-2.573 8.475-6.209 10.497-10.296 1.641-3.317 2.347-6.922 2.236-10.49a24.088 24.088 0 00-2.65-10.197c-2.19-4.267-5.654-7.89-10.11-10.08zm-2.237 9.663a1.837 1.837 0 00-2.56.416 1.824 1.824 0 00.418 2.551c.33.238.656.505.974.796a9.969 9.969 0 013.197 6.404c.234 2.434-.416 5.014-2.066 7.295-.28.388-.603.781-.968 1.176a1.826 1.826 0 00.108 2.586 1.842 1.842 0 002.595-.107 16.12 16.12 0 001.241-1.52c2.195-3.036 3.057-6.492 2.741-9.775a13.625 13.625 0 00-4.36-8.752c-.4-.367-.84-.724-1.32-1.07zM18.15 14.858a1.824 1.824 0 00.417-2.551 1.838 1.838 0 00-2.56-.416c-.48.346-.92.702-1.319 1.069a13.624 13.624 0 00-4.36 8.753c-.316 3.282.546 6.739 2.74 9.776.387.534.8 1.041 1.242 1.519a1.842 1.842 0 002.595.107 1.826 1.826 0 00.108-2.587 12.696 12.696 0 01-.968-1.175c-1.65-2.282-2.3-4.861-2.066-7.296a9.97 9.97 0 013.197-6.403c.319-.291.643-.558.974-.796z"
});

function SvgPodcast(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$14({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$14);
}

function _extends$13() { _extends$13 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$13.apply(this, arguments); }

var _ref$13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24 47c12.703 0 23-10.297 23-23S36.703 1 24 1 1 11.297 1 24s10.297 23 23 23zm.174-39.03c-.866 0-1.568.702-1.568 1.568V29.4a1.568 1.568 0 103.136 0V9.538c0-.866-.702-1.568-1.568-1.568zM30.1 24c-.867 0-1.569.702-1.569 1.568v12.546a1.568 1.568 0 103.137 0V25.568c0-.866-.702-1.568-1.569-1.568zm4.356 1.568a1.568 1.568 0 113.136 0v5.576a1.568 1.568 0 11-3.136 0v-5.576zM18.25 13.197c-.866 0-1.568.702-1.568 1.568v7.667a1.568 1.568 0 103.136 0v-7.667c0-.866-.702-1.568-1.568-1.568zm-7.492 7.492a1.568 1.568 0 113.136 0v5.925a1.568 1.568 0 11-3.136 0v-5.925zM6.402 24c-.867 0-1.569.702-1.569 1.568v1.046a1.568 1.568 0 103.137 0v-1.046c0-.866-.702-1.568-1.568-1.568zm33.977 1.568a1.568 1.568 0 113.136 0v1.046a1.568 1.568 0 11-3.136 0v-1.046z"
});

function SvgPodigee(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$13({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$13);
}

function _extends$12() { _extends$12 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$12.apply(this, arguments); }

var _ref$12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 27.63V3.261C6 2.565 6.562 2 7.254 2c7.01 0 12.693 5.717 12.693 12.768v1.355c0 7.052-5.683 12.768-12.693 12.768A1.258 1.258 0 016 27.63zm16.818 9.62V3.735A1.73 1.73 0 0124.543 2C34.184 2 42 9.862 42 19.561v1.863c0 9.699-7.816 17.561-17.457 17.561a1.73 1.73 0 01-1.725-1.735zm-2.871 1.735c0 3.874-3.122 7.015-6.973 7.015C9.121 46 6 42.86 6 38.985c0-3.874 3.122-7.015 6.973-7.015 3.852 0 6.974 3.14 6.974 7.015z"
});

function SvgPodimo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$12({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$12);
}

function _extends$11() { _extends$11 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$11.apply(this, arguments); }

var _ref$11 = /*#__PURE__*/React.createElement("path", {
  d: "M16 7.667V13.3c-4.207 2.66-7 7.365-7 12.7 0 8.27 6.73 15 15 15s15-6.73 15-15c0-5.33-2.8-10.038-7.002-12.7V7.67C39.059 10.76 44 17.813 44 26c0 11.029-8.971 20-20 20-11.028 0-20-8.971-20-20 0-8.188 4.939-15.242 12-18.333zm5.5 5.633V2h5v11.299l5.498.001h-.011l-2.489.001H26.5V21h-5v-7.699l-5.222-.001H21.5z",
  fillRule: "evenodd"
});

function SvgPower(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$11({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$11);
}

function _extends$10() { _extends$10 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$10.apply(this, arguments); }

var _ref$10 = /*#__PURE__*/React.createElement("path", {
  d: "M42 32.5c0 .827-.673 1.5-1.5 1.5H37v-9H11v9H7.5c-.827 0-1.5-.673-1.5-1.5v-12c0-.827.673-1.5 1.5-1.5h33c.827 0 1.5.673 1.5 1.5v12zM16 42h16V30H16v12zm-3-28h22V6H13v8zm27.5 0H40V1H8v13h-.5A6.508 6.508 0 001 20.5v12C1 36.084 3.916 39 7.5 39H11v8h26v-8h3.5c3.584 0 6.5-2.916 6.5-6.5v-12c0-3.584-2.916-6.5-6.5-6.5z",
  fillRule: "evenodd"
});

function SvgPrinter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$10({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$10);
}

function _extends$$() { _extends$$ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$$.apply(this, arguments); }

var _ref$$ = /*#__PURE__*/React.createElement("path", {
  d: "M6.05 27C7.286 34.035 12.467 39.94 20 41.6v.004l.001 4.848V46.684C9.721 44.876 2.483 36.873 1.053 27.376L1 27h5.05zm31.017 5.487l.336.157.458.216 1.243.584.452.212 2.037.957C38.41 40.725 32.519 45.362 25 46.684l.001-4.852V41.6c5.46-1.203 9.684-4.636 12.066-9.113zM35.497 1a11.81 11.81 0 018.028 3.182C45.765 6.298 46.999 9.15 47 12.21c-.003 1.96-.445 3.564-1.433 5.213-1.342 2.245-3.721 4.569-6.935 7.608L35.488 28l-3.137-2.976c-5.792-5.5-8.353-8.128-8.35-12.818 0-1.97.542-3.921 1.57-5.64C27.659 3.08 31.369 1 35.498 1zM22.5 21.5a3 3 0 110 6 3 3 0 010-6zM20.001 2.324v5.069L20 7.41c-7.532 1.659-12.713 7.565-13.95 14.6H1C2.293 12.348 9.586 4.156 20.001 2.324zM35.494 6c-2.365 0-4.478 1.166-5.648 3.12a5.836 5.836 0 00-.841 3.272l.01.183C29.13 14.212 30.054 15.71 35.5 21c2.745-2.645 4.857-4.84 5.853-6.504.494-.823.644-1.379.646-2.383 0-1.647-.646-3.13-1.866-4.281A6.833 6.833 0 0035.494 6z"
});

function SvgProximitySearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$$({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$$);
}

function _extends$_() { _extends$_ = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$_.apply(this, arguments); }

var _ref$_ = /*#__PURE__*/React.createElement("path", {
  d: "M24 1c12.683 0 23 10.318 23 23 0 12.683-10.317 23-23 23C11.318 47 1 36.683 1 24 1 11.318 11.318 1 24 1zm0 32a3 3 0 100 6 3 3 0 000-6zm0-24c-4.962 0-9 4.038-9 9h5c0-2.206 1.794-4 4-4s4 1.794 4 4c0 3.326-3.883 3.96-4.311 4.02l-2.189.273V30h5v-3.543C29.468 25.432 33 22.922 33 18c0-4.962-4.037-9-9-9z",
  fillRule: "evenodd"
});

function SvgQuestionCircleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$_({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$_);
}

function _extends$Z() { _extends$Z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Z.apply(this, arguments); }

var _ref$Z = /*#__PURE__*/React.createElement("path", {
  d: "M24 1c12.683 0 23 10.318 23 23 0 12.683-10.317 23-23 23C11.318 47 1 36.683 1 24 1 11.318 11.318 1 24 1zm0 5C14.075 6 6 14.075 6 24s8.075 18 18 18 18-8.075 18-18S33.925 6 24 6zm0 27a3 3 0 110 6 3 3 0 010-6zm0-24c4.963 0 9 4.038 9 9 0 4.922-3.532 7.432-6.5 8.457V30h-5v-7.707l2.189-.273C24.117 21.96 28 21.326 28 18c0-2.206-1.794-4-4-4s-4 1.794-4 4h-5c0-4.962 4.038-9 9-9z",
  fillRule: "evenodd"
});

function SvgQuestionCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$Z({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$Z);
}

function _extends$Y() { _extends$Y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Y.apply(this, arguments); }

var _ref$Y = /*#__PURE__*/React.createElement("path", {
  d: "M24 1C16.224 1 10.571 4.646 7.003 8.499L6.999 1 2 1.003l.007 13.499A2.5 2.5 0 004.507 17h13.49v-4.999h-7.411C13.108 9.206 17.424 6 24 6c9.925 0 18 8.075 18 18s-8.075 18-18 18c-9.505 0-15.342-7.062-16.945-11.808l-4.738 1.6C4.383 37.905 11.862 47 24 47c12.683 0 23-10.317 23-23C47 11.318 36.683 1 24 1",
  fillRule: "evenodd"
});

function SvgReload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$Y({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$Y);
}

function _extends$X() { _extends$X = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$X.apply(this, arguments); }

var _ref$X = /*#__PURE__*/React.createElement("path", {
  d: "M42.5 15c2.48 0 4.5 2.019 4.5 4.5v23c0 2.481-2.02 4.5-4.5 4.5h-23a4.505 4.505 0 01-4.5-4.5v-23c0-2.481 2.018-4.5 4.5-4.5h23zm-.5 5H20v22h22V20zM28.5 1C30.981 1 33 3.019 33 5.5V11h-5V6H6v22h5v5H5.5A4.505 4.505 0 011 28.5v-23C1 3.019 3.018 1 5.5 1h23z",
  fillRule: "evenodd"
});

function SvgScreenShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$X({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$X);
}

function _extends$W() { _extends$W = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$W.apply(this, arguments); }

var _ref$W = /*#__PURE__*/React.createElement("path", {
  d: "M6 18.5C6 11.607 11.607 6 18.5 6S31 11.607 31 18.5 25.393 31 18.5 31 6 25.393 6 18.5zm41 24.965L32.496 28.961C34.686 26.039 36 22.424 36 18.5 36 8.851 28.149 1 18.5 1 8.851 1 1 8.851 1 18.5 1 28.149 8.851 36 18.5 36c3.924 0 7.539-1.314 10.461-3.504L43.465 47 47 43.465z",
  fillRule: "evenodd"
});

function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$W({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$W);
}

function _extends$V() { _extends$V = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$V.apply(this, arguments); }

var _ref$V = /*#__PURE__*/React.createElement("path", {
  d: "M17.473 1.498l14.091.014V9.51l1.764.99 6.85-4.1 7.25 12.081-6.862 4.114c.084 1.097.084 2.05 0 2.862l6.838 4.128-7.257 12.075-6.843-4.115c-1.002.61-1.59.938-1.765.985v8.005H17.438V38.53c-.871-.451-1.459-.788-1.764-1.009l-6.85 4.11-7.249-12.084 6.857-4.119a15.848 15.848 0 010-2.87l-6.857-4.116 7.28-12.074 6.852 4.111c.551-.35 1.14-.68 1.766-.99V1.498zm9.091 4.998H22.46v6.476c-3.772 1.01-5.395 2.722-6.412 3.567l-5.18-3.119-.31-.186-2.148 3.532 5.522 3.304c-.78 2.847-.78 5.465 0 7.852l-.032.019-.13.078L8.72 31.06l-.31.187 2.106 3.576 5.531-3.324c1.803 1.71 3.802 2.87 5.998 3.482l.414.108v.084c-.004.42-.02 2.413-.047 5.98l-.002.36h4.114l.037-6.088.001-.147v-.03l.001-.111v-.047c1.888-.298 3.909-1.398 6.063-3.3l.324-.29 5.519 3.323 2.095-3.524-5.51-3.331c.737-2.496.776-4.99.116-7.483l-.116-.415 5.51-3.304-2.095-3.532-2.473 1.481-.45.27-1.242.743-.47.282-.339.203-.18.107-.365.219c-1.626-1.605-3.607-2.763-5.944-3.477l-.443-.128V6.496zM24.5 17a7 7 0 110 14 7 7 0 010-14zm0 5a2 2 0 100 4 2 2 0 000-4z",
  fillRule: "evenodd"
});

function SvgSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$V({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$V);
}

function _extends$U() { _extends$U = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$U.apply(this, arguments); }

var _ref$U = /*#__PURE__*/React.createElement("path", {
  d: "M37 42c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3M11 27c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3M37 6c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3m0 25c-2.085 0-3.98.809-5.406 2.12l-12.781-7.417A7.97 7.97 0 0019 24c0-.569-.062-1.124-.176-1.661l12.866-7.371A7.96 7.96 0 0037 17c4.411 0 8-3.589 8-8s-3.589-8-8-8-8 3.589-8 8c0 .565.061 1.115.173 1.647l-12.874 7.376A7.96 7.96 0 0011 16c-4.411 0-8 3.589-8 8s3.589 8 8 8a7.958 7.958 0 005.267-1.994l12.881 7.476A8.08 8.08 0 0029 39c0 4.411 3.589 8 8 8s8-3.589 8-8-3.589-8-8-8",
  fillRule: "evenodd"
});

function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$U({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$U);
}

function _extends$T() { _extends$T = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$T.apply(this, arguments); }

var _ref$T = /*#__PURE__*/React.createElement("path", {
  d: "M43 27v5H32v11h-5V30.5c0-1.93 1.57-3.5 3.5-3.5H43zm-25.5 0c1.93 0 3.5 1.57 3.5 3.5V43h-5V32H5v-5zM32 5v11h11v5H30.5c-1.93 0-3.5-1.57-3.5-3.5V5h5zM21 5v12.5c0 1.93-1.57 3.5-3.5 3.5H5v-5h11V5h5z",
  fillRule: "evenodd"
});

function SvgShrink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$T({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$T);
}

function _extends$S() { _extends$S = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$S.apply(this, arguments); }

var _ref$S = /*#__PURE__*/React.createElement("path", {
  d: "M32.014 15.008c.4.201.702.553.841.977.158.442.127.93-.084 1.349l-4.712 9.23a.74.74 0 00.311 1 .746.746 0 00.942-.213l6.901-8.952a1.516 1.516 0 012.132-.19c.585.488.714 1.334.301 1.975l-6.51 9.284a.914.914 0 001.417 1.154l6.144-6.466a1.545 1.545 0 012.178-.115c.632.568.683 1.541.113 2.173l-6.827 8.018a.62.62 0 00.361 1.01.634.634 0 00.516-.141l5.925-5.153a1.49 1.49 0 011.136-.362 1.51 1.51 0 011.245 2.112l.005-.009a1.487 1.487 0 01-.36.507 777.345 777.345 0 00-9.979 9.366 33.227 33.227 0 01-5.104 4.066 8.944 8.944 0 01-8.33.629c-2.604-1.125-6.583-3.458-6.583-8.489l-.436-14.022a2.342 2.342 0 012.414-2.27 2.342 2.342 0 012.27 2.18l.156 6.637c.017.736.4 1.338 1.11 1.536.622.18 1.444-.059 2.015-1.036.194-.33 2.024-3.669 3.91-7.117l.366-.668.364-.666 3.603-6.591a1.677 1.677 0 012.249-.743zM3.681 19.275a2.348 2.348 0 013.208-.116l4.052 3.527a.845.845 0 01.289.628l.103 5.256a.342.342 0 01-.577.271L3.789 22.67a2.334 2.334 0 01-.108-3.395zM19.678.998a1.512 1.512 0 011.516 1.508l-.016 11.33a.926.926 0 00.793.89.916.916 0 001.042-.768l1.336-8.73a1.602 1.602 0 011.598-1.385c.032.002.065.004.097.008.847.085 1.463.84 1.378 1.685 0 0-.157 2.846-.4 5.632l-.051.574c-.167 1.81-.369 3.509-.585 4.277 0 0-1.107 2.219-2.286 4.486l-.284.544c-1.09 2.08-2.169 4.054-2.432 4.23a.558.558 0 01-.951-.343l-.042-1.91c-.045-2.515-1.552-4.074-3.54-4.379-1.79-.27-2.431.357-3.294.582a.558.558 0 01-.651-.471l-.021-.207L11.35 4.035a1.793 1.793 0 01.417-1.412 1.677 1.677 0 012.93.885l1.455 10.254a.755.755 0 00.904.654.776.776 0 00.582-.736l.53-11.184c.012-.36.144-.706.376-.982a1.512 1.512 0 011.134-.515z",
  fillRule: "evenodd"
});

function SvgSignLanguage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$S({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$S);
}

function _extends$R() { _extends$R = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$R.apply(this, arguments); }

var _ref$R = /*#__PURE__*/React.createElement("path", {
  d: "M38 42v5H1v-5h37zm-22-8v5H1v-5h15zM36.042 1L47 11.966 26.963 32H16V21.038L36.042 1zm-.003 7.117L21.033 23.121v3.848h3.847l15.004-15.005-3.845-3.847z",
  fillRule: "evenodd"
});

function SvgSign(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$R({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$R);
}

function _extends$Q() { _extends$Q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$Q.apply(this, arguments); }

var _ref$Q = /*#__PURE__*/React.createElement("path", {
  d: "M17 7v5H9.5c-.827 0-1.5.725-1.5 1.552V39.51c0 .827.673 1.49 1.5 1.49h14c.827 0 1.5-.663 1.5-1.49V31h5v8.51c0 3.584-2.916 6.49-6.5 6.49h-14C5.916 46 3 43.094 3 39.51V13.552C3 9.968 5.916 7 9.5 7H17zm-.5 24.76a2.75 2.75 0 110 5.5 2.75 2.75 0 010-5.5zM32.5 2C39.393 2 45 7.607 45 14.5c0 6.79-5.44 12.332-12.192 12.496L32.5 27H20V14.5c0-.127.002-.254.006-.38L20 14.5a12.663 12.663 0 01.305-2.75 14.45 14.45 0 01.112-.46 12.363 12.363 0 011.543-3.504l.026-.041a12.54 12.54 0 012.532-2.858 12.518 12.518 0 012.268-1.503l.188-.095a12.432 12.432 0 01.563-.261l.035-.016a12.419 12.419 0 011.942-.652l.104-.025A12.394 12.394 0 0132.5 2zm0 5c-4.136 0-7.5 3.364-7.5 7.5V22h7.5l.337-.007a7.556 7.556 0 00.426-.031l-.334.026c.117-.007.234-.016.35-.028l-.016.002c.122-.013.244-.028.364-.047l-.348.045a7.48 7.48 0 00.377-.049l-.029.004c.117-.017.233-.038.348-.06l-.32.056a7.45 7.45 0 00.415-.076l-.095.02c.136-.028.27-.059.404-.093l.224-.062a7.443 7.443 0 001-.372l-.074.033c.072-.032.142-.064.212-.098l-.139.065c.08-.036.16-.074.239-.114l-.1.049.21-.105-.11.056c.069-.034.138-.07.206-.107l-.096.05c.076-.039.152-.08.227-.122l-.131.072c.068-.036.135-.074.2-.112l-.07.04a7.527 7.527 0 00.945-.632l-.08.062c.069-.053.137-.107.204-.162l-.124.1c.06-.047.118-.094.176-.143l-.052.043a7.56 7.56 0 00.184-.155l-.132.112c.06-.049.118-.099.175-.15l-.043.038c.062-.055.124-.111.185-.168l-.142.13c.064-.057.127-.115.189-.173l-.047.043c.055-.051.11-.103.163-.156l-.116.113c.06-.057.119-.115.177-.174l-.061.06a7.553 7.553 0 001.151-1.464l-.054.088A7.51 7.51 0 0039 18.24l-.07.12c.044-.074.088-.15.13-.226l-.06.106c.036-.062.07-.124.104-.187l-.044.081a7.49 7.49 0 00.114-.213l-.07.132c.213-.394.391-.808.531-1.24l.065-.209a7.432 7.432 0 00.152-.617l-.029.138c.02-.087.037-.175.053-.264l-.024.126c.014-.07.028-.141.04-.212l-.016.086A7.466 7.466 0 0040 14.5c0-4.055-3.234-7.368-7.258-7.496L32.5 7z"
});

function SvgSms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$Q({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$Q);
}

function _extends$P() { _extends$P = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$P.apply(this, arguments); }

var _ref$P = /*#__PURE__*/React.createElement("circle", {
  stroke: "#fff",
  strokeWidth: 2,
  cx: 24,
  cy: 24,
  r: 23
});

var _ref2$9 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M25.968 12.5c-1.342 0-2.37.207-3.082.619-.715.413-1.228.88-1.546 1.399-.32.522-.498 1.019-.54 1.494-.04.474-.06.783-.06.927v3.17h-2.49v3.898h2.49V35.5h5.107V24.008h3.427c.061-.361.123-.753.185-1.177l.153-1.252c.052-.474.096-.965.137-1.47h-3.875v-2.578c0-.18.118-.374.347-.579.23-.204.486-.308.76-.308h2.769V12.5h-3.782z"
});

function SvgSocialFacebookCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$P({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$P, _ref2$9);
}

function _extends$O() { _extends$O = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$O.apply(this, arguments); }

var _ref$O = /*#__PURE__*/React.createElement("path", {
  xmlns: "http://www.w3.org/2000/svg",
  d: "M27.937 1c-2.685 0-4.742.414-6.165 1.237-1.429.826-2.457 1.76-3.091 2.799-.64 1.044-.996 2.038-1.081 2.987-.079.949-.119 1.567-.119 1.854v6.342H12.5v7.795h4.981V47h10.213V24.017h6.854c.123-.723.247-1.507.37-2.354l.307-2.505c.103-.948.192-1.93.273-2.939h-7.749v-5.157c0-.36.235-.749.693-1.157.461-.409.972-.616 1.52-.616H35.5V1h-7.563z"
});

function SvgSocialFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$O({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$O);
}

function _extends$N() { _extends$N = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$N.apply(this, arguments); }

var _ref$N = /*#__PURE__*/React.createElement("path", {
  d: "M25.37 13.59c-1.18 1.33-2.4 2.611-3.705 3.809-3.32-2.278-8.042-2.929-11.363-.298-4.75 3.26-4.966 10.959-.397 14.469 4.443 4.001 12.841 2.014 14.069-4.113l-1.67-.016-3.344-.015a131.526 131.526 0 01-3.342-.058 585.051 585.051 0 01-.007-4.944c4.652-.013 9.305-.02 13.964.015.28 3.876-.237 8.003-2.637 11.208-3.634 5.074-10.93 6.556-16.622 4.382C4.603 35.869.558 29.88 1.04 23.775c.126-7.47 7.045-14.013 14.572-13.763 3.606-.166 6.996 1.391 9.758 3.579zm17.43 4.674c.007 1.378.015 2.762.028 4.14 1.389.013 2.784.013 4.172.028v4.118c-1.388.015-2.777.022-4.172.035-.013 1.385-.02 2.762-.028 4.14h-4.157c-.014-1.378-.014-2.755-.028-4.133-1.388-.014-2.783-.027-4.171-.042v-4.118c1.388-.015 2.777-.021 4.171-.028.007-1.385.021-2.762.036-4.14h4.15z",
  fillRule: "evenodd"
});

function SvgSocialGoogleplus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$N({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$N);
}

function _extends$M() { _extends$M = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$M.apply(this, arguments); }

var _ref$M = /*#__PURE__*/React.createElement("circle", {
  stroke: "#fff",
  strokeWidth: 2,
  cx: 24,
  cy: 24,
  r: 23
});

var _ref2$8 = /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.258 12.569c-1.223.055-2.059.25-2.79.534a5.64 5.64 0 00-2.038 1.327 5.628 5.628 0 00-1.326 2.037c-.285.732-.48 1.568-.535 2.791-.056 1.227-.069 1.619-.069 4.742s.013 3.515.069 4.742c.055 1.224.25 2.059.535 2.791a5.634 5.634 0 001.326 2.037 5.647 5.647 0 002.037 1.327c.732.284 1.567.479 2.791.534 1.227.056 1.619.069 4.742.069s3.515-.013 4.742-.069c1.224-.056 2.06-.25 2.79-.535a5.642 5.642 0 002.038-1.326 5.65 5.65 0 001.326-2.037c.285-.732.48-1.567.535-2.792.056-1.226.069-1.618.069-4.741 0-3.123-.013-3.515-.069-4.742-.056-1.224-.25-2.06-.535-2.79a5.642 5.642 0 00-1.326-2.038 5.636 5.636 0 00-2.038-1.327c-.73-.284-1.566-.479-2.79-.534-1.227-.056-1.619-.069-4.742-.069-3.124 0-3.515.013-4.742.069zm.095 20.792c-1.122-.051-1.73-.238-2.135-.396a3.57 3.57 0 01-1.323-.86 3.57 3.57 0 01-.86-1.323c-.158-.405-.346-1.014-.396-2.135-.056-1.212-.067-1.577-.067-4.647 0-3.07.011-3.434.067-4.647.05-1.122.238-1.73.396-2.135.208-.537.458-.92.86-1.322a3.578 3.578 0 011.323-.861c.405-.157 1.013-.345 2.135-.396 1.212-.055 1.576-.067 4.647-.067 3.07 0 3.434.012 4.647.067 1.121.051 1.73.239 2.135.396.537.209.92.458 1.322.86.403.403.652.786.861 1.323.157.406.345 1.014.396 2.135.055 1.213.067 1.577.067 4.647 0 3.07-.012 3.434-.067 4.647-.051 1.121-.239 1.73-.396 2.135-.209.537-.458.92-.86 1.323a3.557 3.557 0 01-1.323.86c-.405.157-1.014.345-2.135.396-1.213.056-1.577.068-4.647.068-3.07 0-3.435-.013-4.647-.068z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.095 24a5.905 5.905 0 1011.81 0 5.905 5.905 0 10-11.81 0zm2.071 0a3.833 3.833 0 117.667 0 3.834 3.834 0 01-7.667 0zM28.759 17.861a1.38 1.38 0 002.76 0 1.38 1.38 0 00-2.76 0z"
}));

function SvgSocialInstagramCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$M({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$M, _ref2$8);
}

function _extends$L() { _extends$L = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$L.apply(this, arguments); }

var _ref$L = /*#__PURE__*/React.createElement("path", {
  xmlns: "http://www.w3.org/2000/svg",
  d: "M25.852 1.001c4.584.006 5.445.038 7.632.137l.424.022c2.22.135 3.781.511 5.157 1.047l.345.14c1.366.573 2.55 1.332 3.73 2.513l.286.295c1.112 1.182 1.823 2.382 2.367 3.78l.099.26c.515 1.401.866 3.018.97 5.321l.007.158.038.871.011.273c.058 1.488.078 2.834.081 6.672v3.02c-.004 4.885-.035 5.733-.137 7.973l-.022.424c-.135 2.22-.511 3.781-1.047 5.159l-.14.345c-.573 1.365-1.333 2.548-2.513 3.729l-.295.286c-1.182 1.112-2.382 1.823-3.78 2.367l-.26.098c-1.401.515-3.017.867-5.321.971l-.158.007c-2.125.097-3.047.126-7.816.13h-3.02c-3.141-.003-4.613-.016-5.859-.053l-.274-.008a88.08 88.08 0 01-.54-.02l-.272-.01-1.029-.046-.424-.022c-2.219-.135-3.78-.512-5.157-1.047l-.345-.14c-1.366-.573-2.55-1.333-3.73-2.513l-.287-.295c-1.112-1.183-1.822-2.382-2.365-3.779l-.099-.26c-.516-1.403-.867-3.018-.971-5.323l-.007-.158c-.019-.414-.035-.783-.049-1.144l-.01-.269-.005-.135-.009-.27c-.038-1.232-.053-2.636-.057-5.655v-3.704c.004-3.019.02-4.423.057-5.654l.01-.272c0-.045.002-.09.004-.134l.01-.27c.016-.406.034-.822.056-1.302l.022-.424c.135-2.219.512-3.781 1.048-5.157l.14-.345C2.92 7.224 3.678 6.04 4.86 4.86l.295-.287c1.183-1.112 2.382-1.822 3.78-2.366l.26-.099c1.402-.515 3.018-.866 5.321-.97.48-.022.896-.04 1.302-.056l.27-.01c1.345-.048 2.705-.067 6.06-.071zm-.718 4.143h-2.618l-.658.001c-2.953.005-4.243.02-5.474.063l-.396.014c-.398.016-.808.034-1.282.056l-.329.017c-2.035.122-3.171.477-3.941.774l-.285.116c-.928.395-1.628.874-2.361 1.606l-.212.219c-.682.727-1.129 1.45-1.508 2.426l-.048.125c-.304.81-.648 2.014-.744 4.145l-.007.156c-.019.41-.035.772-.049 1.126l-.014.396c-.042 1.231-.058 2.521-.063 5.474v4.284c.005 2.952.02 4.242.063 5.474l.014.396c.016.398.034.808.056 1.282l.017.329c.121 2.034.476 3.172.775 3.941l.116.285c.394.928.873 1.628 1.604 2.36l.22.212c.728.683 1.45 1.13 2.426 1.509l.125.048c.81.304 2.014.647 4.145.744.474.022.884.04 1.282.056l.264.01c1.361.049 2.724.065 6.264.068h2.968c3.54-.003 4.903-.02 6.264-.068l.264-.01c.398-.016.808-.034 1.282-.056l.329-.017c2.035-.122 3.172-.476 3.941-.775l.286-.116c.928-.394 1.628-.873 2.359-1.605l.212-.219c.684-.728 1.13-1.45 1.51-2.426l.048-.125c.303-.81.646-2.015.743-4.145l.007-.156c.019-.41.035-.772.049-1.126l.01-.264c.048-1.361.064-2.724.067-6.264v-2.968c-.003-3.54-.019-4.903-.068-6.264l-.01-.264c-.015-.398-.033-.808-.055-1.282l-.017-.329c-.122-2.035-.476-3.17-.774-3.941l-.116-.286c-.395-.928-.873-1.628-1.606-2.359l-.219-.212c-.727-.683-1.45-1.13-2.426-1.51l-.125-.047c-.81-.303-2.014-.647-4.145-.744l-.156-.007-.858-.038-.268-.01-.264-.01c-1.273-.046-2.548-.063-5.606-.068h-1.008zM24 12.19l.3.004c6.384.159 11.51 5.383 11.51 11.806l-.004.3C35.647 30.684 30.423 35.81 24 35.81l-.3-.004C17.316 35.647 12.19 30.423 12.19 24c0-6.523 5.287-11.81 11.81-11.81zm0 4.144l-.243.004A7.667 7.667 0 0024 31.667l.243-.004A7.667 7.667 0 0031.667 24l-.004-.243A7.666 7.666 0 0024 16.334zm12.277-7.371l.168.005a2.76 2.76 0 012.592 2.755l-.005.168a2.76 2.76 0 01-2.755 2.592l-.168-.005a2.761 2.761 0 01.168-5.515z"
});

function SvgSocialInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$L({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$L);
}

function _extends$K() { _extends$K = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$K.apply(this, arguments); }

var _ref$K = /*#__PURE__*/React.createElement("circle", {
  stroke: "#fff",
  strokeWidth: 2,
  cx: 24,
  cy: 24,
  r: 23
});

var _ref2$7 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13.037 14.274a.534.534 0 00-.537.514v19.107c0 .274.243.514.537.514h3.189c.295 0 .537-.24.537-.514V29.65h.035c0-1.112.954-2.02 2.097-2.02h1.127c1.16 0 2.097.908 2.097 2.02v1.044h.017v3.202c0 .274.242.514.537.514h3.189c.295 0 .537-.24.537-.514l.052-3.202V29.65h-.017c0-1.592-.624-3.03-1.647-4.144 1.006-1.095 1.612-2.516 1.612-4.091V20.37h-.017a.522.522 0 00-.52-.428h-3.206a.522.522 0 00-.52.428l-.07 1.044c0 1.112-.953 2.02-2.096 2.02v.018h-1.075c-.745 0-1.456.136-2.114.359v-9.023a.558.558 0 00-.537-.514h-3.207zm16.016-.413l-.153.156a1.258 1.258 0 00.013 1.761l.945.94a.32.32 0 00.46 0l.116-.118a.32.32 0 00.012-.457l-.945-.939a.432.432 0 010-.587l.153-.157a.41.41 0 01.575 0l.946.953c.127.13.345.117.472-.013l.115-.118a.32.32 0 000-.456l-.064-.066-.882-.887a1.237 1.237 0 00-.887-.373c-.318 0-.634.12-.876.36zm4.166.012l-.945.953a.331.331 0 00.012.456l.115.118c.128.13.332.143.46.013l.946-.94a.412.412 0 01.575 0l.153.157a.415.415 0 010 .574l-.932.952c-.128.118-.115.326.012.457l.115.118a.32.32 0 00.46 0l.064-.066.882-.887a1.246 1.246 0 000-1.761l-.153-.157a1.226 1.226 0 00-.869-.355c-.324 0-.649.123-.895.368zm-3.374 3.38l-.064.065-.881.887a1.221 1.221 0 00-.013 1.748l.153.156a1.243 1.243 0 001.764-.013l.946-.939a.333.333 0 00-.013-.457l-.115-.117c-.128-.13-.332-.144-.46-.013l-.946.94a.41.41 0 01-.574 0l-.154-.157a.432.432 0 010-.587l.946-.94c.127-.117.115-.326-.014-.456l-.115-.117a.321.321 0 00-.23-.098.323.323 0 00-.23.098zm3.86-.027l-.116.118c-.127.13-.14.326-.012.456l.946.94a.42.42 0 010 .587l-.154.156a.41.41 0 01-.575 0l-.946-.965c-.127-.131-.344-.118-.472.012l-.115.118a.32.32 0 000 .457l.063.065.882.887a1.231 1.231 0 001.764.013l.153-.157a1.259 1.259 0 00-.013-1.76l-.945-.94a.328.328 0 00-.46.013z"
});

function SvgSocialKununuCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$K({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$K, _ref2$7);
}

function _extends$J() { _extends$J = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$J.apply(this, arguments); }

var _ref$J = /*#__PURE__*/React.createElement("path", {
  xmlns: "http://www.w3.org/2000/svg",
  d: "M8.487 4.549l.118.007c.503.062.924.511.956 1.02v18.046l.398-.128a13.05 13.05 0 013.831-.59h2.15v-.035l.207-.005c2.194-.105 3.986-1.878 3.986-4.036l.139-2.088.023-.109c.117-.427.537-.747 1.017-.747h6.412l.119.007c.468.051.857.406.922.849h.034v2.088l-.006.377c-.092 3-1.287 5.704-3.218 7.806l.232.26c1.907 2.189 3.061 4.965 3.061 8.027h.034v2.089l-.103 6.404-.006.109c-.06.5-.518.919-1.069.919h-6.377l-.116-.006c-.537-.058-.959-.51-.959-1.022v-6.404h-.035v-2.089l-.005-.201c-.109-2.131-1.937-3.84-4.189-3.84H13.79l-.207.005c-2.194.105-3.986 1.88-3.986 4.036h-.07v8.493l-.006.109c-.06.5-.52.919-1.069.919H2.074l-.116-.006C1.423 44.755 1 44.303 1 43.79V5.576l.006-.109c.06-.5.52-.918 1.068-.918h6.413zm27.663 5.76l.1.008a.648.648 0 01.36.188l.23.234.07.083c.19.26.187.62-.043.831l-1.892 1.878-.076.09a.873.873 0 00.076 1.085l.308.313.089.078a.824.824 0 001.06-.078l1.891-1.88.081-.07c.255-.183.609-.137.839.097l.231.234.069.082a.665.665 0 01-.044.832l-1.892 1.878-.13.124a2.485 2.485 0 01-3.397-.098l-.307-.312-.121-.13c-.847-.973-.806-2.469.147-3.367l1.763-1.774.128-.13a.646.646 0 01.46-.196zm7.732-.056l.097.007c.128.019.25.075.35.166l1.891 1.879.121.13a2.52 2.52 0 01-.095 3.392l-.307.313-.13.124c-.979.864-2.468.799-3.397-.15l-1.764-1.774-.127-.13-.069-.082a.64.64 0 01.069-.832l.23-.235.082-.071c.259-.192.634-.19.863.046l1.892 1.93.09.078a.825.825 0 001.06-.078l.307-.313.07-.082a.838.838 0 00-.07-1.092L43.153 11.6l-.068-.082c-.18-.256-.136-.596.093-.831l.232-.235a.657.657 0 01.472-.199zm.346-7.243l.189.007a2.445 2.445 0 011.548.704l.307.313.121.132a2.488 2.488 0 01-.121 3.39l-1.765 1.775-.127.13-.08.07a.64.64 0 01-.84-.07l-.23-.235-.07-.083c-.187-.26-.185-.619.045-.83l1.865-1.905.076-.09a.833.833 0 00-.076-1.058l-.306-.313-.09-.077a.828.828 0 00-1.061.077l-1.89 1.879-.081.07c-.256.183-.61.139-.841-.096l-.229-.235-.07-.082a.661.661 0 01.045-.831l1.891-1.905a2.533 2.533 0 011.79-.737zM35.857 3l.193.007c.577.045 1.143.29 1.582.74l1.764 1.774.128.131.07.082a.636.636 0 01-.07.831l-.23.235-.082.071c-.258.192-.634.19-.863-.045l-1.892-1.905-.089-.078a.821.821 0 00-1.06.078l-.307.313-.076.09A.871.871 0 0035 6.408l1.891 1.879.068.083c.18.26.136.619-.093.83l-.23.235-.081.07a.64.64 0 01-.841-.07l-1.89-1.879-.121-.13a2.517 2.517 0 01.095-3.392l.307-.313A2.476 2.476 0 0135.857 3z"
});

function SvgSocialKununu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$J({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$J);
}

function _extends$I() { _extends$I = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$I.apply(this, arguments); }

var _ref$I = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("circle", {
  stroke: "#FFF",
  strokeWidth: 2,
  cx: 24,
  cy: 24,
  r: 23
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M14.22 12.5c-.956 0-1.72.767-1.72 1.661V33.84c0 .894.764 1.661 1.72 1.661h19.561c.955 0 1.719-.767 1.719-1.66V14.16c0-.894-.764-1.661-1.719-1.661h-19.56zm1.466 5.176c0-1.15.892-1.981 1.974-1.981 1.084 0 1.975.894 1.975 1.981 0 1.086-.89 1.98-1.975 1.98a1.987 1.987 0 01-1.974-1.98zm9.11 4.919c.447-.894 1.594-1.789 3.25-1.789 3.44 0 4.078 2.3 4.078 5.239v6.005h-3.377v-5.366c0-1.279 0-2.94-1.784-2.94-1.785 0-2.039 1.406-2.039 2.811v5.431h-3.377v-10.86h3.186v1.469h.063zm-8.854 9.519h3.375V21.125h-3.376v10.989z"
}));

function SvgSocialLinkedinCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$I({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$I);
}

function _extends$H() { _extends$H = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$H.apply(this, arguments); }

var _ref$H = /*#__PURE__*/React.createElement("path", {
  d: "M4.441 1C2.529 1 1 2.534 1 4.323v39.356C1 45.466 2.529 47 4.441 47h39.121C45.472 47 47 45.466 47 43.679V4.323C47 2.534 45.472 1 43.562 1H4.441zm2.932 10.352c0-2.3 1.783-3.962 3.948-3.962 2.168 0 3.95 1.788 3.95 3.962 0 2.172-1.782 3.961-3.95 3.961-2.165 0-3.948-1.789-3.948-3.961zm18.219 9.838c.894-1.789 3.188-3.578 6.5-3.578 6.881 0 8.156 4.601 8.156 10.478v12.011h-6.754V29.368c0-2.557 0-5.879-3.567-5.879-3.57 0-4.079 2.812-4.079 5.622v10.861h-6.753V18.251h6.371v2.939h.126zM7.883 40.227h6.752V18.25H7.883v21.977z",
  xmlns: "http://www.w3.org/2000/svg",
  fillRule: "evenodd"
});

function SvgSocialLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$H({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$H);
}

function _extends$G() { _extends$G = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$G.apply(this, arguments); }

var _ref$G = /*#__PURE__*/React.createElement("circle", {
  stroke: "#FFF",
  strokeWidth: 2,
  cx: 24,
  cy: 24,
  r: 23
});

var _ref2$6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M33.99 18.259a5.697 5.697 0 01-3.466-1.17 5.816 5.816 0 01-2.292-4.589h-3.716v10.262l-.005 5.62a3.396 3.396 0 01-2.311 3.225 3.348 3.348 0 01-2.788-.31 3.405 3.405 0 01-1.644-2.863c-.028-1.9 1.492-3.45 3.371-3.45.371 0 .727.062 1.061.173v-3.813a7.24 7.24 0 00-1.072-.08c-2.057 0-3.98.864-5.355 2.42a7.083 7.083 0 00-1.76 4.25 7.076 7.076 0 002.075 5.481 7.08 7.08 0 005.04 2.085 7.077 7.077 0 005.04-2.085 7.067 7.067 0 002.088-5.003l-.02-8.394A9.368 9.368 0 0034 21.997v-3.739h-.01z"
});

function SvgSocialTiktokCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$G({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$G, _ref2$6);
}

function _extends$F() { _extends$F = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$F.apply(this, arguments); }

var _ref$F = /*#__PURE__*/React.createElement("path", {
  d: "M18.515 46.5a13.88 13.88 0 01-8.032-2.547 14.058 14.058 0 018.032-25.565c.465 0 1.613.027 2.126.084v6.983a14.464 14.464 0 00-2.126-.16 7.148 7.148 0 107.114 7.418L25.643 1.5h6.9c.024.536.085 1.07.183 1.598a11.563 11.563 0 005.027 7.542 11.386 11.386 0 005.748 1.852v6.912a18.164 18.164 0 01-10.181-3.437l-.789-.569v17.046A14.052 14.052 0 0118.515 46.5z"
});

function SvgSocialTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$F({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$F);
}

function _extends$E() { _extends$E = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$E.apply(this, arguments); }

var _ref$E = /*#__PURE__*/React.createElement("circle", {
  stroke: "#FFF",
  strokeWidth: 2,
  cx: 24,
  cy: 24,
  r: 23
});

var _ref2$5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M25.191 15.803a4.842 4.842 0 00-1.366 4.577 13.331 13.331 0 01-9.724-5.005c-1.253 2.189-.613 4.989 1.46 6.396a4.643 4.643 0 01-2.142-.6v.06c0 2.281 1.585 4.245 3.787 4.697a4.644 4.644 0 01-2.131.082c.618 1.952 2.39 3.288 4.409 3.328a9.376 9.376 0 01-5.861 2.054c-.375 0-.751-.024-1.123-.07a13.21 13.21 0 007.233 2.15v.003c8.679 0 13.426-7.301 13.426-13.632 0-.207 0-.413-.013-.619a9.703 9.703 0 002.354-2.48 9.335 9.335 0 01-2.711.754 4.797 4.797 0 002.074-2.65 9.393 9.393 0 01-2.996 1.163 4.667 4.667 0 00-6.676-.208z"
});

function SvgSocialTwitterCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$E({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$E, _ref2$5);
}

function _extends$D() { _extends$D = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$D.apply(this, arguments); }

var _ref$D = /*#__PURE__*/React.createElement("path", {
  xmlns: "http://www.w3.org/2000/svg",
  d: "M26.382 7.606c-2.451 2.339-3.492 5.826-2.732 9.153-7.587-.386-14.656-4.025-19.449-10.01-2.505 4.378-1.225 9.978 2.921 12.792a9.287 9.287 0 01-4.284-1.2v.121c.001 4.562 3.169 8.489 7.573 9.394a9.287 9.287 0 01-4.261.163c1.235 3.904 4.78 6.577 8.817 6.656a18.752 18.752 0 01-11.722 4.109A18.714 18.714 0 011 38.645a26.42 26.42 0 0014.465 4.298v.007c17.358 0 26.853-14.602 26.853-27.265 0-.414 0-.826-.027-1.237A19.406 19.406 0 0047 9.489a18.671 18.671 0 01-5.422 1.506 9.594 9.594 0 004.148-5.3 18.785 18.785 0 01-5.992 2.327A9.348 9.348 0 0032.852 5c-2.32 0-4.646.863-6.47 2.606z"
});

function SvgSocialTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$D({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$D);
}

function _extends$C() { _extends$C = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$C.apply(this, arguments); }

var _ref$C = /*#__PURE__*/React.createElement("path", {
  d: "M35.006 28.5c-.567-.309-3.347-1.798-3.869-2.008-.521-.21-.901-.32-1.308.239-.406.557-1.56 1.804-1.91 2.173-.35.37-.688.404-1.255.096-.564-.307-2.4-.98-4.527-3.01-1.657-1.58-2.743-3.495-3.058-4.08-.315-.585-.002-.883.297-1.157.27-.248.602-.648.903-.97.3-.324.406-.558.613-.933.206-.375.123-.712-.011-1.004-.134-.29-1.18-3.148-1.617-4.311-.437-1.163-.924-.99-1.26-1.003-.337-.011-.72-.074-1.104-.088-.384-.015-1.015.105-1.564.658-.55.552-2.091 1.88-2.197 4.696-.107 2.813 1.856 5.61 2.13 6.001.273.393 3.747 6.494 9.52 9.002 5.774 2.509 5.804 1.744 6.864 1.688 1.06-.056 3.462-1.258 3.994-2.575.53-1.317.573-2.462.438-2.706-.135-.244-.514-.402-1.08-.709zM24.417 42.06a18.8 18.8 0 01-10.342-3.084L6.85 41.272l2.348-6.927a18.457 18.457 0 01-3.58-10.937c0-10.287 8.433-18.655 18.798-18.655 10.367 0 18.8 8.368 18.8 18.655 0 10.285-8.433 18.653-18.8 18.653zm0-41.061C11.946 1 1.836 11.032 1.836 23.408c0 4.233 1.184 8.193 3.24 11.57L1 47l12.503-3.971a22.632 22.632 0 0010.914 2.787C36.89 45.816 47 35.782 47 23.408 47 11.032 36.89 1 24.417 1z",
  fillRule: "evenodd"
});

function SvgSocialWhatsapp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$C({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$C);
}

function _extends$B() { _extends$B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$B.apply(this, arguments); }

var _ref$B = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M47 24c0 12.703-10.297 23-23 23S1 36.703 1 24 11.297 1 24 1s23 10.297 23 23zm-26.174 1.374l-10.994-14.7h8.473l7.207 9.637 8.92-9.637h2.49L26.625 21.8l11.612 15.526h-8.473l-7.826-10.464-9.685 10.464h-2.49l11.063-11.951zm-3.44-12.866h-3.893l17.19 22.983h3.892L17.386 12.508z"
});

function SvgSocialX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$B({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$B);
}

function _extends$A() { _extends$A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A.apply(this, arguments); }

var _ref$A = /*#__PURE__*/React.createElement("circle", {
  stroke: "#fff",
  strokeWidth: 2,
  cx: 24,
  cy: 24,
  r: 23
});

var _ref2$4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M33.351 12.5l.098.006c.156.021.278.093.349.206l.037.074c.05.13.035.285-.043.438l-7.453 12.985-.004.011.004.011 4.745 8.544.04.092a.48.48 0 01-.033.421l-.05.063a.532.532 0 01-.397.149h-3.362l-.134-.008c-.428-.053-.655-.356-.806-.624l-.025-.043-2.065-3.734-.297-.538-2.397-4.332.017-.03L23.5 22.83l.325-.567 5.225-9.13.05-.087c.172-.287.394-.545.85-.545h3.401zm-14.176 4.543l.134.007c.427.052.65.347.803.614l.008.014 1.084 1.864.238.41c.512.879.978 1.68.985 1.689l-.017.03-3.617 6.304-.05.083c-.17.28-.412.557-.869.557h-3.366l-.097-.008a.476.476 0 01-.342-.218l-.038-.075a.522.522 0 01.038-.434l3.576-6.22v-.02l-2.276-3.881-.04-.092c-.056-.153-.054-.3.021-.417l.05-.064c.093-.095.24-.143.408-.143h3.367z"
});

function SvgSocialXingCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$A({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$A, _ref2$4);
}

function _extends$z() { _extends$z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$z.apply(this, arguments); }

var _ref$z = /*#__PURE__*/React.createElement("path", {
  xmlns: "http://www.w3.org/2000/svg",
  d: "M42.702 1l.148.007c.335.033.597.179.746.417l.059.11c.117.266.092.593-.071.914L28.677 28.419l-.007.022.007.021 9.491 17.089.062.138c.126.322.108.639-.049.887l-.07.097c-.182.211-.469.327-.824.327h-6.723l-.187-.008c-.908-.076-1.38-.704-1.694-1.255l-.005-.01-.016-.027-.06-.109-4.886-8.835-.387-.698c-2.18-3.943-4.201-7.596-4.213-7.616l.019-.032 6.769-11.825.662-1.158.222-.386.441-.772C30.76 8.103 34.1 2.263 34.1 2.263l.068-.12C34.516 1.55 34.958 1 35.901 1h6.801zM14.35 10.085l.187.007c.908.075 1.373.685 1.687 1.236l.006.011c.192.33 4.596 7.9 4.623 7.942l-.02.033c-.22.387-1.758 3.066-3.36 5.858l-.356.621-3.532 6.156-.066.115c-.342.576-.828 1.165-1.771 1.165H5.016l-.147-.008a.96.96 0 01-.731-.443l-.053-.098c-.126-.269-.115-.596.053-.921l7.151-12.44.006-.017-.006-.021-4.551-7.764-.057-.123c-.135-.326-.14-.643.019-.895l.072-.097c.185-.21.49-.317.844-.317h6.734z"
});

function SvgSocialXing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$z({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$z);
}

function _extends$y() { _extends$y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$y.apply(this, arguments); }

var _ref$y = /*#__PURE__*/React.createElement("circle", {
  stroke: "#FFF",
  strokeWidth: 2,
  cx: 24,
  cy: 24,
  r: 23
});

var _ref2$3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15.014 16.468a2.846 2.846 0 00-2.033 1.981c-.481 1.747-.481 5.391-.481 5.391s0 3.647.48 5.394a2.845 2.845 0 002.034 1.98c1.793.468 8.986.468 8.986.468s7.192 0 8.986-.468a2.845 2.845 0 002.034-1.98c.48-1.747.48-5.393.48-5.393s0-3.645-.48-5.392a2.846 2.846 0 00-2.034-1.981C31.193 16 24 16 24 16s-7.192 0-8.985.468zM21.7 20.48l5.975 3.36L21.7 27.2v-6.72z"
});

function SvgSocialYoutubeCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$y({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$y, _ref2$3);
}

function _extends$x() { _extends$x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }

var _ref$x = /*#__PURE__*/React.createElement("path", {
  d: "M19.6 30.429V17.57L31.03 24 19.6 30.429zm25.48-16.744c-.505-1.844-1.997-3.297-3.889-3.79C37.76 9 24 9 24 9s-13.76 0-17.19.895c-1.893.493-3.385 1.946-3.89 3.79C2 17.026 2 24 2 24s0 6.974.92 10.316c.505 1.843 1.997 3.296 3.89 3.789C10.24 39 24 39 24 39s13.76 0 17.191-.895c1.892-.493 3.384-1.946 3.89-3.789C46 30.973 46 24 46 24s0-6.974-.92-10.315z"
});

function SvgSocialYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$x({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$x);
}

function _extends$w() { _extends$w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }

var _ref$w = /*#__PURE__*/React.createElement("path", {
  d: "M19.002 1v37.622l9.275-8.923 3.473 3.602-13.514 13A2.5 2.5 0 0116.5 47a2.496 2.496 0 01-1.736-.699l-13.514-13 3.471-3.602 9.276 8.923V1h5.005zm18.415 18v5H24v-5h13.417zm4.791-9v5H24v-5h18.208zM47 1v5H24V1h23z",
  fillRule: "evenodd"
});

function SvgSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$w({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$w);
}

function _extends$v() { _extends$v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }

var _ref$v = /*#__PURE__*/React.createElement("path", {
  d: "M1 32.332c0 .582.207 1.022.62 1.32.415.298.857.403 1.328.316.442-.087.753-.247.931-.48.178-.233.268-.618.268-1.156v-6.325c0-.451-.154-.833-.46-1.146a1.514 1.514 0 00-1.124-.468 1.49 1.49 0 00-1.103.468c-.307.313-.46.695-.46 1.146v6.325zm4.923 2.705c0 .422.146.738.439.949.293.21.667.316 1.124.316.47 0 .852-.105 1.145-.316.293-.211.439-.527.439-.95V20.293c0-.436-.154-.81-.46-1.123a1.515 1.515 0 00-1.124-.47 1.49 1.49 0 00-1.103.47c-.306.312-.46.687-.46 1.123v14.745zm4.902.698c0 .422.15.738.45.949.3.21.684.316 1.155.316.457 0 .832-.105 1.124-.316.293-.211.44-.527.44-.95V22.278c0-.451-.154-.836-.461-1.156a1.474 1.474 0 00-1.102-.48c-.443 0-.821.16-1.135.48a1.59 1.59 0 00-.47 1.156l-.001 13.458zm4.923.065c0 .8.528 1.2 1.584 1.2s1.584-.4 1.584-1.2V13.988c0-1.221-.364-1.912-1.091-2.072-.471-.116-.935.022-1.392.415-.457.392-.685.945-.685 1.657V35.8zm5.01.633V12.7c0-.756.22-1.207.663-1.352A12.004 12.004 0 0124.268 11c2.183 0 4.216.524 6.1 1.57a12.66 12.66 0 014.57 4.287 12.94 12.94 0 012.023 5.987 6.909 6.909 0 012.783-.567c1.997 0 3.706.72 5.126 2.16 1.42 1.439 2.13 3.17 2.13 5.19 0 2.036-.71 3.774-2.13 5.214C43.45 36.28 41.75 37 39.765 37l-18.623-.022a.503.503 0 01-.289-.24.654.654 0 01-.096-.305z"
});

function SvgSoundcloud(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$v({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$v);
}

function _extends$u() { _extends$u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }

var _ref$u = /*#__PURE__*/React.createElement("path", {
  d: "M6.014 41.986c21.672.147 26.168-.704 30.752-5.284C40.142 33.332 42 28.812 42 23.98c0-4.832-1.86-9.35-5.234-12.725-7.02-7.014-18.442-7.013-25.466.001-4.567 4.562-5.417 9.052-5.286 30.731M10.18 47c-2.063 0-4.28-.014-6.672-.036l-2.455-.023-.022-2.454c-.205-23.756.429-30.47 6.733-36.766 8.973-8.962 23.568-8.962 32.537 0C44.62 12.038 46.999 17.812 47 23.98c0 6.168-2.38 11.942-6.698 16.257C34.616 45.917 28.609 47 10.18 47",
  fillRule: "evenodd"
});

function SvgSpeechBubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$u({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$u);
}

function _extends$t() { _extends$t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }

var _ref$t = /*#__PURE__*/React.createElement("path", {
  d: "M24 1C11.298 1 1 11.297 1 24s10.298 23 23 23c12.703 0 23-10.297 23-23C47 11.298 36.703 1 24 1V1zm10.548 33.172a1.433 1.433 0 01-1.971.477c-5.401-3.3-12.2-4.047-20.206-2.218a1.433 1.433 0 11-.638-2.794c8.762-2.003 16.277-1.14 22.34 2.564.675.414.89 1.295.475 1.971zm2.815-6.262a1.794 1.794 0 01-2.467.59c-6.18-3.799-15.606-4.9-22.919-2.68a1.796 1.796 0 01-2.237-1.194 1.796 1.796 0 011.195-2.237c8.353-2.534 18.737-1.306 25.837 3.056a1.792 1.792 0 01.59 2.465zm.242-6.52c-7.414-4.404-19.643-4.809-26.72-2.66a2.151 2.151 0 11-1.25-4.118c8.125-2.466 21.63-1.99 30.165 3.077a2.151 2.151 0 01-2.195 3.7z"
});

function SvgSpotify(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$t({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$t);
}

function _extends$s() { _extends$s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }

var _ref$s = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24 12a5.5 5.5 0 100-11 5.5 5.5 0 000 11M42 37.027c-6.118.047-10.988.517-15.5 2.98v-17.04c3.871-3.083 7.844-3.874 15.5-3.958v18.018zM6 19.01c7.655.084 11.628.876 15.5 3.957v17.041c-4.512-2.464-9.381-2.933-15.5-2.98V19.01zm38.514-5.005C36 13.952 29.829 14.277 24 18.585c-5.83-4.309-12.044-4.635-20.513-4.58L1 14.018V42.04l2.514-.014c9.661-.05 13.87.57 18.251 4.174.648.533 1.442.8 2.236.8a3.5 3.5 0 002.232-.799c4.383-3.605 8.569-4.229 18.253-4.175L47 42.04V14.018l-2.486-.013z"
}));

function SvgSpracheLeicht(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$s({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$s);
}

function _extends$r() { _extends$r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }

var _ref$r = /*#__PURE__*/React.createElement("path", {
  d: "M21 37.038V47h9.963L47 30.966 37.042 21 21 37.038zm5.033 2.083l11.006-11.004 2.845 2.847L28.88 41.969h-2.847V39.12z"
});

var _ref2$2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 47H7.5A6.508 6.508 0 011 40.5v-33C1 3.916 3.916 1 7.5 1h24C35.084 1 38 3.916 38 7.5V17h-5V7.5c0-.827-.673-1.5-1.5-1.5h-24C6.673 6 6 6.673 6 7.5v33c0 .827.673 1.5 1.5 1.5H16v5z"
});

function SvgStackTextbig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$r({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$r, _ref2$2);
}

function _extends$q() { _extends$q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }

var _ref$q = /*#__PURE__*/React.createElement("path", {
  d: "M11.313 46c-.512 0-1.027-.16-1.458-.477-.739-.516-1.129-1.456-.975-2.382l2.205-12.883-9.35-9.118a2.453 2.453 0 011.364-4.178l12.93-1.888L21.803 3.37A2.454 2.454 0 0124.007 2c.932 0 1.798.539 2.205 1.372l5.775 11.702 12.907 1.878c.934.14 1.693.78 1.983 1.67.29.884.058 1.845-.605 2.509l-9.36 9.118 2.205 12.88a2.45 2.45 0 01-.975 2.385c-.727.542-1.785.625-2.599.198l-11.545-6.074-11.544 6.073c-.353.193-.746.289-1.14.289z",
  fillRule: "evenodd"
});

function SvgStarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$q({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$q);
}

function _extends$p() { _extends$p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p.apply(this, arguments); }

var _ref$p = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.998 33.989l.01-23.786 4.659 9.44 10.411 1.515-7.539 7.344.94 5.487.84 4.903-9.32-4.904zM8.88 43.14c-.154.926.236 1.866.975 2.382.431.317.946.477 1.458.477.395 0 .788-.096 1.141-.29l11.544-6.072 11.545 6.074c.814.427 1.872.344 2.6-.198a2.45 2.45 0 00.974-2.386l-2.206-12.88 9.361-9.117a2.453 2.453 0 00.605-2.508 2.453 2.453 0 00-1.983-1.671l-12.907-1.878-5.775-11.702A2.468 2.468 0 0024.007 2c-.938 0-1.805.54-2.203 1.369l-5.776 11.705-12.93 1.888a2.453 2.453 0 00-1.364 4.178l9.351 9.118L8.88 43.14z"
});

function SvgStarHalf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$p({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$p);
}

function _extends$o() { _extends$o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }

var _ref$o = /*#__PURE__*/React.createElement("path", {
  d: "M24.007 2c.932 0 1.798.539 2.205 1.372l5.775 11.702 12.907 1.878c.934.14 1.693.78 1.983 1.67.29.884.058 1.845-.605 2.509l-9.36 9.118 2.205 12.88a2.45 2.45 0 01-.975 2.385c-.727.542-1.785.625-2.599.198l-11.545-6.074-11.544 6.073c-.353.193-.746.289-1.14.289-.513 0-1.028-.16-1.459-.477-.739-.516-1.129-1.456-.975-2.382l2.205-12.883-9.35-9.118a2.453 2.453 0 011.364-4.178l12.93-1.888L21.803 3.37A2.454 2.454 0 0124.007 2zM24 10.205l-4.653 9.42-10.419 1.54 7.528 7.344-1.773 10.383L23.998 34l9.324 4.892L31.54 28.5l7.54-7.345-10.41-1.51-4.67-9.44z",
  fillRule: "evenodd"
});

function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$o({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$o);
}

function _extends$n() { _extends$n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }

var _ref$n = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M47 9.5C47 7.018 44.981 5 42.5 5h-37A4.505 4.505 0 001 9.5v29C1 40.981 3.019 43 5.5 43h37c2.481 0 4.5-2.019 4.5-4.5v-29zM42 38H6V10h36v28zM14.95 15.298c2.654-1.513 6.136-1.846 8.832-.236l-2.564 4.293c-.803-.48-2.322-.552-3.793.287C16.078 20.41 15 21.837 15 24s1.078 3.59 2.425 4.358c1.471.839 2.99.767 3.793.287l2.564 4.293c-2.697 1.61-6.178 1.277-8.832-.236C12.172 31.12 10 28.106 10 24s2.172-7.12 4.95-8.702zm23.092-.236c-2.696-1.61-6.178-1.277-8.832.236-2.778 1.583-4.95 4.596-4.95 8.702s2.172 7.12 4.95 8.702c2.654 1.513 6.136 1.846 8.832.236l-2.564-4.293c-.803.48-2.322.552-3.793-.287-1.347-.768-2.425-2.195-2.425-4.358s1.078-3.59 2.425-4.358c1.471-.838 2.99-.767 3.793-.287l2.564-4.293z"
});

function SvgSubtitle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$n({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$n);
}

function _extends$m() { _extends$m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }

var _ref$m = /*#__PURE__*/React.createElement("path", {
  d: "M26.5 35v5h-5v-5h5zM10 14a9 9 0 110 18 9 9 0 010-18zm28 0a9 9 0 110 18 9 9 0 010-18zM26.5 26v5h-5v-5h5zM10 19a4 4 0 100 8 4 4 0 000-8zm28 0a4 4 0 100 8 4 4 0 000-8zm-11.5-2v5h-5v-5h5zm0-9v5h-5V8h5z",
  fillRule: "evenodd"
});

function SvgSynonym(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$m({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$m);
}

function _extends$l() { _extends$l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }

var _ref$l = /*#__PURE__*/React.createElement("path", {
  d: "M46.8 27c-1.261 9.905-9.115 18.349-19.8 19.811v-5.059C34.795 40.404 40.474 34.386 41.748 27H46.8zM6.252 27c1.26 7.165 6.605 13.151 14.364 14.68l.384.072v5.059c-10.705-1.526-18.283-9.7-19.746-19.445L1.202 27h5.05zM24 20a4 4 0 110 8 4 4 0 010-8zm3.003-18.8c10.565 1.376 18.379 9.652 19.75 19.44l.047.36h-5.052c-1.184-7.105-6.753-13.285-14.375-14.696l-.37-.064V1.2zm-5.982 0v5.04C13.21 7.516 7.455 13.78 6.25 21H1.203c1.229-9.945 9.125-18.407 19.819-19.8z"
});

function SvgTarget(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$l({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$l);
}

function _extends$k() { _extends$k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }

var _ref$k = /*#__PURE__*/React.createElement("path", {
  d: "M40.302 7.721C44.62 12.038 46.999 17.812 47 23.98c0 6.168-2.38 11.942-6.698 16.257C34.616 45.917 28.609 47 10.18 47c-2.063 0-4.28-.014-6.672-.036l-2.455-.023-.022-2.454c-.017-1.9-.028-3.692-.03-5.382L1 37.245c.034-17.986 1.153-23.92 6.764-29.524 8.973-8.962 23.568-8.962 32.537 0zM11.3 11.255c-4.248 4.243-5.28 8.423-5.298 26.425v1.181c.001 1 .005 2.041.012 3.125 1.3.01 2.539.014 3.719.015h1.161c17.512-.028 21.654-1.085 25.872-5.299C40.142 33.332 42 28.812 42 23.98c0-4.832-1.86-9.35-5.234-12.725-7.02-7.014-18.442-7.013-25.466.001zM28 28v5H14v-5h14zm6-11v5H14v-5h20z",
  fillRule: "evenodd"
});

function SvgTextChatBubble(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$k({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$k);
}

function _extends$j() { _extends$j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }

var _ref$j = /*#__PURE__*/React.createElement("path", {
  d: "M18.515 46.5a13.88 13.88 0 01-8.032-2.547 14.058 14.058 0 018.032-25.565c.465 0 1.613.027 2.126.084v6.983a14.464 14.464 0 00-2.126-.16 7.148 7.148 0 107.114 7.418L25.643 1.5h6.9c.024.536.085 1.07.183 1.598a11.563 11.563 0 005.027 7.542 11.386 11.386 0 005.748 1.852v6.912a18.164 18.164 0 01-10.181-3.437l-.789-.569v17.046A14.052 14.052 0 0118.515 46.5z"
});

function SvgTiktok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$j({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$j);
}

function _extends$i() { _extends$i = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$i.apply(this, arguments); }

var _ref$i = /*#__PURE__*/React.createElement("path", {
  d: "M24.5 10a2.56 2.56 0 011.764.699l13.736 13-3.528 3.602L27 18.378V47h-4.998V18.378l-9.472 8.923L9 23.699l13.736-13A2.563 2.563 0 0124.5 10zM44 1v5H4V1h40z",
  fillRule: "evenodd"
});

function SvgTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$i({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$i);
}

function _extends$h() { _extends$h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }

var _ref$h = /*#__PURE__*/React.createElement("path", {
  d: "M35.5 1C39.084 1 42 3.916 42 7.5v23c0 3.103-2.185 5.705-5.097 6.348l4.422 7.654-4.325 2.5L31.221 37c-3.775 0-7.033-.022-9.775-.026h-1.404a204.3 204.3 0 00-3.27.026L11 47.002l-4.33-2.5 4.427-7.655C8.185 36.204 6 33.602 6 30.5v-23C6 3.916 8.916 1 12.5 1zm0 5h-23c-.827 0-1.5.673-1.5 1.5v23c0 .628.788 1.5 1.5 1.5h23c.789 0 1.5-.647 1.5-1.5v-23c0-.827-.673-1.5-1.5-1.5zm-18 17a2.5 2.5 0 110 5 2.5 2.5 0 010-5zm13 0a2.5 2.5 0 110 5 2.5 2.5 0 010-5zM33 10v5H15v-5h18z",
  fillRule: "evenodd"
});

function SvgTrain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$h({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$h);
}

function _extends$g() { _extends$g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }

var _ref$g = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M42.445 18.735c0-.102-.104-.205-.208-.205h-.91c-.104 0-.208.103-.208.205v3.393c0 .045-.046.045-.104 0l-1.268-3.45c0-.102-.104-.148-.254-.148h-1.107c-.104 0-.208.103-.208.205v5.988c0 .102.104.205.208.205H39.4c.103 0 .207-.103.207-.205V21.58c0-.045.046-.045.104 0l1.268 3.199c0 .045.104.148.254.148h1.061c.104 0 .208-.103.208-.205l-.058-5.988zm-5.155 5.089c0-.103-.103-.205-.207-.205h-.761c-.047 0-.104-.046-.104-.103v-3.745c0-.045.046-.102.104-.102h.703c.104 0 .208-.103.208-.205v-.751c0-.103-.104-.205-.208-.205h-2.837c-.104 0-.207.102-.207.205v.853c0 .103.103.205.207.205h.658c.046 0 .103.046.103.103v3.745c0 .045-.046.102-.103.102h-.761c-.104 0-.208.103-.208.205v.854c0 .102.104.205.207.205h3.033c.104 0 .208-.103.208-.205l-.035-.956zm-8.233-3.939H2.51c-.046 0-.104.046-.104.102v12.476c0 .046.046.103.104.103h26.442c.046 0 .104-.046.104-.103V19.885zM47 14.695v14.069a.68.68 0 01-.703.694h-15.88v3.848a.68.68 0 01-.703.694H1.704C1.3 33.955 1 33.647 1 33.249V19.236c0-.398.3-.694.703-.694h27.354v-3.848c0-.398.3-.694.703-.694h16.537a.68.68 0 01.703.694zM25.009 28.171h-2.18c-.046 0-.103-.046-.103-.103v-1.092c0-.046.046-.103.104-.103h2.075c.104 0 .208-.102.208-.205v-.899c0-.102-.104-.205-.208-.205H22.83c-.046 0-.103-.045-.103-.102V24.37c0-.046.046-.103.104-.103h2.121c.104 0 .208-.102.208-.204v-.9c0-.102-.104-.204-.208-.204H21.62c-.104 0-.208.102-.208.204v5.988c0 .102.104.205.208.205h3.39c.104 0 .208-.103.208-.205v-.9c-.058-.034-.104-.08-.208-.08zM20.2 23.084h-.91c-.104 0-.208.102-.208.205v3.392c0 .045-.046.045-.104 0l-1.269-3.45c0-.102-.103-.147-.253-.147h-1.107c-.104 0-.208.102-.208.205v5.987c0 .102.104.205.208.205h.91c.104 0 .208-.103.208-.205v-3.153c0-.046.046-.046.104 0l1.269 3.199c0 .045.103.148.253.148H20.2c.104 0 .208-.103.208-.205v-5.988c0-.102-.104-.193-.208-.193zm-5.154 0h-.911c-.104 0-.208.102-.208.205v4.245c0 .399-.3.752-.911.752-.553 0-.865-.296-.865-.752v-4.257c0-.102-.104-.205-.207-.205h-.911c-.104 0-.208.103-.208.205v4.246c0 1.093.911 1.992 2.18 1.992 1.268 0 2.179-.9 2.179-1.992v-4.246c.011-.102-.035-.193-.138-.193zm-5.051.148v.899c0 .102-.104.205-.208.205H8.622c-.046 0-.103.045-.103.102v4.793c0 .102-.104.204-.208.204h-.91c-.105 0-.208-.102-.208-.204v-4.793c0-.045-.047-.102-.104-.102H6.028c-.104 0-.208-.103-.208-.205v-.9c0-.102.104-.204.208-.204h3.794c.069.057.173.148.173.205z"
});

function SvgTunein(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$g({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$g);
}

function _extends$f() { _extends$f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }

var _ref$f = /*#__PURE__*/React.createElement("path", {
  d: "M23.5 1c8.68 0 11.561 5.165 12.449 9.498l-4.898 1.004C30.271 7.697 27.941 6 23.5 6c-3.979 0-6.168 2.978-6.5 5.166l-.001 7.788H41v23.5c0 2.481-2.019 4.5-4.5 4.5h-25a4.505 4.505 0 01-4.5-4.5v-23.5h5.001l.017-8.251C12.58 5.999 16.795 1 23.5 1zM36 23.954H12v18h24v-18zm-12 5.5a3 3 0 110 6 3 3 0 010-6z",
  fillRule: "evenodd"
});

function SvgUnlock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$f({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$f);
}

function _extends$e() { _extends$e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }

var _ref$e = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M25.736 1.699A2.496 2.496 0 0024 1a2.5 2.5 0 00-1.736.699l-13.514 13 3.473 3.602 9.275-8.923V37h5.005V9.378l9.276 8.923 3.471-3.602-13.514-13zM7.5 47h33c3.584 0 6.5-2.916 6.5-6.5V30h-5v10.5c0 .827-.673 1.5-1.5 1.5h-33c-.827 0-1.5-.673-1.5-1.5V30H1v10.5C1 44.084 3.916 47 7.5 47z"
});

function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$e({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$e);
}

function _extends$d() { _extends$d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }

var _ref$d = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.949 42.001c-6.812 0-12.61-3.854-14.992-9.771 5.024-2.477 10.058-3.731 14.992-3.731 2.435 0 4.928.312 7.41.928l1.208-4.853a35.887 35.887 0 00-8.618-1.074c-6.391 0-12.866 1.787-19.245 5.312L1 29.754l.495 1.879C3.913 40.824 12.133 47 21.949 47c3.182 0 6.227-.649 9.05-1.932l-2.073-4.549c-2.168.983-4.515 1.482-6.977 1.482M47 32h-5v-5h-5v5h-5v5h5v5h5v-5h5zM22 6c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4m0 13c4.963 0 9-4.038 9-9s-4.037-9-9-9c-4.962 0-9 4.038-9 9s4.038 9 9 9"
}));

function SvgUserCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$d({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$d);
}

function _extends$c() { _extends$c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }

var _ref$c = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M40.684 2.304L38.282 3 37.167.762a2.5 2.5 0 013.517 1.542zm-15.576 30.26c-.403-.18-.794-.383-1.172-.61l2.577-4.286c.203.122.413.232.63.329 3.078 1.372 7.14-.152 8.855-4.003 1.655-3.714 1.719-8.667 1.248-12.97a50.969 50.969 0 00-.643-4.21 53.974 53.974 0 00-3.628 2.406c-3.536 2.563-7.163 5.913-8.767 9.495a8.906 8.906 0 00-.7 3.642l-4.998.1a13.902 13.902 0 011.122-5.757c2.159-4.845 6.708-8.846 10.41-11.528a59.388 59.388 0 014.956-3.22A50.901 50.901 0 0136.994.85l.122-.063.035-.017.01-.006.005-.002L38.282 3l2.402-.695.002.006.003.011.01.038c.01.03.022.075.037.13.03.113.074.273.126.477.105.409.248.994.407 1.72.315 1.45.695 3.477.948 5.794.496 4.536.559 10.588-1.652 15.549-2.672 5.997-9.496 9.19-15.457 6.534z"
});

var _ref2$1 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M19.496 38.876l4.302-9.635 4.565 2.038-6.58 14.74a2.5 2.5 0 01-4.638-.18s0 .001 0 0m2.351-6.963a43.5 43.5 0 00-1.824-3.186c-1.334-2.109-3.03-4.334-5.072-6.057-2.045-1.724-4.606-3.08-7.6-3.08v5c1.418 0 2.875.637 4.377 1.903 1.503 1.267 2.88 3.028 4.07 4.907 1.177 1.862 2.108 3.743 2.747 5.168a41.795 41.795 0 01.899 2.166l.042.114.009.025v.002"
});

var _ref3$1 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M23.797 29.24l5.92-13.26 4.566 2.04-5.92 13.26-4.566-2.04z"
});

function SvgVegan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$c({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$c, _ref2$1, _ref3$1);
}

function _extends$b() { _extends$b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }

var _ref$b = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M39.858 3.052l-4.513 9.733-4.536-2.103L35.322.948l4.536 2.104z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M34.94 12.503l10.044-4.466 2.032 4.569-10.045 4.466-2.031-4.569zm-11.394 1.565l5.42 5.525-3.57 3.501-5.419-5.524 3.57-3.502zm-7.052 7.047l5.42 5.525-3.57 3.502-5.42-5.525 3.57-3.502z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M23.953 9.384a6.51 6.51 0 019.187.014l5.468 5.464a6.505 6.505 0 01-.015 9.216l-2.271 2.255-1.74-1.759 1.74 1.759-.016.016-.042.04a60.627 60.627 0 01-.748.725 157.06 157.06 0 01-9.541 8.391c-2.932 2.367-6.248 4.844-9.563 6.9-3.28 2.034-6.72 3.762-9.877 4.482l-.011.002-.011.002a4.54 4.54 0 01-5.405-5.4l.003-.013.003-.012c.72-3.153 2.446-6.594 4.478-9.873 2.055-3.315 4.53-6.633 6.894-9.566a157.501 157.501 0 018.953-10.14 52.3 52.3 0 01.153-.157l.04-.042.016-.016 1.78 1.756-1.78-1.756.01-.009 2.295-2.28zm1.246 5.809l-.002.001-.034.035-.138.142a138.334 138.334 0 00-2.505 2.665 152.604 152.604 0 00-6.142 7.13c-2.29 2.84-4.628 5.982-6.536 9.06-1.725 2.785-3.016 5.387-3.655 7.587 2.202-.637 4.805-1.93 7.589-3.657 3.078-1.909 6.218-4.248 9.056-6.54a152.001 152.001 0 009.787-8.655l.142-.139.04-.04.002-.002.002-.001 2.266-2.25a1.503 1.503 0 00.003-2.13l-5.468-5.464a1.511 1.511 0 00-2.13-.003m0 0l-2.277 2.26 2.276-2.26z"
});

function SvgVegetarian(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$b, _ref2, _ref3);
}

function _extends$a() { _extends$a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }

var _ref$a = /*#__PURE__*/React.createElement("path", {
  d: "M38 41v5H10v-5h28zm2.5-38C44.084 3 47 5.916 47 9.5v22c0 3.584-2.916 6.5-6.5 6.5h-33A6.508 6.508 0 011 31.5v-22C1 5.916 3.916 3 7.5 3zm0 5h-33C6.673 8 6 8.673 6 9.5v22c0 .628.788 1.5 1.5 1.5h33c.789 0 1.5-.647 1.5-1.5v-22c0-.827-.673-1.5-1.5-1.5zm-22.948 4.15a1.05 1.05 0 011.1.01l11.812 7.352c.332.207.536.582.536.988s-.204.781-.536.988L18.65 28.839a1.048 1.048 0 01-1.099.01 1.16 1.16 0 01-.552-.998V13.148c0-.412.21-.793.552-.998z",
  fillRule: "evenodd"
});

function SvgVideoChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$a);
}

function _extends$9() { _extends$9 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }

var _ref$9 = /*#__PURE__*/React.createElement("path", {
  d: "M42 28.576L35.736 24 42 19.423v9.153zM6 35h23V13H6v22zm39.085-21.652a3.486 3.486 0 00-3.649.295L34 19.076V12.5c0-2.482-2.019-4.5-4.5-4.5h-24A4.505 4.505 0 001 12.5v23C1 37.981 3.019 40 5.5 40h24c2.481 0 4.5-2.019 4.5-4.5v-6.576l7.434 5.43a3.475 3.475 0 003.649.298A3.482 3.482 0 0047 31.531V16.469c0-1.325-.734-2.52-1.915-3.121z",
  fillRule: "evenodd"
});

function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$9);
}

function _extends$8() { _extends$8 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }

var _ref$8 = /*#__PURE__*/React.createElement("path", {
  d: "M27.954 1v5h-1.503v5.23a12.96 12.96 0 016.256 3.117l2.215-1.74-.928-1.142 3.886-3.147 5.034 6.217-3.886 3.147-.968-1.184-2.353 1.843C36.569 20.76 37 22.648 37 24c0 2.005-.454 3.904-1.265 5.6l6.33 4.938.924-1.138 3.885 3.147-5.034 6.217-3.886-3.147.97-1.189-6.167-4.82a12.96 12.96 0 01-6.303 3.16V42h1.5v5h-8v-5h1.5v-.655l.002-.901v-.546l.001-.257v-.48l.001-.224.001-.607v-.655l.001-.136v-.65l.001-.05v-.087a12.965 12.965 0 01-6.333-3.25l-3.22 2.524.966 1.191-3.885 3.147-5.035-6.217L7.84 31l.924 1.143 3.434-2.685A12.951 12.951 0 0111 24c0-2.268.581-4.401 1.602-6.257l-.015-.012-5.612-4.382-1.09 1.342L2 11.545l5.035-6.217 3.885 3.146-.796.983 5.682 4.45a12.948 12.948 0 015.648-2.658V6h-1.5V1h8zM24 16a8 8 0 100 16 8 8 0 000-16z",
  fillRule: "evenodd"
});

function SvgVirus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$8);
}

function _extends$7() { _extends$7 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }

var _ref$7 = /*#__PURE__*/React.createElement("path", {
  d: "M36.971 1.405a3.733 3.733 0 012.03 3.326v11.243h-5v-8.77L16.756 18.98H9v10.022h7.757L34 40.778v-8.77h5v11.354A3.624 3.624 0 0135.383 47a3.585 3.585 0 01-2.088-.672L15.243 34.013H4V13.969h11.242L33.358 1.612c1.014-.724 2.423-.821 3.613-.207zM44.5 21.5v5h-16v-5h16z",
  fillRule: "evenodd"
});

function SvgVolumeDecrease(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$7);
}

function _extends$6() { _extends$6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }

var _ref$6 = /*#__PURE__*/React.createElement("path", {
  d: "M36.971 1.405A3.733 3.733 0 0139 4.73V12h-5V7.204L16.757 18.98H9v10.022h7.757L34 40.778V36h5v7.362A3.624 3.624 0 0135.383 47a3.585 3.585 0 01-2.088-.672L15.243 34.013H4V13.969h11.242L33.358 1.612c1.014-.724 2.423-.821 3.613-.207zM39 16v5.5h5.5v5H39V32h-5v-5.5h-5.5v-5H34V16h5z",
  fillRule: "evenodd"
});

function SvgVolumeIncrease(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$6);
}

function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

var _ref$5 = /*#__PURE__*/React.createElement("path", {
  d: "M30.045 4.388A3.588 3.588 0 0132 7.588v33.905a3.495 3.495 0 01-1.898 3.118 3.491 3.491 0 01-1.597.389c-.71 0-1.416-.219-2.02-.648L11.203 33.5H1V15.487l10.203.011L26.486 4.629a3.418 3.418 0 013.559-.241zM27 10.4L12.797 20.5 6 20.493v8.006h6.797L27 38.584V10.4zm9 3.6c5.79 0 10.5 4.71 10.5 10.5S41.79 35 36 35v-5c3.032 0 5.5-2.468 5.5-5.5 0-3.033-2.468-5.5-5.5-5.5v-5z",
  fillRule: "evenodd"
});

function SvgVolumeMedium(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$5);
}

function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }

var _ref$4 = /*#__PURE__*/React.createElement("path", {
  d: "M35.971 1.405A3.733 3.733 0 0138 4.73V12h-5V7.204L15.757 18.98H8v10.022h7.757L33 40.778V36h5v7.362A3.624 3.624 0 0134.383 47a3.585 3.585 0 01-2.088-.672L14.243 34.013H3V13.969h11.242L32.358 1.612c1.014-.724 2.423-.821 3.613-.207zm4.75 13.844l3.529 3.528L39.028 24l5.222 5.222-3.528 3.53-5.222-5.223-5.222 5.222-3.528-3.529L31.972 24l-5.222-5.222 3.528-3.528 5.222 5.223 5.222-5.223z",
  fillRule: "evenodd"
});

function SvgVolumeMute(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$4);
}

function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

var _ref$3 = /*#__PURE__*/React.createElement("path", {
  d: "M40.5 8c.827 0 1.5.673 1.5 1.5v22c0 .853-.711 1.5-1.5 1.5h-33c-.712 0-1.5-.872-1.5-1.5v-22C6 8.673 6.673 8 7.5 8h33zm-33-5A6.508 6.508 0 001 9.5v22C1 35.084 3.916 38 7.5 38h33c3.584 0 6.5-2.916 6.5-6.5v-22C47 5.916 44.084 3 40.5 3h-33zM10 41h28v5H10v-5z"
});

function SvgWeb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _ref$3);
}

function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

var _ref$2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.6 30.429V17.57L31.03 24 19.6 30.429zm25.48-16.744c-.505-1.844-1.997-3.297-3.889-3.79C37.76 9 24 9 24 9s-13.76 0-17.19.895c-1.893.493-3.385 1.946-3.89 3.79C2 17.026 2 24 2 24s0 6.974.92 10.316c.505 1.843 1.997 3.296 3.89 3.789C10.24 39 24 39 24 39s13.76 0 17.191-.895c1.892-.493 3.384-1.946 3.89-3.789C46 30.973 46 24 46 24s0-6.974-.92-10.315z"
});

function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$2);
}

function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

var _ref$1 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5 1C28.149 1 36 8.851 36 18.5c0 3.924-1.314 7.539-3.504 10.461L47 43.465 43.465 47 28.961 32.496C26.039 34.686 22.424 36 18.5 36 8.851 36 1 28.149 1 18.5 1 8.851 8.851 1 18.5 1zm0 5C11.607 6 6 11.607 6 18.5S11.607 31 18.5 31 31 25.393 31 18.5 25.393 6 18.5 6zm2.5 5v5h5v5h-5v5h-5v-5h-5v-5h5v-5h5z",
  fillRule: "evenodd"
});

function SvgZoomIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref$1);
}

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18.5 1C28.149 1 36 8.851 36 18.5c0 3.924-1.314 7.539-3.504 10.461L47 43.465 43.465 47 28.961 32.496C26.039 34.686 22.424 36 18.5 36 8.851 36 1 28.149 1 18.5 1 8.851 8.851 1 18.5 1zm0 5C11.607 6 6 11.607 6 18.5S11.607 31 18.5 31 31 25.393 31 18.5 25.393 6 18.5 6zM26 16v5H11v-5h15z",
  fillRule: "evenodd"
});

function SvgZoomOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

var AddressBook = function AddressBook(props) {
  return /*#__PURE__*/React__default.createElement(SvgAddressBook, props);
};
var AlertCircleFilled = function AlertCircleFilled(props) {
  return /*#__PURE__*/React__default.createElement(SvgAlertCircleFilled, props);
};
var AlertCircle = function AlertCircle(props) {
  return /*#__PURE__*/React__default.createElement(SvgAlertCircle, props);
};
var Amazonmusic = function Amazonmusic(props) {
  return /*#__PURE__*/React__default.createElement(SvgAmazonmusic, props);
};
var Applepodcast = function Applepodcast(props) {
  return /*#__PURE__*/React__default.createElement(SvgApplepodcast, props);
};
var ArrowDown = function ArrowDown(props) {
  return /*#__PURE__*/React__default.createElement(SvgArrowDown, props);
};
var ArrowLeftCircleFilled = function ArrowLeftCircleFilled(props) {
  return /*#__PURE__*/React__default.createElement(SvgArrowLeftCircleFilled, props);
};
var ArrowLeftCircle = function ArrowLeftCircle(props) {
  return /*#__PURE__*/React__default.createElement(SvgArrowLeftCircle, props);
};
var ArrowLeftReply = function ArrowLeftReply(props) {
  return /*#__PURE__*/React__default.createElement(SvgArrowLeftReply, props);
};
var ArrowLeft = function ArrowLeft(props) {
  return /*#__PURE__*/React__default.createElement(SvgArrowLeft, props);
};
var ArrowRightCircleFilled = function ArrowRightCircleFilled(props) {
  return /*#__PURE__*/React__default.createElement(SvgArrowRightCircleFilled, props);
};
var ArrowRightCircle = function ArrowRightCircle(props) {
  return /*#__PURE__*/React__default.createElement(SvgArrowRightCircle, props);
};
var ArrowRightReply = function ArrowRightReply(props) {
  return /*#__PURE__*/React__default.createElement(SvgArrowRightReply, props);
};
var ArrowRight = function ArrowRight(props) {
  return /*#__PURE__*/React__default.createElement(SvgArrowRight, props);
};
var ArrowRoundedDown = function ArrowRoundedDown(props) {
  return /*#__PURE__*/React__default.createElement(SvgArrowRoundedDown, props);
};
var ArrowRoundedLeft = function ArrowRoundedLeft(props) {
  return /*#__PURE__*/React__default.createElement(SvgArrowRoundedLeft, props);
};
var ArrowRoundedLeftdown = function ArrowRoundedLeftdown(props) {
  return /*#__PURE__*/React__default.createElement(SvgArrowRoundedLeftdown, props);
};
var ArrowRoundedLeftup = function ArrowRoundedLeftup(props) {
  return /*#__PURE__*/React__default.createElement(SvgArrowRoundedLeftup, props);
};
var ArrowRoundedRight = function ArrowRoundedRight(props) {
  return /*#__PURE__*/React__default.createElement(SvgArrowRoundedRight, props);
};
var ArrowRoundedRightdown = function ArrowRoundedRightdown(props) {
  return /*#__PURE__*/React__default.createElement(SvgArrowRoundedRightdown, props);
};
var ArrowRoundedRightup = function ArrowRoundedRightup(props) {
  return /*#__PURE__*/React__default.createElement(SvgArrowRoundedRightup, props);
};
var ArrowRoundedUp = function ArrowRoundedUp(props) {
  return /*#__PURE__*/React__default.createElement(SvgArrowRoundedUp, props);
};
var ArrowSmallDown = function ArrowSmallDown(props) {
  return /*#__PURE__*/React__default.createElement(SvgArrowSmallDown, props);
};
var ArrowSmallLeft = function ArrowSmallLeft(props) {
  return /*#__PURE__*/React__default.createElement(SvgArrowSmallLeft, props);
};
var ArrowSmallRight = function ArrowSmallRight(props) {
  return /*#__PURE__*/React__default.createElement(SvgArrowSmallRight, props);
};
var ArrowSmallUp = function ArrowSmallUp(props) {
  return /*#__PURE__*/React__default.createElement(SvgArrowSmallUp, props);
};
var ArrowUp = function ArrowUp(props) {
  return /*#__PURE__*/React__default.createElement(SvgArrowUp, props);
};
var Attachment = function Attachment(props) {
  return /*#__PURE__*/React__default.createElement(SvgAttachment, props);
};
var Audio = function Audio(props) {
  return /*#__PURE__*/React__default.createElement(SvgAudio, props);
};
var Backward = function Backward(props) {
  return /*#__PURE__*/React__default.createElement(SvgBackward, props);
};
var Backwards = function Backwards(props) {
  return /*#__PURE__*/React__default.createElement(SvgBackwards, props);
};
var Bank = function Bank(props) {
  return /*#__PURE__*/React__default.createElement(SvgBank, props);
};
var BecomeMember = function BecomeMember(props) {
  return /*#__PURE__*/React__default.createElement(SvgBecomeMember, props);
};
var Bell = function Bell(props) {
  return /*#__PURE__*/React__default.createElement(SvgBell, props);
};
var Blocked = function Blocked(props) {
  return /*#__PURE__*/React__default.createElement(SvgBlocked, props);
};
var BookmarkFilled = function BookmarkFilled(props) {
  return /*#__PURE__*/React__default.createElement(SvgBookmarkFilled, props);
};
var Bookmark = function Bookmark(props) {
  return /*#__PURE__*/React__default.createElement(SvgBookmark, props);
};
var BookmarksList = function BookmarksList(props) {
  return /*#__PURE__*/React__default.createElement(SvgBookmarksList, props);
};
var BoxMail = function BoxMail(props) {
  return /*#__PURE__*/React__default.createElement(SvgBoxMail, props);
};
var BrandAndroid = function BrandAndroid(props) {
  return /*#__PURE__*/React__default.createElement(SvgBrandAndroid, props);
};
var BrandApple = function BrandApple(props) {
  return /*#__PURE__*/React__default.createElement(SvgBrandApple, props);
};
var BrandWindows = function BrandWindows(props) {
  return /*#__PURE__*/React__default.createElement(SvgBrandWindows, props);
};
var BubbleLines = function BubbleLines(props) {
  return /*#__PURE__*/React__default.createElement(SvgBubbleLines, props);
};
var BubbleStar = function BubbleStar(props) {
  return /*#__PURE__*/React__default.createElement(SvgBubbleStar, props);
};
var BubbleVideo = function BubbleVideo(props) {
  return /*#__PURE__*/React__default.createElement(SvgBubbleVideo, props);
};
var Bubbles = function Bubbles(props) {
  return /*#__PURE__*/React__default.createElement(SvgBubbles, props);
};
var CalendarCheck = function CalendarCheck(props) {
  return /*#__PURE__*/React__default.createElement(SvgCalendarCheck, props);
};
var Calendar = function Calendar(props) {
  return /*#__PURE__*/React__default.createElement(SvgCalendar, props);
};
var Calories = function Calories(props) {
  return /*#__PURE__*/React__default.createElement(SvgCalories, props);
};
var Camera = function Camera(props) {
  return /*#__PURE__*/React__default.createElement(SvgCamera, props);
};
var CancelCircleFilled = function CancelCircleFilled(props) {
  return /*#__PURE__*/React__default.createElement(SvgCancelCircleFilled, props);
};
var CancelCircle = function CancelCircle(props) {
  return /*#__PURE__*/React__default.createElement(SvgCancelCircle, props);
};
var CaretDown = function CaretDown(props) {
  return /*#__PURE__*/React__default.createElement(SvgCaretDown, props);
};
var CaretDrag = function CaretDrag(props) {
  return /*#__PURE__*/React__default.createElement(SvgCaretDrag, props);
};
var CaretLeft = function CaretLeft(props) {
  return /*#__PURE__*/React__default.createElement(SvgCaretLeft, props);
};
var CaretRight = function CaretRight(props) {
  return /*#__PURE__*/React__default.createElement(SvgCaretRight, props);
};
var CaretSelect = function CaretSelect(props) {
  return /*#__PURE__*/React__default.createElement(SvgCaretSelect, props);
};
var CaretUp = function CaretUp(props) {
  return /*#__PURE__*/React__default.createElement(SvgCaretUp, props);
};
var ChatBubble = function ChatBubble(props) {
  return /*#__PURE__*/React__default.createElement(SvgChatBubble, props);
};
var CheckmarkCircleFilled = function CheckmarkCircleFilled(props) {
  return /*#__PURE__*/React__default.createElement(SvgCheckmarkCircleFilled, props);
};
var CheckmarkCircle = function CheckmarkCircle(props) {
  return /*#__PURE__*/React__default.createElement(SvgCheckmarkCircle, props);
};
var Checkmark = function Checkmark(props) {
  return /*#__PURE__*/React__default.createElement(SvgCheckmark, props);
};
var Clipboard = function Clipboard(props) {
  return /*#__PURE__*/React__default.createElement(SvgClipboard, props);
};
var Clock = function Clock(props) {
  return /*#__PURE__*/React__default.createElement(SvgClock, props);
};
var CloseSmall = function CloseSmall(props) {
  return /*#__PURE__*/React__default.createElement(SvgCloseSmall, props);
};
var Close = function Close(props) {
  return /*#__PURE__*/React__default.createElement(SvgClose, props);
};
var Compare = function Compare(props) {
  return /*#__PURE__*/React__default.createElement(SvgCompare, props);
};
var Copy = function Copy(props) {
  return /*#__PURE__*/React__default.createElement(SvgCopy, props);
};
var CustomerCentre = function CustomerCentre(props) {
  return /*#__PURE__*/React__default.createElement(SvgCustomerCentre, props);
};
var Deezer = function Deezer(props) {
  return /*#__PURE__*/React__default.createElement(SvgDeezer, props);
};
var Delete = function Delete(props) {
  return /*#__PURE__*/React__default.createElement(SvgDelete, props);
};
var Documents = function Documents(props) {
  return /*#__PURE__*/React__default.createElement(SvgDocuments, props);
};
var DoubleArrowLeftForward = function DoubleArrowLeftForward(props) {
  return /*#__PURE__*/React__default.createElement(SvgDoubleArrowLeftForward, props);
};
var DownloadCircleFilled = function DownloadCircleFilled(props) {
  return /*#__PURE__*/React__default.createElement(SvgDownloadCircleFilled, props);
};
var DownloadFolder = function DownloadFolder(props) {
  return /*#__PURE__*/React__default.createElement(SvgDownloadFolder, props);
};
var Download = function Download(props) {
  return /*#__PURE__*/React__default.createElement(SvgDownload, props);
};
var EasyLanguage = function EasyLanguage(props) {
  return /*#__PURE__*/React__default.createElement(SvgEasyLanguage, props);
};
var Edit = function Edit(props) {
  return /*#__PURE__*/React__default.createElement(SvgEdit, props);
};
var Enlarge = function Enlarge(props) {
  return /*#__PURE__*/React__default.createElement(SvgEnlarge, props);
};
var EnterLogin = function EnterLogin(props) {
  return /*#__PURE__*/React__default.createElement(SvgEnterLogin, props);
};
var Equalizer = function Equalizer(props) {
  return /*#__PURE__*/React__default.createElement(SvgEqualizer, props);
};
var Exit = function Exit(props) {
  return /*#__PURE__*/React__default.createElement(SvgExit, props);
};
var ExpandArrow = function ExpandArrow(props) {
  return /*#__PURE__*/React__default.createElement(SvgExpandArrow, props);
};
var EyeClosed = function EyeClosed(props) {
  return /*#__PURE__*/React__default.createElement(SvgEyeClosed, props);
};
var EyeOpen = function EyeOpen(props) {
  return /*#__PURE__*/React__default.createElement(SvgEyeOpen, props);
};
var Fax = function Fax(props) {
  return /*#__PURE__*/React__default.createElement(SvgFax, props);
};
var File = function File(props) {
  return /*#__PURE__*/React__default.createElement(SvgFile, props);
};
var Filter = function Filter(props) {
  return /*#__PURE__*/React__default.createElement(SvgFilter, props);
};
var Fish = function Fish(props) {
  return /*#__PURE__*/React__default.createElement(SvgFish, props);
};
var Flag = function Flag(props) {
  return /*#__PURE__*/React__default.createElement(SvgFlag, props);
};
var Folder = function Folder(props) {
  return /*#__PURE__*/React__default.createElement(SvgFolder, props);
};
var Form = function Form(props) {
  return /*#__PURE__*/React__default.createElement(SvgForm, props);
};
var Forms = function Forms(props) {
  return /*#__PURE__*/React__default.createElement(SvgForms, props);
};
var Forward = function Forward(props) {
  return /*#__PURE__*/React__default.createElement(SvgForward, props);
};
var Globe = function Globe(props) {
  return /*#__PURE__*/React__default.createElement(SvgGlobe, props);
};
var Googlepodcast = function Googlepodcast(props) {
  return /*#__PURE__*/React__default.createElement(SvgGooglepodcast, props);
};
var Grid = function Grid(props) {
  return /*#__PURE__*/React__default.createElement(SvgGrid, props);
};
var Headphones = function Headphones(props) {
  return /*#__PURE__*/React__default.createElement(SvgHeadphones, props);
};
var HeartBubble = function HeartBubble(props) {
  return /*#__PURE__*/React__default.createElement(SvgHeartBubble, props);
};
var HeartFilled = function HeartFilled(props) {
  return /*#__PURE__*/React__default.createElement(SvgHeartFilled, props);
};
var Heart = function Heart(props) {
  return /*#__PURE__*/React__default.createElement(SvgHeart, props);
};
var Home = function Home(props) {
  return /*#__PURE__*/React__default.createElement(SvgHome, props);
};
var Image = function Image(props) {
  return /*#__PURE__*/React__default.createElement(SvgImage, props);
};
var Images = function Images(props) {
  return /*#__PURE__*/React__default.createElement(SvgImages, props);
};
var InfoCircleFilled = function InfoCircleFilled(props) {
  return /*#__PURE__*/React__default.createElement(SvgInfoCircleFilled, props);
};
var InfoCircle = function InfoCircle(props) {
  return /*#__PURE__*/React__default.createElement(SvgInfoCircle, props);
};
var Keyword = function Keyword(props) {
  return /*#__PURE__*/React__default.createElement(SvgKeyword, props);
};
var Language = function Language(props) {
  return /*#__PURE__*/React__default.createElement(SvgLanguage, props);
};
var Link = function Link(props) {
  return /*#__PURE__*/React__default.createElement(SvgLink, props);
};
var List = function List(props) {
  return /*#__PURE__*/React__default.createElement(SvgList, props);
};
var Load = function Load(props) {
  return /*#__PURE__*/React__default.createElement(SvgLoad, props);
};
var Location = function Location(props) {
  return /*#__PURE__*/React__default.createElement(SvgLocation, props);
};
var Lock = function Lock(props) {
  return /*#__PURE__*/React__default.createElement(SvgLock, props);
};
var Login = function Login(props) {
  return /*#__PURE__*/React__default.createElement(SvgLogin, props);
};
var MailOpen = function MailOpen(props) {
  return /*#__PURE__*/React__default.createElement(SvgMailOpen, props);
};
var Mail = function Mail(props) {
  return /*#__PURE__*/React__default.createElement(SvgMail, props);
};
var Mailbox = function Mailbox(props) {
  return /*#__PURE__*/React__default.createElement(SvgMailbox, props);
};
var Map = function Map(props) {
  return /*#__PURE__*/React__default.createElement(SvgMap, props);
};
var Meat = function Meat(props) {
  return /*#__PURE__*/React__default.createElement(SvgMeat, props);
};
var MenuDotsHorizontal = function MenuDotsHorizontal(props) {
  return /*#__PURE__*/React__default.createElement(SvgMenuDotsHorizontal, props);
};
var MenuDotsVertical = function MenuDotsVertical(props) {
  return /*#__PURE__*/React__default.createElement(SvgMenuDotsVertical, props);
};
var MenuMobile = function MenuMobile(props) {
  return /*#__PURE__*/React__default.createElement(SvgMenuMobile, props);
};
var Menu = function Menu(props) {
  return /*#__PURE__*/React__default.createElement(SvgMenu, props);
};
var Mic = function Mic(props) {
  return /*#__PURE__*/React__default.createElement(SvgMic, props);
};
var Microphone = function Microphone(props) {
  return /*#__PURE__*/React__default.createElement(SvgMicrophone, props);
};
var Minus = function Minus(props) {
  return /*#__PURE__*/React__default.createElement(SvgMinus, props);
};
var MobilePhone = function MobilePhone(props) {
  return /*#__PURE__*/React__default.createElement(SvgMobilePhone, props);
};
var Mobile = function Mobile(props) {
  return /*#__PURE__*/React__default.createElement(SvgMobile, props);
};
var NewTab = function NewTab(props) {
  return /*#__PURE__*/React__default.createElement(SvgNewTab, props);
};
var Office = function Office(props) {
  return /*#__PURE__*/React__default.createElement(SvgOffice, props);
};
var Parking = function Parking(props) {
  return /*#__PURE__*/React__default.createElement(SvgParking, props);
};
var Pastries = function Pastries(props) {
  return /*#__PURE__*/React__default.createElement(SvgPastries, props);
};
var PauseCircleFilled = function PauseCircleFilled(props) {
  return /*#__PURE__*/React__default.createElement(SvgPauseCircleFilled, props);
};
var PauseCircle = function PauseCircle(props) {
  return /*#__PURE__*/React__default.createElement(SvgPauseCircle, props);
};
var Pause = function Pause(props) {
  return /*#__PURE__*/React__default.createElement(SvgPause, props);
};
var PhoneCallback = function PhoneCallback(props) {
  return /*#__PURE__*/React__default.createElement(SvgPhoneCallback, props);
};
var Phone = function Phone(props) {
  return /*#__PURE__*/React__default.createElement(SvgPhone, props);
};
var Piggybank = function Piggybank(props) {
  return /*#__PURE__*/React__default.createElement(SvgPiggybank, props);
};
var Pin = function Pin(props) {
  return /*#__PURE__*/React__default.createElement(SvgPin, props);
};
var PlayCircleFilled = function PlayCircleFilled(props) {
  return /*#__PURE__*/React__default.createElement(SvgPlayCircleFilled, props);
};
var PlayCircle = function PlayCircle(props) {
  return /*#__PURE__*/React__default.createElement(SvgPlayCircle, props);
};
var PlayFilled = function PlayFilled(props) {
  return /*#__PURE__*/React__default.createElement(SvgPlayFilled, props);
};
var Play = function Play(props) {
  return /*#__PURE__*/React__default.createElement(SvgPlay, props);
};
var Plus = function Plus(props) {
  return /*#__PURE__*/React__default.createElement(SvgPlus, props);
};
var Pocketcasts = function Pocketcasts(props) {
  return /*#__PURE__*/React__default.createElement(SvgPocketcasts, props);
};
var Podcast = function Podcast(props) {
  return /*#__PURE__*/React__default.createElement(SvgPodcast, props);
};
var Podigee = function Podigee(props) {
  return /*#__PURE__*/React__default.createElement(SvgPodigee, props);
};
var Podimo = function Podimo(props) {
  return /*#__PURE__*/React__default.createElement(SvgPodimo, props);
};
var Power = function Power(props) {
  return /*#__PURE__*/React__default.createElement(SvgPower, props);
};
var Printer = function Printer(props) {
  return /*#__PURE__*/React__default.createElement(SvgPrinter, props);
};
var ProximitySearch = function ProximitySearch(props) {
  return /*#__PURE__*/React__default.createElement(SvgProximitySearch, props);
};
var QuestionCircleFilled = function QuestionCircleFilled(props) {
  return /*#__PURE__*/React__default.createElement(SvgQuestionCircleFilled, props);
};
var QuestionCircle = function QuestionCircle(props) {
  return /*#__PURE__*/React__default.createElement(SvgQuestionCircle, props);
};
var Reload = function Reload(props) {
  return /*#__PURE__*/React__default.createElement(SvgReload, props);
};
var ScreenShare = function ScreenShare(props) {
  return /*#__PURE__*/React__default.createElement(SvgScreenShare, props);
};
var Search = function Search(props) {
  return /*#__PURE__*/React__default.createElement(SvgSearch, props);
};
var Settings = function Settings(props) {
  return /*#__PURE__*/React__default.createElement(SvgSettings, props);
};
var Share = function Share(props) {
  return /*#__PURE__*/React__default.createElement(SvgShare, props);
};
var Shrink = function Shrink(props) {
  return /*#__PURE__*/React__default.createElement(SvgShrink, props);
};
var SignLanguage = function SignLanguage(props) {
  return /*#__PURE__*/React__default.createElement(SvgSignLanguage, props);
};
var Sign = function Sign(props) {
  return /*#__PURE__*/React__default.createElement(SvgSign, props);
};
var Sms = function Sms(props) {
  return /*#__PURE__*/React__default.createElement(SvgSms, props);
};
var SocialFacebookCircle = function SocialFacebookCircle(props) {
  return /*#__PURE__*/React__default.createElement(SvgSocialFacebookCircle, props);
};
var SocialFacebook = function SocialFacebook(props) {
  return /*#__PURE__*/React__default.createElement(SvgSocialFacebook, props);
};
var SocialGoogleplus = function SocialGoogleplus(props) {
  return /*#__PURE__*/React__default.createElement(SvgSocialGoogleplus, props);
};
var SocialInstagramCircle = function SocialInstagramCircle(props) {
  return /*#__PURE__*/React__default.createElement(SvgSocialInstagramCircle, props);
};
var SocialInstagram = function SocialInstagram(props) {
  return /*#__PURE__*/React__default.createElement(SvgSocialInstagram, props);
};
var SocialKununuCircle = function SocialKununuCircle(props) {
  return /*#__PURE__*/React__default.createElement(SvgSocialKununuCircle, props);
};
var SocialKununu = function SocialKununu(props) {
  return /*#__PURE__*/React__default.createElement(SvgSocialKununu, props);
};
var SocialLinkedinCircle = function SocialLinkedinCircle(props) {
  return /*#__PURE__*/React__default.createElement(SvgSocialLinkedinCircle, props);
};
var SocialLinkedin = function SocialLinkedin(props) {
  return /*#__PURE__*/React__default.createElement(SvgSocialLinkedin, props);
};
var SocialTiktokCircle = function SocialTiktokCircle(props) {
  return /*#__PURE__*/React__default.createElement(SvgSocialTiktokCircle, props);
};
var SocialTiktok = function SocialTiktok(props) {
  return /*#__PURE__*/React__default.createElement(SvgSocialTiktok, props);
};
var SocialTwitterCircle = function SocialTwitterCircle(props) {
  return /*#__PURE__*/React__default.createElement(SvgSocialTwitterCircle, props);
};
var SocialTwitter = function SocialTwitter(props) {
  return /*#__PURE__*/React__default.createElement(SvgSocialTwitter, props);
};
var SocialWhatsapp = function SocialWhatsapp(props) {
  return /*#__PURE__*/React__default.createElement(SvgSocialWhatsapp, props);
};
var SocialX = function SocialX(props) {
  return /*#__PURE__*/React__default.createElement(SvgSocialX, props);
};
var SocialXingCircle = function SocialXingCircle(props) {
  return /*#__PURE__*/React__default.createElement(SvgSocialXingCircle, props);
};
var SocialXing = function SocialXing(props) {
  return /*#__PURE__*/React__default.createElement(SvgSocialXing, props);
};
var SocialYoutubeCircle = function SocialYoutubeCircle(props) {
  return /*#__PURE__*/React__default.createElement(SvgSocialYoutubeCircle, props);
};
var SocialYoutube = function SocialYoutube(props) {
  return /*#__PURE__*/React__default.createElement(SvgSocialYoutube, props);
};
var Sort = function Sort(props) {
  return /*#__PURE__*/React__default.createElement(SvgSort, props);
};
var Soundcloud = function Soundcloud(props) {
  return /*#__PURE__*/React__default.createElement(SvgSoundcloud, props);
};
var SpeechBubble = function SpeechBubble(props) {
  return /*#__PURE__*/React__default.createElement(SvgSpeechBubble, props);
};
var Spotify = function Spotify(props) {
  return /*#__PURE__*/React__default.createElement(SvgSpotify, props);
};
var SpracheLeicht = function SpracheLeicht(props) {
  return /*#__PURE__*/React__default.createElement(SvgSpracheLeicht, props);
};
var StackTextbig = function StackTextbig(props) {
  return /*#__PURE__*/React__default.createElement(SvgStackTextbig, props);
};
var StarFilled = function StarFilled(props) {
  return /*#__PURE__*/React__default.createElement(SvgStarFilled, props);
};
var StarHalf = function StarHalf(props) {
  return /*#__PURE__*/React__default.createElement(SvgStarHalf, props);
};
var Star = function Star(props) {
  return /*#__PURE__*/React__default.createElement(SvgStar, props);
};
var Subtitle = function Subtitle(props) {
  return /*#__PURE__*/React__default.createElement(SvgSubtitle, props);
};
var Synonym = function Synonym(props) {
  return /*#__PURE__*/React__default.createElement(SvgSynonym, props);
};
var Target = function Target(props) {
  return /*#__PURE__*/React__default.createElement(SvgTarget, props);
};
var TextChatBubble = function TextChatBubble(props) {
  return /*#__PURE__*/React__default.createElement(SvgTextChatBubble, props);
};
var Tiktok = function Tiktok(props) {
  return /*#__PURE__*/React__default.createElement(SvgTiktok, props);
};
var Top = function Top(props) {
  return /*#__PURE__*/React__default.createElement(SvgTop, props);
};
var Train = function Train(props) {
  return /*#__PURE__*/React__default.createElement(SvgTrain, props);
};
var Tunein = function Tunein(props) {
  return /*#__PURE__*/React__default.createElement(SvgTunein, props);
};
var Unlock = function Unlock(props) {
  return /*#__PURE__*/React__default.createElement(SvgUnlock, props);
};
var Upload = function Upload(props) {
  return /*#__PURE__*/React__default.createElement(SvgUpload, props);
};
var UserCheck = function UserCheck(props) {
  return /*#__PURE__*/React__default.createElement(SvgUserCheck, props);
};
var Vegan = function Vegan(props) {
  return /*#__PURE__*/React__default.createElement(SvgVegan, props);
};
var Vegetarian = function Vegetarian(props) {
  return /*#__PURE__*/React__default.createElement(SvgVegetarian, props);
};
var VideoChat = function VideoChat(props) {
  return /*#__PURE__*/React__default.createElement(SvgVideoChat, props);
};
var Video = function Video(props) {
  return /*#__PURE__*/React__default.createElement(SvgVideo, props);
};
var Virus = function Virus(props) {
  return /*#__PURE__*/React__default.createElement(SvgVirus, props);
};
var VolumeDecrease = function VolumeDecrease(props) {
  return /*#__PURE__*/React__default.createElement(SvgVolumeDecrease, props);
};
var VolumeIncrease = function VolumeIncrease(props) {
  return /*#__PURE__*/React__default.createElement(SvgVolumeIncrease, props);
};
var VolumeMedium = function VolumeMedium(props) {
  return /*#__PURE__*/React__default.createElement(SvgVolumeMedium, props);
};
var VolumeMute = function VolumeMute(props) {
  return /*#__PURE__*/React__default.createElement(SvgVolumeMute, props);
};
var Web = function Web(props) {
  return /*#__PURE__*/React__default.createElement(SvgWeb, props);
};
var Youtube = function Youtube(props) {
  return /*#__PURE__*/React__default.createElement(SvgYoutube, props);
};
var ZoomIn = function ZoomIn(props) {
  return /*#__PURE__*/React__default.createElement(SvgZoomIn, props);
};
var ZoomOut = function ZoomOut(props) {
  return /*#__PURE__*/React__default.createElement(SvgZoomOut, props);
};

var _excluded = ["name", "className"];

var Icon = function Icon(_ref) {
  var name = _ref.name,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, _excluded);

  switch (name) {
    case 'address-book':
      return /*#__PURE__*/React__default.createElement(AddressBook, _extends$3m({
        className: className
      }, rest));

    case 'alert-circle-filled':
      return /*#__PURE__*/React__default.createElement(AlertCircleFilled, _extends$3m({
        className: className
      }, rest));

    case 'alert-circle':
      return /*#__PURE__*/React__default.createElement(AlertCircle, _extends$3m({
        className: className
      }, rest));

    case 'amazonmusic':
      return /*#__PURE__*/React__default.createElement(Amazonmusic, _extends$3m({
        className: className
      }, rest));

    case 'applepodcast':
      return /*#__PURE__*/React__default.createElement(Applepodcast, _extends$3m({
        className: className
      }, rest));

    case 'arrow-down':
      return /*#__PURE__*/React__default.createElement(ArrowDown, _extends$3m({
        className: className
      }, rest));

    case 'arrow-left-circle-filled':
      return /*#__PURE__*/React__default.createElement(ArrowLeftCircleFilled, _extends$3m({
        className: className
      }, rest));

    case 'arrow-left-circle':
      return /*#__PURE__*/React__default.createElement(ArrowLeftCircle, _extends$3m({
        className: className
      }, rest));

    case 'arrow-left-reply':
      return /*#__PURE__*/React__default.createElement(ArrowLeftReply, _extends$3m({
        className: className
      }, rest));

    case 'arrow-left':
      return /*#__PURE__*/React__default.createElement(ArrowLeft, _extends$3m({
        className: className
      }, rest));

    case 'arrow-right-circle-filled':
      return /*#__PURE__*/React__default.createElement(ArrowRightCircleFilled, _extends$3m({
        className: className
      }, rest));

    case 'arrow-right-circle':
      return /*#__PURE__*/React__default.createElement(ArrowRightCircle, _extends$3m({
        className: className
      }, rest));

    case 'arrow-right-reply':
      return /*#__PURE__*/React__default.createElement(ArrowRightReply, _extends$3m({
        className: className
      }, rest));

    case 'arrow-right':
      return /*#__PURE__*/React__default.createElement(ArrowRight, _extends$3m({
        className: className
      }, rest));

    case 'arrow-rounded-down':
      return /*#__PURE__*/React__default.createElement(ArrowRoundedDown, _extends$3m({
        className: className
      }, rest));

    case 'arrow-rounded-left':
      return /*#__PURE__*/React__default.createElement(ArrowRoundedLeft, _extends$3m({
        className: className
      }, rest));

    case 'arrow-rounded-leftdown':
      return /*#__PURE__*/React__default.createElement(ArrowRoundedLeftdown, _extends$3m({
        className: className
      }, rest));

    case 'arrow-rounded-leftup':
      return /*#__PURE__*/React__default.createElement(ArrowRoundedLeftup, _extends$3m({
        className: className
      }, rest));

    case 'arrow-rounded-right':
      return /*#__PURE__*/React__default.createElement(ArrowRoundedRight, _extends$3m({
        className: className
      }, rest));

    case 'arrow-rounded-rightdown':
      return /*#__PURE__*/React__default.createElement(ArrowRoundedRightdown, _extends$3m({
        className: className
      }, rest));

    case 'arrow-rounded-rightup':
      return /*#__PURE__*/React__default.createElement(ArrowRoundedRightup, _extends$3m({
        className: className
      }, rest));

    case 'arrow-rounded-up':
      return /*#__PURE__*/React__default.createElement(ArrowRoundedUp, _extends$3m({
        className: className
      }, rest));

    case 'arrow-small-down':
      return /*#__PURE__*/React__default.createElement(ArrowSmallDown, _extends$3m({
        className: className
      }, rest));

    case 'arrow-small-left':
      return /*#__PURE__*/React__default.createElement(ArrowSmallLeft, _extends$3m({
        className: className
      }, rest));

    case 'arrow-small-right':
      return /*#__PURE__*/React__default.createElement(ArrowSmallRight, _extends$3m({
        className: className
      }, rest));

    case 'arrow-small-up':
      return /*#__PURE__*/React__default.createElement(ArrowSmallUp, _extends$3m({
        className: className
      }, rest));

    case 'arrow-up':
      return /*#__PURE__*/React__default.createElement(ArrowUp, _extends$3m({
        className: className
      }, rest));

    case 'attachment':
      return /*#__PURE__*/React__default.createElement(Attachment, _extends$3m({
        className: className
      }, rest));

    case 'audio':
      return /*#__PURE__*/React__default.createElement(Audio, _extends$3m({
        className: className
      }, rest));

    case 'backward':
      return /*#__PURE__*/React__default.createElement(Backward, _extends$3m({
        className: className
      }, rest));

    case 'backwards':
      return /*#__PURE__*/React__default.createElement(Backwards, _extends$3m({
        className: className
      }, rest));

    case 'bank':
      return /*#__PURE__*/React__default.createElement(Bank, _extends$3m({
        className: className
      }, rest));

    case 'become-member':
      return /*#__PURE__*/React__default.createElement(BecomeMember, _extends$3m({
        className: className
      }, rest));

    case 'bell':
      return /*#__PURE__*/React__default.createElement(Bell, _extends$3m({
        className: className
      }, rest));

    case 'blocked':
      return /*#__PURE__*/React__default.createElement(Blocked, _extends$3m({
        className: className
      }, rest));

    case 'bookmark-filled':
      return /*#__PURE__*/React__default.createElement(BookmarkFilled, _extends$3m({
        className: className
      }, rest));

    case 'bookmark':
      return /*#__PURE__*/React__default.createElement(Bookmark, _extends$3m({
        className: className
      }, rest));

    case 'bookmarks-list':
      return /*#__PURE__*/React__default.createElement(BookmarksList, _extends$3m({
        className: className
      }, rest));

    case 'box-mail':
      return /*#__PURE__*/React__default.createElement(BoxMail, _extends$3m({
        className: className
      }, rest));

    case 'brand-android':
      return /*#__PURE__*/React__default.createElement(BrandAndroid, _extends$3m({
        className: className
      }, rest));

    case 'brand-apple':
      return /*#__PURE__*/React__default.createElement(BrandApple, _extends$3m({
        className: className
      }, rest));

    case 'brand-windows':
      return /*#__PURE__*/React__default.createElement(BrandWindows, _extends$3m({
        className: className
      }, rest));

    case 'bubble-lines':
      return /*#__PURE__*/React__default.createElement(BubbleLines, _extends$3m({
        className: className
      }, rest));

    case 'bubble-star':
      return /*#__PURE__*/React__default.createElement(BubbleStar, _extends$3m({
        className: className
      }, rest));

    case 'bubble-video':
      return /*#__PURE__*/React__default.createElement(BubbleVideo, _extends$3m({
        className: className
      }, rest));

    case 'bubbles':
      return /*#__PURE__*/React__default.createElement(Bubbles, _extends$3m({
        className: className
      }, rest));

    case 'calendar-check':
      return /*#__PURE__*/React__default.createElement(CalendarCheck, _extends$3m({
        className: className
      }, rest));

    case 'calendar':
      return /*#__PURE__*/React__default.createElement(Calendar, _extends$3m({
        className: className
      }, rest));

    case 'calories':
      return /*#__PURE__*/React__default.createElement(Calories, _extends$3m({
        className: className
      }, rest));

    case 'camera':
      return /*#__PURE__*/React__default.createElement(Camera, _extends$3m({
        className: className
      }, rest));

    case 'cancel-circle-filled':
      return /*#__PURE__*/React__default.createElement(CancelCircleFilled, _extends$3m({
        className: className
      }, rest));

    case 'cancel-circle':
      return /*#__PURE__*/React__default.createElement(CancelCircle, _extends$3m({
        className: className
      }, rest));

    case 'caret-down':
      return /*#__PURE__*/React__default.createElement(CaretDown, _extends$3m({
        className: className
      }, rest));

    case 'caret-drag':
      return /*#__PURE__*/React__default.createElement(CaretDrag, _extends$3m({
        className: className
      }, rest));

    case 'caret-left':
      return /*#__PURE__*/React__default.createElement(CaretLeft, _extends$3m({
        className: className
      }, rest));

    case 'caret-right':
      return /*#__PURE__*/React__default.createElement(CaretRight, _extends$3m({
        className: className
      }, rest));

    case 'caret-select':
      return /*#__PURE__*/React__default.createElement(CaretSelect, _extends$3m({
        className: className
      }, rest));

    case 'caret-up':
      return /*#__PURE__*/React__default.createElement(CaretUp, _extends$3m({
        className: className
      }, rest));

    case 'chat-bubble':
      return /*#__PURE__*/React__default.createElement(ChatBubble, _extends$3m({
        className: className
      }, rest));

    case 'checkmark-circle-filled':
      return /*#__PURE__*/React__default.createElement(CheckmarkCircleFilled, _extends$3m({
        className: className
      }, rest));

    case 'checkmark-circle':
      return /*#__PURE__*/React__default.createElement(CheckmarkCircle, _extends$3m({
        className: className
      }, rest));

    case 'checkmark':
      return /*#__PURE__*/React__default.createElement(Checkmark, _extends$3m({
        className: className
      }, rest));

    case 'clipboard':
      return /*#__PURE__*/React__default.createElement(Clipboard, _extends$3m({
        className: className
      }, rest));

    case 'clock':
      return /*#__PURE__*/React__default.createElement(Clock, _extends$3m({
        className: className
      }, rest));

    case 'close-small':
      return /*#__PURE__*/React__default.createElement(CloseSmall, _extends$3m({
        className: className
      }, rest));

    case 'close':
      return /*#__PURE__*/React__default.createElement(Close, _extends$3m({
        className: className
      }, rest));

    case 'compare':
      return /*#__PURE__*/React__default.createElement(Compare, _extends$3m({
        className: className
      }, rest));

    case 'copy':
      return /*#__PURE__*/React__default.createElement(Copy, _extends$3m({
        className: className
      }, rest));

    case 'customer-centre':
      return /*#__PURE__*/React__default.createElement(CustomerCentre, _extends$3m({
        className: className
      }, rest));

    case 'deezer':
      return /*#__PURE__*/React__default.createElement(Deezer, _extends$3m({
        className: className
      }, rest));

    case 'delete':
      return /*#__PURE__*/React__default.createElement(Delete, _extends$3m({
        className: className
      }, rest));

    case 'documents':
      return /*#__PURE__*/React__default.createElement(Documents, _extends$3m({
        className: className
      }, rest));

    case 'double-arrow-left-forward':
      return /*#__PURE__*/React__default.createElement(DoubleArrowLeftForward, _extends$3m({
        className: className
      }, rest));

    case 'download-circle-filled':
      return /*#__PURE__*/React__default.createElement(DownloadCircleFilled, _extends$3m({
        className: className
      }, rest));

    case 'download-folder':
      return /*#__PURE__*/React__default.createElement(DownloadFolder, _extends$3m({
        className: className
      }, rest));

    case 'download':
      return /*#__PURE__*/React__default.createElement(Download, _extends$3m({
        className: className
      }, rest));

    case 'easy-language':
      return /*#__PURE__*/React__default.createElement(EasyLanguage, _extends$3m({
        className: className
      }, rest));

    case 'edit':
      return /*#__PURE__*/React__default.createElement(Edit, _extends$3m({
        className: className
      }, rest));

    case 'enlarge':
      return /*#__PURE__*/React__default.createElement(Enlarge, _extends$3m({
        className: className
      }, rest));

    case 'enter-login':
      return /*#__PURE__*/React__default.createElement(EnterLogin, _extends$3m({
        className: className
      }, rest));

    case 'equalizer':
      return /*#__PURE__*/React__default.createElement(Equalizer, _extends$3m({
        className: className
      }, rest));

    case 'exit':
      return /*#__PURE__*/React__default.createElement(Exit, _extends$3m({
        className: className
      }, rest));

    case 'expand-arrow':
      return /*#__PURE__*/React__default.createElement(ExpandArrow, _extends$3m({
        className: className
      }, rest));

    case 'eye-closed':
      return /*#__PURE__*/React__default.createElement(EyeClosed, _extends$3m({
        className: className
      }, rest));

    case 'eye-open':
      return /*#__PURE__*/React__default.createElement(EyeOpen, _extends$3m({
        className: className
      }, rest));

    case 'fax':
      return /*#__PURE__*/React__default.createElement(Fax, _extends$3m({
        className: className
      }, rest));

    case 'file':
      return /*#__PURE__*/React__default.createElement(File, _extends$3m({
        className: className
      }, rest));

    case 'filter':
      return /*#__PURE__*/React__default.createElement(Filter, _extends$3m({
        className: className
      }, rest));

    case 'fish':
      return /*#__PURE__*/React__default.createElement(Fish, _extends$3m({
        className: className
      }, rest));

    case 'flag':
      return /*#__PURE__*/React__default.createElement(Flag, _extends$3m({
        className: className
      }, rest));

    case 'folder':
      return /*#__PURE__*/React__default.createElement(Folder, _extends$3m({
        className: className
      }, rest));

    case 'form':
      return /*#__PURE__*/React__default.createElement(Form, _extends$3m({
        className: className
      }, rest));

    case 'forms':
      return /*#__PURE__*/React__default.createElement(Forms, _extends$3m({
        className: className
      }, rest));

    case 'forward':
      return /*#__PURE__*/React__default.createElement(Forward, _extends$3m({
        className: className
      }, rest));

    case 'globe':
      return /*#__PURE__*/React__default.createElement(Globe, _extends$3m({
        className: className
      }, rest));

    case 'googlepodcast':
      return /*#__PURE__*/React__default.createElement(Googlepodcast, _extends$3m({
        className: className
      }, rest));

    case 'grid':
      return /*#__PURE__*/React__default.createElement(Grid, _extends$3m({
        className: className
      }, rest));

    case 'headphones':
      return /*#__PURE__*/React__default.createElement(Headphones, _extends$3m({
        className: className
      }, rest));

    case 'heart-bubble':
      return /*#__PURE__*/React__default.createElement(HeartBubble, _extends$3m({
        className: className
      }, rest));

    case 'heart-filled':
      return /*#__PURE__*/React__default.createElement(HeartFilled, _extends$3m({
        className: className
      }, rest));

    case 'heart':
      return /*#__PURE__*/React__default.createElement(Heart, _extends$3m({
        className: className
      }, rest));

    case 'home':
      return /*#__PURE__*/React__default.createElement(Home, _extends$3m({
        className: className
      }, rest));

    case 'image':
      return /*#__PURE__*/React__default.createElement(Image, _extends$3m({
        className: className
      }, rest));

    case 'images':
      return /*#__PURE__*/React__default.createElement(Images, _extends$3m({
        className: className
      }, rest));

    case 'info-circle-filled':
      return /*#__PURE__*/React__default.createElement(InfoCircleFilled, _extends$3m({
        className: className
      }, rest));

    case 'info-circle':
      return /*#__PURE__*/React__default.createElement(InfoCircle, _extends$3m({
        className: className
      }, rest));

    case 'keyword':
      return /*#__PURE__*/React__default.createElement(Keyword, _extends$3m({
        className: className
      }, rest));

    case 'language':
      return /*#__PURE__*/React__default.createElement(Language, _extends$3m({
        className: className
      }, rest));

    case 'link':
      return /*#__PURE__*/React__default.createElement(Link, _extends$3m({
        className: className
      }, rest));

    case 'list':
      return /*#__PURE__*/React__default.createElement(List, _extends$3m({
        className: className
      }, rest));

    case 'load':
      return /*#__PURE__*/React__default.createElement(Load, _extends$3m({
        className: className
      }, rest));

    case 'location':
      return /*#__PURE__*/React__default.createElement(Location, _extends$3m({
        className: className
      }, rest));

    case 'lock':
      return /*#__PURE__*/React__default.createElement(Lock, _extends$3m({
        className: className
      }, rest));

    case 'login':
      return /*#__PURE__*/React__default.createElement(Login, _extends$3m({
        className: className
      }, rest));

    case 'mail-open':
      return /*#__PURE__*/React__default.createElement(MailOpen, _extends$3m({
        className: className
      }, rest));

    case 'mail':
      return /*#__PURE__*/React__default.createElement(Mail, _extends$3m({
        className: className
      }, rest));

    case 'mailbox':
      return /*#__PURE__*/React__default.createElement(Mailbox, _extends$3m({
        className: className
      }, rest));

    case 'map':
      return /*#__PURE__*/React__default.createElement(Map, _extends$3m({
        className: className
      }, rest));

    case 'meat':
      return /*#__PURE__*/React__default.createElement(Meat, _extends$3m({
        className: className
      }, rest));

    case 'menu-dots-horizontal':
      return /*#__PURE__*/React__default.createElement(MenuDotsHorizontal, _extends$3m({
        className: className
      }, rest));

    case 'menu-dots-vertical':
      return /*#__PURE__*/React__default.createElement(MenuDotsVertical, _extends$3m({
        className: className
      }, rest));

    case 'menu-mobile':
      return /*#__PURE__*/React__default.createElement(MenuMobile, _extends$3m({
        className: className
      }, rest));

    case 'menu':
      return /*#__PURE__*/React__default.createElement(Menu, _extends$3m({
        className: className
      }, rest));

    case 'mic':
      return /*#__PURE__*/React__default.createElement(Mic, _extends$3m({
        className: className
      }, rest));

    case 'microphone':
      return /*#__PURE__*/React__default.createElement(Microphone, _extends$3m({
        className: className
      }, rest));

    case 'minus':
      return /*#__PURE__*/React__default.createElement(Minus, _extends$3m({
        className: className
      }, rest));

    case 'mobile-phone':
      return /*#__PURE__*/React__default.createElement(MobilePhone, _extends$3m({
        className: className
      }, rest));

    case 'mobile':
      return /*#__PURE__*/React__default.createElement(Mobile, _extends$3m({
        className: className
      }, rest));

    case 'new-tab':
      return /*#__PURE__*/React__default.createElement(NewTab, _extends$3m({
        className: className
      }, rest));

    case 'office':
      return /*#__PURE__*/React__default.createElement(Office, _extends$3m({
        className: className
      }, rest));

    case 'parking':
      return /*#__PURE__*/React__default.createElement(Parking, _extends$3m({
        className: className
      }, rest));

    case 'pastries':
      return /*#__PURE__*/React__default.createElement(Pastries, _extends$3m({
        className: className
      }, rest));

    case 'pause-circle-filled':
      return /*#__PURE__*/React__default.createElement(PauseCircleFilled, _extends$3m({
        className: className
      }, rest));

    case 'pause-circle':
      return /*#__PURE__*/React__default.createElement(PauseCircle, _extends$3m({
        className: className
      }, rest));

    case 'pause':
      return /*#__PURE__*/React__default.createElement(Pause, _extends$3m({
        className: className
      }, rest));

    case 'phone-callback':
      return /*#__PURE__*/React__default.createElement(PhoneCallback, _extends$3m({
        className: className
      }, rest));

    case 'phone':
      return /*#__PURE__*/React__default.createElement(Phone, _extends$3m({
        className: className
      }, rest));

    case 'piggybank':
      return /*#__PURE__*/React__default.createElement(Piggybank, _extends$3m({
        className: className
      }, rest));

    case 'pin':
      return /*#__PURE__*/React__default.createElement(Pin, _extends$3m({
        className: className
      }, rest));

    case 'play-circle-filled':
      return /*#__PURE__*/React__default.createElement(PlayCircleFilled, _extends$3m({
        className: className
      }, rest));

    case 'play-circle':
      return /*#__PURE__*/React__default.createElement(PlayCircle, _extends$3m({
        className: className
      }, rest));

    case 'play-filled':
      return /*#__PURE__*/React__default.createElement(PlayFilled, _extends$3m({
        className: className
      }, rest));

    case 'play':
      return /*#__PURE__*/React__default.createElement(Play, _extends$3m({
        className: className
      }, rest));

    case 'plus':
      return /*#__PURE__*/React__default.createElement(Plus, _extends$3m({
        className: className
      }, rest));

    case 'pocketcasts':
      return /*#__PURE__*/React__default.createElement(Pocketcasts, _extends$3m({
        className: className
      }, rest));

    case 'podcast':
      return /*#__PURE__*/React__default.createElement(Podcast, _extends$3m({
        className: className
      }, rest));

    case 'podigee':
      return /*#__PURE__*/React__default.createElement(Podigee, _extends$3m({
        className: className
      }, rest));

    case 'podimo':
      return /*#__PURE__*/React__default.createElement(Podimo, _extends$3m({
        className: className
      }, rest));

    case 'power':
      return /*#__PURE__*/React__default.createElement(Power, _extends$3m({
        className: className
      }, rest));

    case 'printer':
      return /*#__PURE__*/React__default.createElement(Printer, _extends$3m({
        className: className
      }, rest));

    case 'proximity-search':
      return /*#__PURE__*/React__default.createElement(ProximitySearch, _extends$3m({
        className: className
      }, rest));

    case 'question-circle-filled':
      return /*#__PURE__*/React__default.createElement(QuestionCircleFilled, _extends$3m({
        className: className
      }, rest));

    case 'question-circle':
      return /*#__PURE__*/React__default.createElement(QuestionCircle, _extends$3m({
        className: className
      }, rest));

    case 'reload':
      return /*#__PURE__*/React__default.createElement(Reload, _extends$3m({
        className: className
      }, rest));

    case 'screen-share':
      return /*#__PURE__*/React__default.createElement(ScreenShare, _extends$3m({
        className: className
      }, rest));

    case 'search':
      return /*#__PURE__*/React__default.createElement(Search, _extends$3m({
        className: className
      }, rest));

    case 'settings':
      return /*#__PURE__*/React__default.createElement(Settings, _extends$3m({
        className: className
      }, rest));

    case 'share':
      return /*#__PURE__*/React__default.createElement(Share, _extends$3m({
        className: className
      }, rest));

    case 'shrink':
      return /*#__PURE__*/React__default.createElement(Shrink, _extends$3m({
        className: className
      }, rest));

    case 'sign-language':
      return /*#__PURE__*/React__default.createElement(SignLanguage, _extends$3m({
        className: className
      }, rest));

    case 'sign':
      return /*#__PURE__*/React__default.createElement(Sign, _extends$3m({
        className: className
      }, rest));

    case 'sms':
      return /*#__PURE__*/React__default.createElement(Sms, _extends$3m({
        className: className
      }, rest));

    case 'social-facebook-circle':
      return /*#__PURE__*/React__default.createElement(SocialFacebookCircle, _extends$3m({
        className: className
      }, rest));

    case 'social-facebook':
      return /*#__PURE__*/React__default.createElement(SocialFacebook, _extends$3m({
        className: className
      }, rest));

    case 'social-googleplus':
      return /*#__PURE__*/React__default.createElement(SocialGoogleplus, _extends$3m({
        className: className
      }, rest));

    case 'social-instagram-circle':
      return /*#__PURE__*/React__default.createElement(SocialInstagramCircle, _extends$3m({
        className: className
      }, rest));

    case 'social-instagram':
      return /*#__PURE__*/React__default.createElement(SocialInstagram, _extends$3m({
        className: className
      }, rest));

    case 'social-kununu-circle':
      return /*#__PURE__*/React__default.createElement(SocialKununuCircle, _extends$3m({
        className: className
      }, rest));

    case 'social-kununu':
      return /*#__PURE__*/React__default.createElement(SocialKununu, _extends$3m({
        className: className
      }, rest));

    case 'social-linkedin-circle':
      return /*#__PURE__*/React__default.createElement(SocialLinkedinCircle, _extends$3m({
        className: className
      }, rest));

    case 'social-linkedin':
      return /*#__PURE__*/React__default.createElement(SocialLinkedin, _extends$3m({
        className: className
      }, rest));

    case 'social-tiktok-circle':
      return /*#__PURE__*/React__default.createElement(SocialTiktokCircle, _extends$3m({
        className: className
      }, rest));

    case 'social-tiktok':
      return /*#__PURE__*/React__default.createElement(SocialTiktok, _extends$3m({
        className: className
      }, rest));

    case 'social-whatsapp':
      return /*#__PURE__*/React__default.createElement(SocialWhatsapp, _extends$3m({
        className: className
      }, rest));

    case 'social-twitter-circle':
    case 'social-twitter':
    case 'social-x':
      return /*#__PURE__*/React__default.createElement(SocialX, _extends$3m({
        className: className
      }, rest));

    case 'social-xing-circle':
      return /*#__PURE__*/React__default.createElement(SocialXingCircle, _extends$3m({
        className: className
      }, rest));

    case 'social-xing':
      return /*#__PURE__*/React__default.createElement(SocialXing, _extends$3m({
        className: className
      }, rest));

    case 'social-youtube-circle':
      return /*#__PURE__*/React__default.createElement(SocialYoutubeCircle, _extends$3m({
        className: className
      }, rest));

    case 'social-youtube':
      return /*#__PURE__*/React__default.createElement(SocialYoutube, _extends$3m({
        className: className
      }, rest));

    case 'sort':
      return /*#__PURE__*/React__default.createElement(Sort, _extends$3m({
        className: className
      }, rest));

    case 'soundcloud':
      return /*#__PURE__*/React__default.createElement(Soundcloud, _extends$3m({
        className: className
      }, rest));

    case 'speech-bubble':
      return /*#__PURE__*/React__default.createElement(SpeechBubble, _extends$3m({
        className: className
      }, rest));

    case 'spotify':
      return /*#__PURE__*/React__default.createElement(Spotify, _extends$3m({
        className: className
      }, rest));

    case 'sprache-leicht':
      return /*#__PURE__*/React__default.createElement(SpracheLeicht, _extends$3m({
        className: className
      }, rest));

    case 'stack-textbig':
      return /*#__PURE__*/React__default.createElement(StackTextbig, _extends$3m({
        className: className
      }, rest));

    case 'star-filled':
      return /*#__PURE__*/React__default.createElement(StarFilled, _extends$3m({
        className: className
      }, rest));

    case 'star-half':
      return /*#__PURE__*/React__default.createElement(StarHalf, _extends$3m({
        className: className
      }, rest));

    case 'star':
      return /*#__PURE__*/React__default.createElement(Star, _extends$3m({
        className: className
      }, rest));

    case 'subtitle':
      return /*#__PURE__*/React__default.createElement(Subtitle, _extends$3m({
        className: className
      }, rest));

    case 'synonym':
      return /*#__PURE__*/React__default.createElement(Synonym, _extends$3m({
        className: className
      }, rest));

    case 'target':
      return /*#__PURE__*/React__default.createElement(Target, _extends$3m({
        className: className
      }, rest));

    case 'text-chat-bubble':
      return /*#__PURE__*/React__default.createElement(TextChatBubble, _extends$3m({
        className: className
      }, rest));

    case 'tiktok':
      return /*#__PURE__*/React__default.createElement(Tiktok, _extends$3m({
        className: className
      }, rest));

    case 'top':
      return /*#__PURE__*/React__default.createElement(Top, _extends$3m({
        className: className
      }, rest));

    case 'train':
      return /*#__PURE__*/React__default.createElement(Train, _extends$3m({
        className: className
      }, rest));

    case 'tunein':
      return /*#__PURE__*/React__default.createElement(Tunein, _extends$3m({
        className: className
      }, rest));

    case 'unlock':
      return /*#__PURE__*/React__default.createElement(Unlock, _extends$3m({
        className: className
      }, rest));

    case 'upload':
      return /*#__PURE__*/React__default.createElement(Upload, _extends$3m({
        className: className
      }, rest));

    case 'user-check':
      return /*#__PURE__*/React__default.createElement(UserCheck, _extends$3m({
        className: className
      }, rest));

    case 'vegan':
      return /*#__PURE__*/React__default.createElement(Vegan, _extends$3m({
        className: className
      }, rest));

    case 'vegetarian':
      return /*#__PURE__*/React__default.createElement(Vegetarian, _extends$3m({
        className: className
      }, rest));

    case 'video-chat':
      return /*#__PURE__*/React__default.createElement(VideoChat, _extends$3m({
        className: className
      }, rest));

    case 'video':
      return /*#__PURE__*/React__default.createElement(Video, _extends$3m({
        className: className
      }, rest));

    case 'virus':
      return /*#__PURE__*/React__default.createElement(Virus, _extends$3m({
        className: className
      }, rest));

    case 'volume-decrease':
      return /*#__PURE__*/React__default.createElement(VolumeDecrease, _extends$3m({
        className: className
      }, rest));

    case 'volume-increase':
      return /*#__PURE__*/React__default.createElement(VolumeIncrease, _extends$3m({
        className: className
      }, rest));

    case 'volume-medium':
      return /*#__PURE__*/React__default.createElement(VolumeMedium, _extends$3m({
        className: className
      }, rest));

    case 'volume-mute':
      return /*#__PURE__*/React__default.createElement(VolumeMute, _extends$3m({
        className: className
      }, rest));

    case 'web':
      return /*#__PURE__*/React__default.createElement(Web, _extends$3m({
        className: className
      }, rest));

    case 'youtube':
      return /*#__PURE__*/React__default.createElement(Youtube, _extends$3m({
        className: className
      }, rest));

    case 'zoom-in':
      return /*#__PURE__*/React__default.createElement(ZoomIn, _extends$3m({
        className: className
      }, rest));

    case 'zoom-out':
      return /*#__PURE__*/React__default.createElement(ZoomOut, _extends$3m({
        className: className
      }, rest));

    default:
      return /*#__PURE__*/React__default.createElement(AlertCircleFilled, _extends$3m({
        className: className
      }, rest));
  }
};

Icon.propTypes = {
  name: PropTypes.string,
  // icon filename
  className: PropTypes.string
};
Icon.defaultProps = {
  name: '',
  className: ''
};

export { AddressBook, AlertCircle, AlertCircleFilled, Amazonmusic, Applepodcast, ArrowDown, ArrowLeft, ArrowLeftCircle, ArrowLeftCircleFilled, ArrowLeftReply, ArrowRight, ArrowRightCircle, ArrowRightCircleFilled, ArrowRightReply, ArrowRoundedDown, ArrowRoundedLeft, ArrowRoundedLeftdown, ArrowRoundedLeftup, ArrowRoundedRight, ArrowRoundedRightdown, ArrowRoundedRightup, ArrowRoundedUp, ArrowSmallDown, ArrowSmallLeft, ArrowSmallRight, ArrowSmallUp, ArrowUp, Attachment, Audio, Backward, Backwards, Bank, BecomeMember, Bell, Blocked, Bookmark, BookmarkFilled, BookmarksList, BoxMail, BrandAndroid, BrandApple, BrandWindows, BubbleLines, BubbleStar, BubbleVideo, Bubbles, Calendar, CalendarCheck, Calories, Camera, CancelCircle, CancelCircleFilled, CaretDown, CaretDrag, CaretLeft, CaretRight, CaretSelect, CaretUp, ChatBubble, Checkmark, CheckmarkCircle, CheckmarkCircleFilled, Clipboard, Clock, Close, CloseSmall, Compare, Copy, CustomerCentre, Deezer, Delete, Documents, DoubleArrowLeftForward, Download, DownloadCircleFilled, DownloadFolder, EasyLanguage, Edit, Enlarge, EnterLogin, Equalizer, Exit, ExpandArrow, EyeClosed, EyeOpen, Fax, File, Filter, Fish, Flag, Folder, Form, Forms, Forward, Globe, Googlepodcast, Grid, Headphones, Heart, HeartBubble, HeartFilled, Home, Image, Images, InfoCircle, InfoCircleFilled, Keyword, Language, Link, List, Load, Location, Lock, Login, Mail, MailOpen, Mailbox, Map, Meat, Menu, MenuDotsHorizontal, MenuDotsVertical, MenuMobile, Mic, Microphone, Minus, Mobile, MobilePhone, NewTab, Office, Parking, Pastries, Pause, PauseCircle, PauseCircleFilled, Phone, PhoneCallback, Piggybank, Pin, Play, PlayCircle, PlayCircleFilled, PlayFilled, Plus, Pocketcasts, Podcast, Podigee, Podimo, Power, Printer, ProximitySearch, QuestionCircle, QuestionCircleFilled, Reload, ScreenShare, Search, Settings, Share, Shrink, Sign, SignLanguage, Sms, SocialFacebook, SocialFacebookCircle, SocialGoogleplus, SocialInstagram, SocialInstagramCircle, SocialKununu, SocialKununuCircle, SocialLinkedin, SocialLinkedinCircle, SocialTiktok, SocialTiktokCircle, SocialTwitter, SocialTwitterCircle, SocialWhatsapp, SocialX, SocialXing, SocialXingCircle, SocialYoutube, SocialYoutubeCircle, Sort, Soundcloud, SpeechBubble, Spotify, SpracheLeicht, StackTextbig, Star, StarFilled, StarHalf, Subtitle, Synonym, Target, TextChatBubble, Tiktok, Top, Train, Tunein, Unlock, Upload, UserCheck, Vegan, Vegetarian, Video, VideoChat, Virus, VolumeDecrease, VolumeIncrease, VolumeMedium, VolumeMute, Web, Youtube, ZoomIn, ZoomOut, Icon as default };
